export const formDataSaqAep = [
  // Page - 1 (07)
  {
    _uid: "52a9f451-e869-484a-bbfd-f75d26520e89",
    layout: "form",
    component: "page",
    label: "Merchant Organization Information",
    simplifiedLabel: "Merchant Organization Information",
    caption: "Original Caption",
    simplifiedCaption: "Simplified Caption",
    fields: [
      {
        _uid: "1bd2f544-eab8-4e0d-8440-81361e7f5317",
        component: "text",
        type: "text",
        label: "Company Name",
        simplifiedLabel: "Company Name",
        maxLength: "120",
      },
      {
        _uid: "acda0759-ff18-4c5d-9f02-477c1e5aff03",
        component: "text",
        type: "text",
        label: "Contact Name",
        simplifiedLabel: "Contact Name",
        maxLength: "120",
      },
      {
        _uid: "490377b2-7a98-46f6-8e4e-7f61a4fc5dcf",
        component: "text",
        type: "text",
        label: "Telephone",
        simplifiedLabel: "Telephone",
        maxLength: "120",
      },
      {
        _uid: "83c7a014-8532-47b3-a2f5-844da9771f27",
        component: "text",
        type: "text",
        label: "Business Address",
        simplifiedLabel: "Business Address",
        maxLength: "120",
      },
      {
        _uid: "18bd302a-d186-41d9-86bb-414648f648db",
        component: "text",
        type: "text",
        label: "URL",
        simplifiedLabel: "URL",
        maxLength: "120",
      },
      {
        _uid: "70688d51-a324-4bad-a638-a0e01b4fce2e",
        component: "text",
        type: "text",
        label: "DBA (doing business as)",
        simplifiedLabel: "DBA (doing business as)",
        maxLength: "120",
      },
      {
        _uid: "edf0ecf7-39e0-4277-a35e-813ee9c37e2d",
        component: "text",
        type: "text",
        label: "Title",
        simplifiedLabel: "Title",
        maxLength: "120",
      },
      {
        _uid: "4b3b3e9d-6645-4e65-83f2-c24880071ab1",
        component: "text",
        type: "text",
        label: "E-mail",
        simplifiedLabel: "E-mail",
        maxLength: "120",
      },
      {
        _uid: "8283ed85-ee0a-455f-af2e-f8e393b28adf",
        component: "text",
        type: "text",
        label: "City",
        simplifiedLabel: "City",
        maxLength: "120",
      },
      {
        _uid: "c5790d17-12b6-4e65-9039-9e488c19ac7c",
        component: "text",
        type: "text",
        label: "State/Province",
        simplifiedLabel: "State/Province",
        maxLength: "120",
      },
      {
        _uid: "2f43abd5-ab54-449f-9ffb-d99575d232d6",
        component: "text",
        type: "text",
        label: "Country",
        simplifiedLabel: "Country",
        maxLength: "120",
      },
      {
        _uid: "632c15ee-e12c-4466-aa6a-4f298bebad5d",
        component: "text",
        type: "text",
        label: "Zip",
        simplifiedLabel: "Zip",
        maxLength: "5",
      },
    ],
  },

  // Page - 2 (07)
  {
    _uid: "b6b355a8-8fc3-4d27-9b23-c634001aa429",
    layout: "form",
    component: "page",
    label: "Executive Summary",
    simplifiedLabel: "Executive Summary",
    caption: "Type of Merchant Business (check all that apply)",
    simplifiedCaption: "Type of Merchant Business (check all that apply)",
    fields: [
      {
        _uid: "17e356cd-52c4-41fa-abf5-9fd7f2b87ed0",
        component: "checkbox",
        type: "checkbox",
        label: "Retailer",
        simplifiedLabel: "Retailer",
        value: "Retailer",
      },
      {
        _uid: "3fcb950c-b50e-49ca-a895-08b1f24837b2",
        component: "checkbox",
        type: "checkbox",
        label: "Telecommunication",
        simplifiedLabel: "Telecommunication",
        value: "Telecommunication",
      },
      {
        _uid: "6925e369-0d34-42b5-8718-f3ab917e1e9f",
        component: "checkbox",
        label: "Grocery and Supermarkets",
        simplifiedLabel: "Grocery and Supermarkets",
        type: "checkbox",
        value: "Grocery and Supermarkets",
      },
      {
        _uid: "5e645ba4-8216-42d4-9d11-5c7ab1a62eec",
        component: "checkbox",
        label: "Petroleum",
        simplifiedLabel: "Petroleum",
        type: "checkbox",
        value: "Petroleum",
      },
      {
        _uid: "2c87efdb-5797-436e-91ad-c80d27f93fbf",
        component: "checkbox",
        label: "E-Commerce",
        simplifiedLabel: "E-Commerce",
        type: "checkbox",
        value: "E-Commerce",
      },
      {
        _uid: "4a655d62-e045-4282-b8c9-638c0d06b92d",
        component: "checkbox",
        label: "Mail order/telephone order (MOTO)",
        simplifiedLabel: "Mail order/telephone order (MOTO)",
        type: "checkbox",
        value: "Mail order/telephone order (MOTO)",
      },
      {
        _uid: "797272f7-5e45-4f46-9b48-39f32a20b1e0",
        component: "checkbox",
        label: "Others",
        simplifiedLabel: "Others",
        type: "checkbox",
        value: "Others",
        resetFields: {
          value: "",
          _uids: ["e02edad4-0590-40b5-881d-dc4933ac1337"],
        },
      },
      {
        _uid: "e02edad4-0590-40b5-881d-dc4933ac1337",
        component: "text",
        label: "If Others (please specify):",
        simplifiedLabel: "If Others (please specify):",
        type: "text",
        col: "12",
        conditional: {
          value: "Others",
          field:
            "8681f3c5-4b3f-436a-bb69-0bbd0ce0f391_797272f7-5e45-4f46-9b48-39f32a20b1e0",
        },
        maxLength: "160",
      },
      {
        _uid: "6f7fc404-508b-4803-a095-00f3cae5c871",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        headers: [
          "What types of payment channels does your business serve?",
          "Which payment channels are covered by this SAQ?",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "3d282e4a-6970-4313-a51d-20b0c25ea623",
                component: "col",
                label: "Mail order/telephone order (MOTO)",
                simplifiedLabel: "Mail order/telephone order (MOTO)",
                type: "checkbox",
                value: "Mail order/telephone order (MOTO)",
                col: "12",
              },
              {
                _uid: "9a82ec55-6c9f-464c-ab85-23158a626082",
                component: "col",
                label: "Mail order/telephone order (MOTO)",
                simplifiedLabel: "Mail order/telephone order (MOTO)",
                type: "checkbox",
                value: "Mail order/telephone order (MOTO)",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "db9eb286-268b-43fc-8316-22d834ee4d9b",
                component: "col",
                label: "E-Commerce",
                simplifiedLabel: "E-Commerce",
                type: "checkbox",
                value: "E-Commerce",
                col: "12",
              },
              {
                _uid: "a30c580e-134c-401f-9f33-13f40e05c177",
                component: "col",
                label: "E-Commerce",
                simplifiedLabel: "E-Commerce",
                type: "checkbox",
                value: "E-Commerce",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "63e886d7-4fc8-489b-b250-da30e67fba0d",
                component: "col",
                label: "Card-present (face-to-face)",
                simplifiedLabel: "Card-present (face-to-face)",
                type: "checkbox",
                value: "Card-present (face-to-face)",
                col: "12",
              },
              {
                _uid: "c92812a8-4b21-440d-bd3f-0ee856ef1142",
                component: "col",
                label: "Card-present (face-to-face)",
                simplifiedLabel: "Card-present (face-to-face)",
                type: "checkbox",
                value: "Card-present (face-to-face)",
                col: "12",
              },
            ],
          },
        ],
      },
      {
        _uid: "b2e2ee3a-b3ec-4f70-8ab2-f21baffa3c84",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Description of Payment Card Business",
        fields: [
          {
            _uid: "baf434c8-4269-418b-8ef5-5c864b593ed7",
            component: "row",
            label:
              "How and in what capacity does your business store, process and/or transmit cardholder data?",
            simplifiedLabel:
              "How and in what capacity does your business store, process and/or transmit cardholder data?",
            type: "text",
            col: "12",
            doNotDisplayLabel: "yes",
            maxLength: "56",
          },
        ],
      },
      {
        _uid: "9f12c26d-b73f-41b3-9367-969fdbd2c3b5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Locations",
        description:
          "List types of facilities (for example, retail outlets, corporate offices, data centers, call centers, etc.) and a summary of locations included in the PCI DSS review.",
        headers: [
          "Type of facility",
          "Number of facilities of this type",
          "Location(s) of facility (city, country)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "4cfd9046-a2e4-4776-b1fc-87d12ca5cdc9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "fde10f60-03e3-443e-8bf2-0d0675ea7974",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "661d5167-d651-494d-966e-769e09131c98",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2204c3be-9ad0-45a7-a868-4648b6bc6d90",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "83d30aa5-c4cf-4257-8727-20a88c14b48a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "c8f85661-8ef7-45f5-b706-c6bb6581ffc7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "744bc602-dd56-40af-9e41-4f5f6c473041",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "99ee4fca-1247-4f22-8d2a-8ddb7700c8e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "388fdd5f-fcea-4f84-b486-222ce0b19b1e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e9e41a83-1584-483d-bf1f-07c8aa356fcf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "ca55cc32-b82f-43cf-8ab4-8af9df327227",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "5a69b6d5-6b95-4bad-a8b8-7fab86faa4ac",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4051b8fc-f3b1-4e3d-8c45-bd31e96f45d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "64187053-83a9-42bc-9d5d-e19c3ee5acd1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "6959c754-1948-495b-bd0f-44a470734749",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e7772725-98ad-46a9-a018-913c50f68806",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "60",
              },
              {
                _uid: "0caf6890-3abd-4f9f-af49-f06742c48361",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "c9dafabe-e1f8-4c3a-8971-06bfdb168395",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 3 (08)
  {
    _uid: "049f8abc-9b17-4a7b-be93-0f8500a924ef",
    layout: "form",
    component: "page",
    label: "Executive Summary (continued)",
    simplifiedLabel: "Executive Summary (continued)",
    fields: [
      {
        _uid: "ecaa1026-51a9-4353-ba39-49cd57fe21cc",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Payment Applications",
        fields: [
          {
            _uid: "56d7cefc-9161-46f3-b6b6-9af7188ee52e",
            component: "row",
            label:
              "Does the organization use one or more Payment Applications?",
            simplifiedLabel:
              "Does the organization use one or more Payment Applications?",
            type: "radio",
            options: [
              {
                component: "option",
                label: "Yes",
                simplifiedLabel: "Yes",
                value: "yes",
              },
              {
                component: "option",
                label: "No",
                simplifiedLabel: "No",
                value: "no",
              },
            ],
            col: "12",
            doNotDisplayLabel: "yes",
            resetFields: {
              value: "no",
              _uids: [
                "ffeb9627-9b0f-417b-95ad-ae067ed4ff4c",
                "54723d73-4fc7-48c3-8380-915a0d48d648",
                "ef730c04-a401-4b96-87e2-48c8bf5c3c32",
                "4b577ed8-0f59-49ab-baef-aa49924c70a4",
                "c0284ca9-8761-4370-9704-08e5aaed08f0",
                "5ba5d951-dfcc-4afb-8574-02288f9da29f",
                "5beec6bb-358e-4974-b010-0d5d604a30de",
                "8d121b89-4484-4f31-8711-84d4befc111d",
                "b161a42c-2649-415e-a49a-4484fd08ae86",
                "948c947d-b3b3-4c5b-8ad3-8edbbc055ad9",
                "ab9859f2-5bfa-45c5-8381-ea4f2a193d8f",
                "8d14718c-538a-4130-bf44-15729d64b7a9",
                "7e251bb8-c9c3-42dc-bb5a-56a94a65d043",
                "f492f13a-ff67-4666-b5b4-882621632fe5",
                "2b55b47f-65fd-42a1-9f44-a8cd9b0fa074",
                "503192b9-0d6a-4ac6-a001-11a2bfcc6e7c",
                "3302bf89-56b0-4fd8-a329-2c48fcf3f9c3",
                "eff80b0d-de05-4f91-9dd9-0a086c93a602",
                "15aaf844-3650-40b6-8d0c-32859b892aa0",
                "9bb0d8f2-5d7a-4ff4-8421-cab70e937b6b",
                "3776585c-adf3-4573-82d2-ff94ec7bc170",
                "22bbe8d8-b5ec-4ccd-a05a-db0d5ca0cdbb",
                "5c1129ed-1848-4009-bedf-43d747391891",
                "05e398ea-8fe7-442b-96f5-e609255585a9",
                "b1e47016-d686-4a5e-a2b8-a23bb3bbaa4f",
              ],
            },
          },
        ],
      },
      {
        _uid: "56374fed-572e-4b44-abfe-171c1f75e411",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        conditional: {
          value: "yes",
          field:
            "1b6ac1fd-9b93-4a32-aea5-88bb83c977e1_56d7cefc-9161-46f3-b6b6-9af7188ee52e",
        },
        description:
          "Provide the following information regarding the Payment Applications your organization uses:",
        headers: [
          "Payment Application Name",
          "Version Number",
          "Application Vendor",
          "Is application PA-DSS Listed?",
          "PA-DSS Listing Expiry date (if applicable)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "ffeb9627-9b0f-417b-95ad-ae067ed4ff4c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "18",
              },
              {
                _uid: "54723d73-4fc7-48c3-8380-915a0d48d648",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "ef730c04-a401-4b96-87e2-48c8bf5c3c32",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "100",
              },
              {
                _uid: "4b577ed8-0f59-49ab-baef-aa49924c70a4",
                component: "radio",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
              },
              {
                _uid: "c0284ca9-8761-4370-9704-08e5aaed08f0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "16",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5ba5d951-dfcc-4afb-8574-02288f9da29f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "18",
              },
              {
                _uid: "5beec6bb-358e-4974-b010-0d5d604a30de",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "8d121b89-4484-4f31-8711-84d4befc111d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "b161a42c-2649-415e-a49a-4484fd08ae86",
                component: "radio",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
              },
              {
                _uid: "948c947d-b3b3-4c5b-8ad3-8edbbc055ad9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "16",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ab9859f2-5bfa-45c5-8381-ea4f2a193d8f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "18",
              },
              {
                _uid: "8d14718c-538a-4130-bf44-15729d64b7a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "7e251bb8-c9c3-42dc-bb5a-56a94a65d043",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "f492f13a-ff67-4666-b5b4-882621632fe5",
                component: "radio",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
              },
              {
                _uid: "2b55b47f-65fd-42a1-9f44-a8cd9b0fa074",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "16",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "503192b9-0d6a-4ac6-a001-11a2bfcc6e7c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "18",
              },
              {
                _uid: "3302bf89-56b0-4fd8-a329-2c48fcf3f9c3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "eff80b0d-de05-4f91-9dd9-0a086c93a602",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "15aaf844-3650-40b6-8d0c-32859b892aa0",
                component: "radio",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
              },
              {
                _uid: "9bb0d8f2-5d7a-4ff4-8421-cab70e937b6b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "16",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3776585c-adf3-4573-82d2-ff94ec7bc170",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "18",
              },
              {
                _uid: "22bbe8d8-b5ec-4ccd-a05a-db0d5ca0cdbb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "5c1129ed-1848-4009-bedf-43d747391891",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "4",
              },
              {
                _uid: "05e398ea-8fe7-442b-96f5-e609255585a9",
                component: "radio",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
              },
              {
                _uid: "b1e47016-d686-4a5e-a2b8-a23bb3bbaa4f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "16",
              },
            ],
          },
        ],
      },
      {
        _uid: "e2f5e8f7-1885-4b8c-930b-0615b9d298b9",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Description of Environment",
        fields: [
          {
            _uid: "b1d6d3a4-53b9-4c2d-830d-427d45dc1cb4",
            component: "row",
            label:
              "Provide a high-level description of the environment covered by this assessment.",
            simplifiedLabel:
              "Provide a high-level description of the environment covered by this assessment.",
            type: "textarea",
            textareaRows: "12",
            description: [
              "Connections into and out of the cardholder data",
              "Critical system components within the CDE, such as POS devices, databases, web servers, etc., and any other necessary payment components, as applicable.",
            ],
            col: "12",
            doNotDisplayLabel: "yes",
            maxLength: "375",
          },
        ],
      },
      {
        _uid: "5ad3d427-b672-4590-9bb0-ce5a6552d4c3",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        fields: [
          {
            _uid: "1187ae0d-da73-4c64-90ad-9f342fc3f405",
            component: "row",
            label:
              "Does your business use network segmentation to affect the scope of your PCI DSS environment?",
            simplifiedLabel:
              "Does your business use network segmentation to affect the scope of your PCI DSS environment?",
            type: "radio",
            options: [
              {
                component: "option",
                label: "Yes",
                simplifiedLabel: "Yes",
                value: "yes",
              },
              {
                component: "option",
                label: "No",
                simplifiedLabel: "No",
                value: "no",
              },
            ],
            col: "12",
            doNotDisplayLabel: "yes",
          },
        ],
      },
    ],
  },

  // Page - 4 (09)
  {
    _uid: "4f025dea-1a99-484b-b7dc-0748fd8fd852",
    layout: "form",
    component: "page",
    label: "Executive Summary (continued)",
    simplifiedLabel: "Executive Summary (continued)",
    caption: "Third-Party Service Providers",
    fields: [
      {
        _uid: "449afd84-d075-4a2a-baa4-1d798283363b",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        fields: [
          {
            _uid: "253e40fc-f93e-4a02-a598-1b4d58eb5bad",
            component: "row",
            label:
              "Does your company use a Qualified Integrator & Reseller (QIR)? ",
            simplifiedLabel:
              "Does your company use a Qualified Integrator & Reseller (QIR)? ",
            type: "radio",
            options: [
              {
                component: "option",
                label: "Yes",
                simplifiedLabel: "Yes",
                value: "yes",
              },
              {
                component: "option",
                label: "No",
                simplifiedLabel: "No",
                value: "no",
              },
            ],
            col: "12",
            doNotDisplayLabel: "yes",
            resetFields: {
              value: "yes",
              _uids: [
                "56d7cefc-9161-46f3-b6b6-9af7188ee52e",
                "4d52f757-f06f-4294-923e-3694bcc91d24",
                "026fc4b6-ace6-48fe-bc91-685282f99b44",
                "e5f50d99-900d-41eb-b01d-9eacbd84112b",
              ],
            },
          },
        ],
      },
      {
        _uid: "adbdfcd9-3dcf-4179-9d68-284749457dab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        conditional: {
          value: "yes",
          field:
            "46b40a86-a80b-4303-91fa-680ddfc27f25_253e40fc-f93e-4a02-a598-1b4d58eb5bad",
        },
        caption: "( If yes )",
        fields: [
          {
            _uid: "56d7cefc-9161-46f3-b6b6-9af7188ee52e",
            component: "row",
            label: "Name of QIR Company:",
            simplifiedLabel: "Name of QIR Company:",
            type: "text",
            col: "12",
            doNotDisplayLabel: "yes",
            maxLength: "60",
          },
          {
            _uid: "4d52f757-f06f-4294-923e-3694bcc91d24",
            component: "row",
            label: "QIR Individual Name:",
            simplifiedLabel: "QIR Individual Name:",
            type: "text",
            col: "12",
            doNotDisplayLabel: "yes",
            maxLength: "60",
          },
          {
            _uid: "026fc4b6-ace6-48fe-bc91-685282f99b44",
            component: "row",
            label: "Description of services provided by QIR:",
            simplifiedLabel: "Description of services provided by QIR:",
            type: "text",
            col: "12",
            doNotDisplayLabel: "yes",
            maxLength: "60",
          },
          {
            _uid: "e5f50d99-900d-41eb-b01d-9eacbd84112b",
            component: "row",
            label:
              "Does your company share cardholder data with any third-party service providers (for example, Qualified Integrator & Resellers (QIR), gateways, payment processors, payment service providers (PSP), web-hosting companies, airline booking agents, loyalty program agents, etc.)?",
            simplifiedLabel:
              "Does your company share cardholder data with any third-party service providers (for example, Qualified Integrator & Resellers (QIR), gateways, payment processors, payment service providers (PSP), web-hosting companies, airline booking agents, loyalty program agents, etc.)?",
            type: "radio",
            options: [
              {
                component: "option",
                label: "Yes",
                simplifiedLabel: "Yes",
                value: "yes",
              },
              {
                component: "option",
                label: "No",
                simplifiedLabel: "No",
                value: "no",
              },
            ],
            resetFields: {
              value: "no",
              _uids: [
                "5d10ac7a-a2b3-4165-bdfa-048729771620",
                "304721b1-791f-4871-bc11-8ce06f130fcd",
                "fe1908db-cf2c-47d0-9235-f2008caf00b6",
                "f53360b0-8d3d-4478-832f-84a7e81819aa",
                "10746b1d-7922-40f8-9476-1855c915ec46",
                "86c34787-d0ce-432c-93b3-fff9583c26f6",
                "9c978260-103f-4138-bc86-89ab3736b0f6",
                "d908dbb3-0a36-486c-a37d-44c1d005bd5e",
                "2b6b1931-341d-4d6d-9130-060fba8a2536",
                "955fff7b-df98-48cc-9ec7-8708ea2ead9c",
                "7715a1e9-8f41-4c85-9398-e63f5edc6360",
                "3524b4e5-ea70-4765-9faa-721e97597b67",
              ],
            },
          },
        ],
      },
      {
        _uid: "3d90f670-9139-4e95-947a-f1620fc50743",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        conditional: {
          value: "yes",
          field:
            "4bd9d170-41fc-4f23-93f4-907edf87e043_253e40fc-f93e-4a02-a598-1b4d58eb5bad",
        },
        caption: "( If yes )",
        headers: [
          "Name of service provider",
          "Description of services provided",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "5d10ac7a-a2b3-4165-bdfa-048729771620",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "304721b1-791f-4871-bc11-8ce06f130fcd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fe1908db-cf2c-47d0-9235-f2008caf00b6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "f53360b0-8d3d-4478-832f-84a7e81819aa",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10746b1d-7922-40f8-9476-1855c915ec46",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "86c34787-d0ce-432c-93b3-fff9583c26f6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9c978260-103f-4138-bc86-89ab3736b0f6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "d908dbb3-0a36-486c-a37d-44c1d005bd5e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2b6b1931-341d-4d6d-9130-060fba8a2536",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "955fff7b-df98-48cc-9ec7-8708ea2ead9c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7715a1e9-8f41-4c85-9398-e63f5edc6360",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "32",
              },
              {
                _uid: "3524b4e5-ea70-4765-9faa-721e97597b67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                maxLength: "80",
              },
            ],
          },
        ],
      },
      {
        _uid: "a519e214-05ed-4b7d-ac4c-8da1ce3c78eb",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Eligibility to Complete SAQ A-EP",
        description:
          "Merchant certifies eligibility to complete this shortened version of the Self-Assessment Questionnaire because, for this payment channel:",
        fields: [
          {
            fields: [
              {
                _uid: "a7e15902-a01e-42ee-8e13-5c51dfffdaa6",
                component: "col",
                label: "Merchant accepts only e-commerce transactions;",
                simplifiedLabel:
                  "Merchant accepts only e-commerce transactions;",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24235f12-76a9-419e-80fe-06607d481cb9",
                component: "col",
                label:
                  "All processing of cardholder data, with the exception of the payment page, is entirely outsourced to a PCI DSS validated third-party payment processor;",
                simplifiedLabel:
                  "All processing of cardholder data, with the exception of the payment page, is entirely outsourced to a PCI DSS validated third-party payment processor;",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e9b84b46-c0a2-47e7-a211-3f24bb87861d",
                component: "col",
                label:
                  "Merchant’s e-commerce website does not receive cardholder data but controls how consumers, or their cardholder data, are redirected to a PCI DSS validated third-party payment processor;",
                simplifiedLabel:
                  "Merchant’s e-commerce website does not receive cardholder data but controls how consumers, or their cardholder data, are redirected to a PCI DSS validated third-party payment processor;",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cd26bf64-29f9-47c1-a406-91e56baeb4fd",
                component: "col",
                label:
                  "If merchant website is hosted by a third-party provider, the provider is validated to all applicable PCI DSS requirements (e.g., including PCI DSS Appendix A if the provider is a shared hosting provider);",
                simplifiedLabel:
                  "If merchant website is hosted by a third-party provider, the provider is validated to all applicable PCI DSS requirements (e.g., including PCI DSS Appendix A if the provider is a shared hosting provider);",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "53abe223-2309-45ba-aa6d-f87f09beec65",
                component: "col",
                label:
                  "Each element of the payment page(s) delivered to the consumer’s browser originates from either the merchant’s website or a PCI DSS compliant service provider(s);",
                simplifiedLabel:
                  "Each element of the payment page(s) delivered to the consumer’s browser originates from either the merchant’s website or a PCI DSS compliant service provider(s);",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1a29cfc4-4d19-4ead-95a6-3ba549df7aff",
                component: "col",
                label: [
                  "Each element of the payment page(s) delivered to the consumer’s browser originates from either the merchant’s website or a PCI DSS compliant service provider(s);",
                ],
                simplifiedLabel: [
                  "Each element of the payment page(s) delivered to the consumer’s browser originates from either the merchant’s website or a PCI DSS compliant service provider(s);",
                ],
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
                hasLi: "no",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23868de5-54bd-4c4a-930b-f03c15c293dd",
                component: "col",
                label: [
                  "Merchant has confirmed that all third party(s) handling storage, processing, and/or transmission of cardholder data are PCI DSS compliant; and",
                ],
                simplifiedLabel: [
                  "Merchant has confirmed that all third party(s) handling storage, processing, and/or transmission of cardholder data are PCI DSS compliant; and",
                ],
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
                hasLi: "no",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "36455fae-9a08-41f0-8f64-2d569001297a",
                component: "col",
                label: [
                  "Any cardholder data the merchant retains is on paper (for example, printed reports or receipts), and these documents are not received electronically.",
                ],
                simplifiedLabel: [
                  "Any cardholder data the merchant retains is on paper (for example, printed reports or receipts), and these documents are not received electronically.",
                ],
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "100%",
                col: "12",
                colSpan: 2,
                hasLi: "no",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 5 (10)
  {
    _uid: "48ad7e07-f45d-4eb0-8c0d-16bd0100b064",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    fields: [
      {
        _uid: "c5c5f202-761e-452e-9979-68bab1fdfcfe",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        headers: [
          "PCI DSS Question",
          "Expected Testing",
          "Response (Check one response for each question)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "67d6b9b7-ee70-4aa7-8852-faddff2e9272",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "65%",
                colSpan: 3,
              },
              {
                _uid: "c6a3ca0d-5354-46f8-a3db-6fc65ba381ec",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "select",
                options: [
                  {
                    value: "yes",
                    label: "Yes",
                  },
                  {
                    value: "yesWithCcw",
                    label: "Yes With Ccw",
                  },
                  {
                    value: "no",
                    label: "No",
                  },
                  {
                    value: "na",
                    label: "N/A",
                  },
                ],
                col: "12",
                width: "35%",
                colSpan: 3,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f5b7ac66-82dc-4086-912f-d38e7c871740",
                component: "col",
                label: [
                  "Note: The following questions are numbered according to PCI DSS requirements and testing procedures, as defined in the PCI DSS Requirements and Security Assessment Procedures document.",
                  "Build and Maintain a Secure Network",
                  "Requirement 1: Install and maintain a firewall configuration to protect data",
                ],
                simplifiedLabel: [
                  "Note: The following questions are numbered according to PCI DSS requirements and testing procedures, as defined in the PCI DSS Requirements and Security Assessment Procedures document.",
                  "Build and Maintain a Secure Network",
                  "Requirement 1: Install and maintain a firewall configuration to protect data",
                ],
                type: "",
                col: "12",
                colSpan: "5",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "631242d6-0607-47b0-91a5-f425e0e7bc8f",
                component: "col",
                label: "1.1",
                simplifiedLabel: "1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "bd58a05d-ea25-47cb-8738-861f0ade3c0b",
                component: "col",
                label:
                  "Are firewall and router configuration standards established and implemented to include the following:",
                simplifiedLabel:
                  "Are firewall and router configuration standards established and implemented to include the following:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c423eeda-0f24-4113-949f-aa940cdf8481",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "25520d71-d62e-4f31-b3ce-0f6817981bc8",
                component: "col",
                label: "1.1.1",
                simplifiedLabel: "1.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6fd64fb0-130e-4bbf-a7bc-5ac6d06b48b7",
                component: "col",
                label:
                  "Is there a formal process for approving and testing all network connections and changes to the firewall and router configurations?",
                simplifiedLabel:
                  "Is there a formal process for approving and testing all network connections and changes to the firewall and router configurations?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "11f8920a-d047-4c4e-8b49-9c6ba52b70a8",
                component: "col",
                label: [
                  "Review documented process.",
                  "Interview personnel.",
                  "Examine network configurations.",
                ],
                simplifiedLabel: [
                  "Review documented process.",
                  "Interview personnel.",
                  "Examine network configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "13813ed6-0e65-4e94-932d-b82189733aff",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1cee8739-7a09-4f2e-8a77-60f876876804"],
                },
              },
              {
                _uid: "1cee8739-7a09-4f2e-8a77-60f876876804",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4269b281-fbb4-46f8-844c-b51b75000ea1_13813ed6-0e65-4e94-932d-b82189733aff",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5c864748-aac9-4729-8235-92883d34e7bc",
                component: "col",
                label: "1.1.2 (a)",
                simplifiedLabel: "1.1.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4c32db18-b907-4de7-95fe-bed1baa9f2ce",
                component: "col",
                label:
                  "Is there a current network diagram that documents all connections between the cardholder data environment and other networks, including any wireless networks?",
                simplifiedLabel:
                  "Is there a current network diagram that documents all connections between the cardholder data environment and other networks, including any wireless networks?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9a144a59-fc50-4eb7-b91d-8f48cb0c0e9f",
                component: "col",
                label: [
                  "Review current network diagram.",
                  "Examine network configurations.",
                ],
                simplifiedLabel: [
                  "Review current network diagram.",
                  "Examine network configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7c34e894-f4d1-4c76-942c-1222c70cfa12",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["dae388c9-9ac5-4049-a2b2-71da15e6e7fc"],
                },
              },
              {
                _uid: "dae388c9-9ac5-4049-a2b2-71da15e6e7fc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7265eecd-ac15-475b-b6bd-857d696bdca9_7c34e894-f4d1-4c76-942c-1222c70cfa12",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b8c2c617-b64d-454d-be22-c290ce5ba45e",
                component: "col",
                label: "1.1.2 (b)",
                simplifiedLabel: "1.1.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c8b771f2-4115-429d-8dc1-3ec8a055c99b",
                component: "col",
                label:
                  "Is there a process to ensure the diagram is kept current?",
                simplifiedLabel:
                  "Is there a process to ensure the diagram is kept current?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "623e4732-c0e2-41dc-9d12-5d549606bfaf",
                component: "col",
                label: ["Interview responsible personnel."],
                simplifiedLabel: ["Interview responsible personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2ce41a1f-bd1f-467e-8477-f610a48836c4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["5e069567-58b6-4a77-932a-4b8d85b468a4"],
                },
              },
              {
                _uid: "5e069567-58b6-4a77-932a-4b8d85b468a4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "99816e09-b108-4417-8e83-bfe42e9b9609_2ce41a1f-bd1f-467e-8477-f610a48836c4",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "17b2403b-2e37-4665-ac67-e72357673fc9",
                component: "col",
                label: "1.1.3 (a)",
                simplifiedLabel: "1.1.3 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "db708962-5ec4-406d-96b6-325fdb3f8a07",
                component: "col",
                label:
                  "Is there a current diagram that shows all cardholder data flows across systems and networks?",
                simplifiedLabel:
                  "Is there a current diagram that shows all cardholder data flows across systems and networks?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "56460391-fec1-419f-a385-13d7bdd09e56",
                component: "col",
                label: [
                  "Review current network diagram.",
                  "Examine network configurations.",
                ],
                simplifiedLabel: [
                  "Review current network diagram.",
                  "Examine network configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e1c342f9-bfef-4ffc-a91d-3679ac09c630",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8bad9ca2-2770-4bbd-b127-60e8e297594b"],
                },
              },
              {
                _uid: "8bad9ca2-2770-4bbd-b127-60e8e297594b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fff95d88-4b8e-4778-9deb-7bc1dac71a5a_e1c342f9-bfef-4ffc-a91d-3679ac09c630",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "22bc65d9-e21a-4ff0-a080-60390b9dccf5",
                component: "col",
                label: "1.1.3 (b)",
                simplifiedLabel: "1.1.3 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fdf78dcf-6aba-474d-85f2-758f73c71afd",
                component: "col",
                label:
                  "Is there a process to ensure the diagram is kept current?",
                simplifiedLabel:
                  "Is there a process to ensure the diagram is kept current?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dd432404-3c97-4371-bbd3-978a76c65887",
                component: "col",
                label: ["Interview personnel."],
                simplifiedLabel: ["Interview personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "03ed5ec1-dc39-4e40-bc27-487670d9528e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4dd822b3-7b5b-4f3a-a4b1-de691ef367bc"],
                },
              },
              {
                _uid: "4dd822b3-7b5b-4f3a-a4b1-de691ef367bc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6d6c2c14-051b-4c4b-8abd-08555148582c_03ed5ec1-dc39-4e40-bc27-487670d9528e",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6abb8b2a-967c-4284-a259-5fea2d141362",
                component: "col",
                label: "1.1.4 (a)",
                simplifiedLabel: "1.1.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "be9fd866-6686-49eb-9762-859b45b04874",
                component: "col",
                label:
                  "Is a firewall required and implemented at each Internet connection and between any demilitarized zone (DMZ) and the internal network zone?",
                simplifiedLabel:
                  "Is a firewall required and implemented at each Internet connection and between any demilitarized zone (DMZ) and the internal network zone?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7bbbda9b-2ee6-4e6b-9372-fb781607076e",
                component: "col",
                label: [
                  "Review firewall configuration standards.",
                  "Observe network configurationsto verify that a firewall(s)is in place.",
                ],
                simplifiedLabel: [
                  "Review firewall configuration standards.",
                  "Observe network configurationsto verify that a firewall(s)is in place.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8ec8136f-b585-435e-9d04-1c87c8f9dc65",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1918edf9-a5ea-4d22-9508-b5ac75f353a9"],
                },
              },
              {
                _uid: "1918edf9-a5ea-4d22-9508-b5ac75f353a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fe4b32f2-b554-4c18-bc6b-ccf5319c201d_8ec8136f-b585-435e-9d04-1c87c8f9dc65",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "11e5a5ed-2eb9-49db-ba3e-e29df1844d53",
                component: "col",
                label: "1.1.4 (b)",
                simplifiedLabel: "1.1.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "23868de5-54bd-4c4a-930b-f03c15c293dd",
                component: "col",
                label:
                  "Is the current network diagram consistent with the firewall configuration standards?",
                simplifiedLabel:
                  "Is the current network diagram consistent with the firewall configuration standards?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "36455fae-9a08-41f0-8f64-2d569001297a",
                component: "col",
                label: [
                  "Compare firewall configuration standards to current network diagram.",
                ],
                simplifiedLabel: [
                  "Compare firewall configuration standards to current network diagram.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bb323bd8-e590-482a-8061-cd94777f4bb0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a55f8806-b48a-471b-bd30-891922eb0808"],
                },
              },
              {
                _uid: "a55f8806-b48a-471b-bd30-891922eb0808",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "995583b9-2a0b-45e4-9008-097980584bf2_bb323bd8-e590-482a-8061-cd94777f4bb0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "046b36d0-51c1-4623-9a86-c65caf48080c",
                component: "col",
                label: "1.1.6 (a)",
                simplifiedLabel: "1.1.6 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9b49ce5f-cd92-4bd2-878a-ee02378e84b0",
                component: "col",
                label:
                  "Do firewall and router configuration standards include a documented list of services, protocols, and ports, including business justificationand approval for each?",
                simplifiedLabel:
                  "Do firewall and router configuration standards include a documented list of services, protocols, and ports, including business justificationand approval for each?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c2a71b51-c52f-47dc-a504-9f974bea33ce",
                component: "col",
                label: ["Review firewall and router configuration standards."],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6b00ed97-4a76-452d-99db-0c5f930dc8c8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c8bfee3e-7480-4d1c-9abf-edd5c2223f65"],
                },
              },
              {
                _uid: "c8bfee3e-7480-4d1c-9abf-edd5c2223f65",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "cd822dd7-902c-4acd-84b5-d1182e4f041d_6b00ed97-4a76-452d-99db-0c5f930dc8c8",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6b922a6c-01cc-495d-81e0-eb9b40594f33",
                component: "col",
                label: "1.1.6 (b)",
                simplifiedLabel: "1.1.6 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "50ac8db5-1b71-49dc-b3c8-99ee6147a881",
                component: "col",
                label:
                  "Are all insecure services, protocols, and ports identified, and are security features documented and implemented for each identified service?",
                simplifiedLabel:
                  "Are all insecure services, protocols, and ports identified, and are security features documented and implemented for each identified service?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7f2d497b-b91d-4467-832c-4cb009f94ac9",
                component: "col",
                label: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "49855e97-3f99-4a08-ad3e-ee01c3cf53dc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c07cab2e-27d6-4390-bbaf-5739d6ef5dfa"],
                },
              },
              {
                _uid: "c07cab2e-27d6-4390-bbaf-5739d6ef5dfa",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d8aab5a4-2e3f-4d40-8d07-dc876e26f4ab_49855e97-3f99-4a08-ad3e-ee01c3cf53dc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2df841df-97c9-49b1-b685-c1c223ca989d",
                component: "col",
                label: "1.1.7 (a)",
                simplifiedLabel: "1.1.7 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "98f3dd33-6086-4e4b-aa69-6f38f1a28404",
                component: "col",
                label:
                  "Do firewall and router configuration standards require review of firewall and router rule sets at least every six months?",
                simplifiedLabel:
                  "Do firewall and router configuration standards require review of firewall and router rule sets at least every six months?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a00b1c04-ce92-445b-bb49-73b29522c934",
                component: "col",
                label: ["Review firewall and router configuration standards."],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7440713c-a1d3-449e-abe5-03d50ac895c9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["10d42189-185c-4dad-8cd3-b63ffd26f67f"],
                },
              },
              {
                _uid: "10d42189-185c-4dad-8cd3-b63ffd26f67f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "e6336dae-b2cb-455c-ab52-f7b341fbd4fb_7440713c-a1d3-449e-abe5-03d50ac895c9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9e5fdc64-81e8-4305-ab09-3bc88bc97310",
                component: "col",
                label: "1.1.7 (b)",
                simplifiedLabel: "1.1.7 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b6f86f39-1122-4845-8507-06f1ed05956e",
                component: "col",
                label:
                  "Are firewall and router rule sets reviewed at least every six months?",
                simplifiedLabel:
                  "Are firewall and router rule sets reviewed at least every six months?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f1e578fa-9c74-4680-a556-1e721e8da24a",
                component: "col",
                label: ["Examine documentation from firewall reviews."],
                simplifiedLabel: [
                  "Examine documentation from firewall reviews.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7cfc652f-a6a5-4e97-a89a-887897a3c4b9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["470c5179-1ace-4b9c-a9b4-ea0d252947e2"],
                },
              },
              {
                _uid: "470c5179-1ace-4b9c-a9b4-ea0d252947e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "95063f3e-73a0-4355-8041-8a875ccb12f7_7cfc652f-a6a5-4e97-a89a-887897a3c4b9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6eb01b1b-1fa0-4b6d-a5e2-29e2c6e5cca7",
                component: "col",
                label: "1.2",
                simplifiedLabel: "1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e8378319-dd35-443d-9e5d-6454a78621c6",
                component: "col",
                label: [
                  "Do firewall and router configurations restrict connections between untrusted networks and any system in the cardholder data environment as follows:",
                  "Note: An “untrusted network” is any network that is external to the networks belonging to the entity under review, and/or which is out of the entity’s ability to control or manage.",
                ],
                simplifiedLabel: [
                  "Do firewall and router configurations restrict connections between untrusted networks and any system in the cardholder data environment as follows:",
                  "Note: An “untrusted network” is any network that is external to the networks belonging to the entity under review, and/or which is out of the entity’s ability to control or manage.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "83c2819a-e81c-4e09-9cac-7904003aae21",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e94acf74-5e07-465f-8eb7-c8de3f525f6a",
                component: "col",
                label: "1.2.1 (a)",
                simplifiedLabel: "1.2.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "92a48163-c594-494e-8217-98ea99f4415b",
                component: "col",
                label:
                  "Is inbound and outbound traffic restricted to that which is necessary for the cardholder data environment? ",
                simplifiedLabel:
                  "Is inbound and outbound traffic restricted to that which is necessary for the cardholder data environment? ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "420fbd2f-2463-4192-9213-1913f77701d5",
                component: "col",
                label: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "cc300e91-c6c5-4beb-8bcd-12aabb31154c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ee84e2e8-92fc-4664-9576-83af277628b2"],
                },
              },
              {
                _uid: "ee84e2e8-92fc-4664-9576-83af277628b2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "8352fd84-bd0d-4aff-a28d-c6905885fc49_cc300e91-c6c5-4beb-8bcd-12aabb31154c",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f54d20f7-44b8-4638-8d6e-91610217fbc3",
                component: "col",
                label: "1.2.1 (b)",
                simplifiedLabel: "1.2.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "55533b7f-3222-4369-a95e-8ba1269a5553",
                component: "col",
                label:
                  "Is all other inbound and outbound traffic specifically denied (for example by using an explicit “deny all” or an implicit deny after allow statement)?",
                simplifiedLabel:
                  "Is all other inbound and outbound traffic specifically denied (for example by using an explicit “deny all” or an implicit deny after allow statement)?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5a696a98-41a3-4597-910b-4712a315d472",
                component: "col",
                label: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1f8e80e1-0cec-4322-9d03-c5e46be1663e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["94b73de7-eb66-41fa-a94e-d7cbb9bc6ef3"],
                },
              },
              {
                _uid: "94b73de7-eb66-41fa-a94e-d7cbb9bc6ef3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "158c45aa-aef3-42fc-8f3b-564f4a06ef66_1f8e80e1-0cec-4322-9d03-c5e46be1663e",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e42638e8-6b21-43aa-931a-cb00d4bdeab9",
                component: "col",
                label: "1.2.2",
                simplifiedLabel: "1.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d77d2838-f01e-486e-b5c8-3b4b915835f5",
                component: "col",
                label:
                  "Are router configuration files secured from unauthorized access and synchronized—for example, the running (or active) configuration matches the start-up configuration (used when machines are booted)?",
                simplifiedLabel:
                  "Are router configuration files secured from unauthorized access and synchronized—for example, the running (or active) configuration matches the start-up configuration (used when machines are booted)?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f865434e-41cb-444e-b4db-bd76b236201b",
                component: "col",
                label: [
                  "Review firewall and router configuration standards.",
                  "Examine router configuration files and router configurations.",
                ],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                  "Examine router configuration files and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fe48c763-b37d-4b28-98a0-5bdd44d5d95d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1ce6f123-d589-42b1-a0c9-a98252668e2a"],
                },
              },
              {
                _uid: "1ce6f123-d589-42b1-a0c9-a98252668e2a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "18cd8749-6374-487b-9708-1d4b5e62749a_fe48c763-b37d-4b28-98a0-5bdd44d5d95d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e1d0b9d3-da3a-4712-8a1f-454d51b89c2a",
                component: "col",
                label: "1.2.3",
                simplifiedLabel: "1.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "aae8e7b1-86ba-4df9-8be6-ce3151965d06",
                component: "col",
                label:
                  "Are perimeter firewalls installed between all wireless networks and the cardholder data environment, and are these firewalls configured to deny or, if traffic is necessary for business purposes, permit only authorized traffic between the wireless environment and the cardholder data environment?",
                simplifiedLabel:
                  "Are perimeter firewalls installed between all wireless networks and the cardholder data environment, and are these firewalls configured to deny or, if traffic is necessary for business purposes, permit only authorized traffic between the wireless environment and the cardholder data environment?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5a69f857-556f-441b-bec4-fcdce76f7b33",
                component: "col",
                label: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                simplifiedLabel: [
                  "Review firewall and router configuration standards.",
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b54d5daf-c624-41d9-955c-1800d6d14aef",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8eed07ad-c98a-48aa-8c4f-2260ca07ba96"],
                },
              },
              {
                _uid: "8eed07ad-c98a-48aa-8c4f-2260ca07ba96",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "114c455e-7e82-4772-8f08-22078decc9df_b54d5daf-c624-41d9-955c-1800d6d14aef",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e3b07a12-c84b-4a46-a9e1-ab06ae5ce299",
                component: "col",
                label: "1.3",
                simplifiedLabel: "1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c2247938-e491-47e7-942d-ddb49c60cd5d",
                component: "col",
                label:
                  "Is direct public access prohibited between the Internet and any system component in the cardholder data environment, as follows:",
                simplifiedLabel:
                  "Is direct public access prohibited between the Internet and any system component in the cardholder data environment, as follows:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "4714aa20-0e9e-415d-902f-5e468e34d14c",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "76e3187e-fee1-4274-a567-b9389c549cb5",
                component: "col",
                label: "1.3.1",
                simplifiedLabel: "1.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7542b2e6-82ed-4951-9fd7-9a17059b1cb4",
                component: "col",
                label:
                  "Is a DMZ implemented to limit inbound traffic to only system components that provide authorized publicly accessible services, protocols, and ports?",
                simplifiedLabel:
                  "Is a DMZ implemented to limit inbound traffic to only system components that provide authorized publicly accessible services, protocols, and ports?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "124c5623-eeda-4fa5-aff9-6f2cce732a82",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "54019d20-1174-47c4-8801-3752aa3504cc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e47b96a7-0bda-4776-ae16-dfe2e1da7238"],
                },
              },
              {
                _uid: "e47b96a7-0bda-4776-ae16-dfe2e1da7238",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1d9c224f-a5f7-4f90-831f-a96b239ea04d_54019d20-1174-47c4-8801-3752aa3504cc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd0abd04-2089-4239-885d-3b23bbd4990f",
                component: "col",
                label: "1.3.2",
                simplifiedLabel: "1.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b84895c2-d412-4b91-ae1c-af167c20d143",
                component: "col",
                label:
                  "Is inbound Internet traffic limited to IP addresses within the DMZ?",
                simplifiedLabel:
                  "Is inbound Internet traffic limited to IP addresses within the DMZ?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f2dc690d-92d5-4ed4-8b97-317ad37d908c",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "46b548be-1ef9-4add-9643-19e66ea27d02",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["b9115696-1103-492a-af85-b7450bfb3c98"],
                },
              },
              {
                _uid: "b9115696-1103-492a-af85-b7450bfb3c98",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "68b81a55-cf7f-40b2-b7d9-cd0ff1be5b50_46b548be-1ef9-4add-9643-19e66ea27d02",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1877ff5c-8813-4b0e-ba86-2fef258e26ae",
                component: "col",
                label: "1.3.3",
                simplifiedLabel: "1.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b0e2d24b-38c0-46c5-867d-af674330cbee",
                component: "col",
                label: [
                  "Are anti-spoofing measures implemented to detect and block forged sourced IP addresses from entering the network? ",
                  "(For example, block traffic originating from the internet with an internal address.)",
                ],
                simplifiedLabel: [
                  "Are anti-spoofing measures implemented to detect and block forged sourced IP addresses from entering the network? ",
                  "(For example, block traffic originating from the internet with an internal address.)",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4136aafc-591d-4108-a91c-20bd00d37ea6",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4e5e0d6b-214c-44c2-a78b-ea1be5ba5643",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3c0ce2dc-aed2-4216-a1d4-3a7122ef9332"],
                },
              },
              {
                _uid: "3c0ce2dc-aed2-4216-a1d4-3a7122ef9332",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1d6dab3d-a295-496d-827d-32daaf7c88fd_4e5e0d6b-214c-44c2-a78b-ea1be5ba5643",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "68ae9477-253e-4c43-8607-47de39a88cef",
                component: "col",
                label: "1.3.4",
                simplifiedLabel: "1.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b9cf2b91-c6e4-4875-bc3b-16c9dbdba9ac",
                component: "col",
                label:
                  "Is outbound traffic from the cardholder data environment to the Internet explicitly authorized?",
                simplifiedLabel:
                  "Is outbound traffic from the cardholder data environment to the Internet explicitly authorized?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2c80d8a7-e8c7-4b12-a7f8-85131d9ae95f",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b87f4f1e-cc34-4d5b-a842-05745a63fc47",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4da2203e-5337-4204-bb2b-f0ccb9eefde8"],
                },
              },
              {
                _uid: "4da2203e-5337-4204-bb2b-f0ccb9eefde8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "10d70181-43b7-49a5-9843-8d5230d8833c_b87f4f1e-cc34-4d5b-a842-05745a63fc47",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f8b103f-1ba8-4be5-98cc-703991d474b1",
                component: "col",
                label: "1.3.5",
                simplifiedLabel: "1.3.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "01b3a8b7-1d49-4149-a2fb-ebb256876ed4",
                component: "col",
                label:
                  "Are only established connections permitted into the network?",
                simplifiedLabel:
                  "Are only established connections permitted into the network?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2dea6cad-057f-4525-aaa5-d54d3522bf71",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "13caba48-c6e0-48e5-a1a2-61e97c93f821",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3c925ee3-bbbd-41ff-9f49-88fe231a53cc"],
                },
              },
              {
                _uid: "3c925ee3-bbbd-41ff-9f49-88fe231a53cc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3da0105d-a2e1-4a53-8785-f7076cd5e110_13caba48-c6e0-48e5-a1a2-61e97c93f821",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "67c240db-fa04-4d0b-9d21-53af7c295ad8",
                component: "col",
                label: "1.3.7 (a)",
                simplifiedLabel: "1.3.7 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d1023788-378e-470c-9fb4-c65030f5777d",
                component: "col",
                label: [
                  "Are methods in place to prevent the disclosure of private IP addresses and routing information to the Internet?",
                  "Note: Methods to obscure IP addressing may include, but are not limited to:",
                ],
                simplifiedLabel: [
                  "Are methods in place to prevent the disclosure of private IP addresses and routing information to the Internet?",
                  "Note: Methods to obscure IP addressing may include, but are not limited to:",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [
                    "Network Address Translation (NAT)",
                    "Placing servers containing cardholder data behind proxy servers/firewalls,",
                    "Removal or filtering of route advertisements for private networks that employ registered addressing,",
                    "Internal use of RFC1918 address space instead of registered addresses.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "031f9378-e13a-4992-935b-d48ec3539786",
                component: "col",
                label: ["Examine firewall and router configurations."],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ee8decc1-bb5f-4a1e-b692-47f8451dfc2d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["b8828a1f-e9aa-4800-8dd5-d6c0c2086d9c"],
                },
              },
              {
                _uid: "b8828a1f-e9aa-4800-8dd5-d6c0c2086d9c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "42664064-7c0e-423a-808c-36c659df2dae_ee8decc1-bb5f-4a1e-b692-47f8451dfc2d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9aa87514-a980-48fe-93f8-1c9650fbe552",
                component: "col",
                label: "1.3.7 (b)",
                simplifiedLabel: "1.3.7 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3ea4e255-3b24-4b35-a4ff-e25502b47654",
                component: "col",
                label:
                  "Is any disclosure of private IP addresses and routing information to external entities authorized?",
                simplifiedLabel:
                  "Is any disclosure of private IP addresses and routing information to external entities authorized?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fc6e2d7b-87a1-4f8c-aea8-8e80f41e57ce",
                component: "col",
                label: [
                  "Examine firewall and router configurations.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Examine firewall and router configurations.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c95c416d-dcf1-4dc0-baa9-e7cd2b8af8bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["0d12cf69-e1e7-4bb9-826e-17d9533a1472"],
                },
              },
              {
                _uid: "0d12cf69-e1e7-4bb9-826e-17d9533a1472",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1851c07e-661e-4b52-b7b5-e679f54b7919_c95c416d-dcf1-4dc0-baa9-e7cd2b8af8bc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "030048a0-06ca-4c1b-b137-076780e51bc5",
                component: "col",
                label: "1.4 (a)",
                simplifiedLabel: "1.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b3b83bdd-178b-4412-b096-548d59e39635",
                component: "col",
                label:
                  "Is personal firewall software (or equivalent functionality) installed and active on any portable computing devices (including company and/or employee-owned) that connect to the Internet when outside the network (for example, laptops used by employees), and which are also used to access the CDE?",
                simplifiedLabel:
                  "Is personal firewall software (or equivalent functionality) installed and active on any portable computing devices (including company and/or employee-owned) that connect to the Internet when outside the network (for example, laptops used by employees), and which are also used to access the CDE?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5afa720e-ae2e-460a-8a49-39e9732dae80",
                component: "col",
                label: [
                  "Review policies and configuration standards.",
                  "Examine mobile and/or employee owned devices.",
                ],
                simplifiedLabel: [
                  "Review policies and configuration standards.",
                  "Examine mobile and/or employee owned devices.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3c4cf6be-afa9-415d-9c2c-d78819b3f81f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ef9546b9-6ec8-4e2e-8bdc-eac56b29595b"],
                },
              },
              {
                _uid: "ef9546b9-6ec8-4e2e-8bdc-eac56b29595b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d7385dd5-bcbf-4444-abe2-09f7312ee84e_3c4cf6be-afa9-415d-9c2c-d78819b3f81f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5a12c45b-6b9b-4bff-8ad8-f14c9cfb6c49",
                component: "col",
                label: "1.4 (b)",
                simplifiedLabel: "1.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6cf6240a-051c-42c3-9988-a63e72923510",
                component: "col",
                label:
                  "Is the personal firewall software (or equivalent functionality) configured to specific configuration settings, actively running, and not alterable by users of mobile and/or employee-owned devices?",
                simplifiedLabel:
                  "Is the personal firewall software (or equivalent functionality) configured to specific configuration settings, actively running, and not alterable by users of mobile and/or employee-owned devices?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d76d14ef-c2c4-459c-8bc4-cb386bee0eef",
                component: "col",
                label: [
                  "Review policies and configuration standards.",
                  "Examine mobile and/or employee owned devices.",
                ],
                simplifiedLabel: [
                  "Review policies and configuration standards.",
                  "Examine mobile and/or employee owned devices.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "19700ac2-87ea-49b3-b2b5-80f9c7bf79b2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["0db7ea50-df43-44cf-93b0-29615ddbb0a0"],
                },
              },
              {
                _uid: "0db7ea50-df43-44cf-93b0-29615ddbb0a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "0f423c26-916d-4a16-a2a2-0112410b6a62_19700ac2-87ea-49b3-b2b5-80f9c7bf79b2",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a0360976-e132-4523-88d4-52e9c5da64f8",
                component: "col",
                label: "1.5",
                simplifiedLabel: "1.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dcb06e98-e146-43c3-b4f8-708769390ed5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are security policies and operational procedures for managing firewalls:",
                  simplifiedLabel:
                    "Are security policies and operational procedures for managing firewalls:",
                  ul: [
                    "Documented",
                    "In use",
                    "Known to all affected parties?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "911407f3-be0e-4ca3-b1e0-dbd6ed80b318",
                component: "col",
                label: [
                  "Review security policies and operational procedures",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review security policies and operational procedures",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b7a48c85-7cd8-4adb-8a5a-ac396ec861ac",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["05648521-2a97-40ee-9985-869157d07847"],
                },
              },
              {
                _uid: "05648521-2a97-40ee-9985-869157d07847",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "edd01b6f-0b46-4dfd-ba7e-dde1290797b0_b7a48c85-7cd8-4adb-8a5a-ac396ec861ac",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5436e834-12fc-4ab4-bb90-434297efa3dd",
                component: "col",
                label:
                  "Requirement 2: Do not use vendor-supplied defaults for system passwords and other security parameters",
                simplifiedLabel:
                  "Requirement 2: Do not use vendor-supplied defaults for system passwords and other security parameters",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b6273674-59ac-4f0b-9733-04ae6968eeb0",
                component: "col",
                label: "2.1 (a)",
                simplifiedLabel: "2.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8b8438ac-2092-4d3e-8ac3-cf86e6840ca7",
                component: "col",
                label: [
                  "Are vendor-supplied defaults always changed before installing a system on the network?",
                  "This applies to ALL default passwords, including but not limited to those used by operating systems, software that provides security services, application and system accounts, point-of-sale (POS) terminals, payment applications, Simple Network Management Protocol (SNMP) community strings, etc.).",
                ],
                simplifiedLabel: [
                  "Are vendor-supplied defaults always changed before installing a system on the network?",
                  "This applies to ALL default passwords, including but not limited to those used by operating systems, software that provides security services, application and system accounts, point-of-sale (POS) terminals, payment applications, Simple Network Management Protocol (SNMP) community strings, etc.).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "60adf5d2-67fc-4977-80c9-a220d8d81d91",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Examine vendor documentation.",
                  "Observe system configurations and account settings.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Examine vendor documentation.",
                  "Observe system configurations and account settings.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "00f8706d-6fdb-4fa3-8a7b-18d416f56bfc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1f70c11f-266e-4310-a47c-47346a571186"],
                },
              },
              {
                _uid: "1f70c11f-266e-4310-a47c-47346a571186",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "300bd3f7-eb66-46e9-b699-873dd92194c7_00f8706d-6fdb-4fa3-8a7b-18d416f56bfc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f3cfbf45-8c25-4c03-bb92-a27e4a4564c2",
                component: "col",
                label: "2.1 (b)",
                simplifiedLabel: "2.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2dd53d90-de74-40c3-89c9-efc1068d962b",
                component: "col",
                label:
                  "Are unnecessary default accounts removed or disabled before installing a system on the network?",
                simplifiedLabel:
                  "Are unnecessary default accounts removed or disabled before installing a system on the network?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8f5472f6-bee2-4a15-8aa1-62412806bed1",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Examine vendor documentation.",
                  "Observe system configurations and account settings.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Examine vendor documentation.",
                  "Observe system configurations and account settings.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0a340b0c-97f5-4043-826d-28ac6634b8ba",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4832ca6a-b9f6-4b90-a50c-d5c99b18ba0b"],
                },
              },
              {
                _uid: "4832ca6a-b9f6-4b90-a50c-d5c99b18ba0b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9274e12f-8378-4440-b639-dad87e8465af_0a340b0c-97f5-4043-826d-28ac6634b8ba",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "07ee3c7c-b4a4-457b-bd12-09d419f42fe5",
                component: "col",
                label: "2.2 (a)",
                simplifiedLabel: "2.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "620541f8-7b76-4756-ac91-a30d3d4f9720",
                component: "col",
                label: [
                  "Are configuration standards developed for all system components and are they consistent with industryaccepted system hardening standards?",
                  "Sources of industry-accepted system hardening standards may include, but are not limited to, SysAdmin Audit Network Security (SANS) Institute, National Institute of Standards Technology (NIST), International Organization for Standardization (ISO), and Center for Internet Security (CIS).",
                ],
                simplifiedLabel: [
                  "Are configuration standards developed for all system components and are they consistent with industryaccepted system hardening standards?",
                  "Sources of industry-accepted system hardening standards may include, but are not limited to, SysAdmin Audit Network Security (SANS) Institute, National Institute of Standards Technology (NIST), International Organization for Standardization (ISO), and Center for Internet Security (CIS).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7f829fb7-191a-4006-819d-99e6a987b4b4",
                component: "col",
                label: [
                  "Review system configuration standards.",
                  "Review industry-accepted hardening standards.",
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review system configuration standards.",
                  "Review industry-accepted hardening standards.",
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4952568a-88e0-4dea-beab-192535df91eb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["91d391e4-220e-45cd-913b-b016d3168d72"],
                },
              },
              {
                _uid: "91d391e4-220e-45cd-913b-b016d3168d72",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "dcb196f5-56aa-4a72-9ea6-ff50964a5e9c_4952568a-88e0-4dea-beab-192535df91eb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e7bc011-e882-46ec-8964-88d8f132fa1d",
                component: "col",
                label: "2.2 (b)",
                simplifiedLabel: "2.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5b88d63c-2bf5-4b9b-a985-1c9e41f3bc9e",
                component: "col",
                label: [
                  "Are system configuration standards updated as new vulnerability issues are identified, as defined in Requirement 6.1?",
                ],
                simplifiedLabel: [
                  "Are system configuration standards updated as new vulnerability issues are identified, as defined in Requirement 6.1?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b6737b32-b59d-4430-8a69-7e9e467f6846",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4bef8a4d-ffbe-4041-91e7-b8b7522fb5c9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["89bf7878-f5e8-49d8-b281-3932c1976ead"],
                },
              },
              {
                _uid: "89bf7878-f5e8-49d8-b281-3932c1976ead",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9d683c1a-9038-4015-8172-88c6ba1bb01a_4bef8a4d-ffbe-4041-91e7-b8b7522fb5c9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3cd3c42e-f289-46d1-8c46-f00f8a2b8204",
                component: "col",
                label: "2.2 (c)",
                simplifiedLabel: "2.2 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f4cef8d4-7a69-42b4-afe3-483ca5e1302b",
                component: "col",
                label: [
                  "Are system configuration standards applied when new systems are configured?",
                ],
                simplifiedLabel: [
                  "Are system configuration standards applied when new systems are configured?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "da35223f-3c25-4f8e-8163-f2c1c74f1692",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "065808c8-80a0-4be2-9772-f064bfdf0bcf",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9db004bb-5805-4046-bcdd-a9678134874a"],
                },
              },
              {
                _uid: "9db004bb-5805-4046-bcdd-a9678134874a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "96933aed-c3f2-43d0-a322-1bf6f6d551df_065808c8-80a0-4be2-9772-f064bfdf0bcf",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b318ae38-e766-443a-bfa9-6df0ba7595ca",
                component: "col",
                label: "2.2 (d)",
                simplifiedLabel: "2.2 (d)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c0759480-3d94-4436-bef0-6a3a955a1e78",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Do system configuration standards include all of the following:",
                  simplifiedLabel:
                    "Do system configuration standards include all of the following:",
                  ul: [
                    "Changing of all vendor-supplied defaults and elimination of unnecessary default accounts?",
                    "Implementing only one primary function per server to prevent functions that require different security levels from co-existing on the same server?",
                    "Enabling only necessary services, protocols, daemons, etc., as required for the function of the system?",
                    "Implementing additional security features for any required services, protocols or daemons that are considered to be insecure?",
                    "Configuring system security parameters to prevent misuse?",
                    "Removing all unnecessary functionality, such as scripts, drivers, features, subsystems, file systems, and unnecessary web servers?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "64c68fdb-5b48-448e-b119-8632d4b617bc",
                component: "col",
                label: ["Review system configuration standards."],
                simplifiedLabel: ["Review system configuration standards."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ff686264-c7db-4ddc-9017-5d4a3de453c0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d699aac5-9768-44fe-aa7f-54cfb7e6cfee"],
                },
              },
              {
                _uid: "d699aac5-9768-44fe-aa7f-54cfb7e6cfee",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "36f7810d-9504-44cc-8545-e98676c11c94_ff686264-c7db-4ddc-9017-5d4a3de453c0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a3683369-3605-4824-a6c0-3da6df25f4da",
                component: "col",
                label: "2.2.1 (a)",
                simplifiedLabel: "2.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3c7e3f39-e857-4b84-94f3-ff7eaf7ded41",
                component: "col",
                label: [
                  "Is only one primary function implemented per server, to prevent functions that require different security levels from co-existing on the same server?",
                  "For example, web servers, database servers, and DNS should be implemented on separate servers",
                ],
                simplifiedLabel: [
                  "Is only one primary function implemented per server, to prevent functions that require different security levels from co-existing on the same server?",
                  "For example, web servers, database servers, and DNS should be implemented on separate servers",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0df2109e-c503-4db6-a8b0-51e4f3ab504b",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c761899c-5054-4ded-9192-e6272858b17d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["fe0fa9a0-8c71-461a-907c-48a72da8baaa"],
                },
              },
              {
                _uid: "fe0fa9a0-8c71-461a-907c-48a72da8baaa",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a3822788-7042-4302-ac0d-2349bc97d6c5_c761899c-5054-4ded-9192-e6272858b17d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e891f02a-61e6-4974-afd6-f9689b995f36",
                component: "col",
                label: "2.2.1 (b)",
                simplifiedLabel: "2.2.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b7530c77-f1d6-4c22-ad63-a5e201d3a59e",
                component: "col",
                label: [
                  "If virtualization technologies are used, is only one primary function implemented per virtual system component or device?",
                ],
                simplifiedLabel: [
                  "If virtualization technologies are used, is only one primary function implemented per virtual system component or device?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eb1db7b6-c4e5-48e1-a9d7-91f36a32793b",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d1c538b4-66ed-4dc1-aa90-64adb478c024",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["27cd69e7-c1a9-4f41-81f4-12189264a5d5"],
                },
              },
              {
                _uid: "27cd69e7-c1a9-4f41-81f4-12189264a5d5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "8d4ca928-a421-4001-8172-e2dead8fa378_d1c538b4-66ed-4dc1-aa90-64adb478c024",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "630ba97f-6b9b-4ae2-974e-94f766d2bddc",
                component: "col",
                label: "2.2.2 (a)",
                simplifiedLabel: "2.2.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3adfa6f4-d6c5-4ff0-a835-dc8102320309",
                component: "col",
                label: [
                  "Are only necessary services, protocols, daemons, etc. enabled as required for the function of the system (services and protocols not directly needed to perform the device’s specified function are disabled)?",
                ],
                simplifiedLabel: [
                  "Are only necessary services, protocols, daemons, etc. enabled as required for the function of the system (services and protocols not directly needed to perform the device’s specified function are disabled)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cf59919f-478b-4f42-b40f-3f5978fd8edf",
                component: "col",
                label: [
                  "Review configuration standards.",
                  "Examine system configurations.",
                ],
                simplifiedLabel: [
                  "Review configuration standards.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c048685b-7475-4d30-bc66-7fdf07d563ec",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["05e7df8f-a6fa-411c-b391-0b56e7ff4bcc"],
                },
              },
              {
                _uid: "05e7df8f-a6fa-411c-b391-0b56e7ff4bcc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "eb64973c-a4b9-4692-ba2e-b37dc358a141_c048685b-7475-4d30-bc66-7fdf07d563ec",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "89a3f8d4-8c62-418b-83a4-23fde36fb3b5",
                component: "col",
                label: "2.2.2 (b)",
                simplifiedLabel: "2.2.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "40af6378-720b-44ea-bbf1-27539f3b89ff",
                component: "col",
                label: [
                  "Are all enabled insecure services, daemons, or protocols justified per documented configuration standards?",
                ],
                simplifiedLabel: [
                  "Are all enabled insecure services, daemons, or protocols justified per documented configuration standards?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "74f69236-120f-456f-bc00-d5a03a4a0fd2",
                component: "col",
                label: [
                  "Review configuration standards.",
                  "Interview personnel.",
                  "Examine configuration settings.",
                  "Compare enabled services, etc. to documented justifications.",
                ],
                simplifiedLabel: [
                  "Review configuration standards.",
                  "Interview personnel.",
                  "Examine configuration settings.",
                  "Compare enabled services, etc. to documented justifications.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0c5a15ae-64ee-4d78-8d1a-e4e8cd0c1086",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8ad77605-0450-44bb-aa25-6acfed4b9647"],
                },
              },
              {
                _uid: "8ad77605-0450-44bb-aa25-6acfed4b9647",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b9c0f222-5e06-47a9-8704-d20ca48e8bb5_0c5a15ae-64ee-4d78-8d1a-e4e8cd0c1086",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b55cd892-cf42-479e-a2cf-4e319f47974e",
                component: "col",
                label: "2.2.3",
                simplifiedLabel: "2.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "eb6df50b-5561-4b91-af78-73f5d755f4a3",
                component: "col",
                label: [
                  "Are additional security features documented and implemented for any required services, protocols or daemons that are considered to be insecure?",
                ],
                simplifiedLabel: [
                  "Are additional security features documented and implemented for any required services, protocols or daemons that are considered to be insecure?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d488ac40-f89e-46ae-a826-88cd6b0dc945",
                component: "col",
                label: [
                  "Review configuration standards.",
                  "Examine configuration settings.",
                ],
                simplifiedLabel: [
                  "Review configuration standards.",
                  "Examine configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1c104396-99c2-428b-8a5a-d66e3419ade5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d10f0291-bbd7-4694-9d3b-81d489f53168"],
                },
              },
              {
                _uid: "d10f0291-bbd7-4694-9d3b-81d489f53168",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ea56f975-ee3f-4c51-8b4a-91c3ac9c0c7d_1c104396-99c2-428b-8a5a-d66e3419ade5",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "911ad8d0-95d6-4886-aeb7-cb52105dff53",
                component: "col",
                label: "2.2.4 (a)",
                simplifiedLabel: "2.2.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0aee4bf3-8020-4fe4-a069-633963665b0a",
                component: "col",
                label: [
                  "Are system administrators and/or personnel that configure system components knowledgeable about common security parameter settings for those system components?",
                ],
                simplifiedLabel: [
                  "Are system administrators and/or personnel that configure system components knowledgeable about common security parameter settings for those system components?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "492a1a96-c1f5-4f96-a04d-a78d85179891",
                component: "col",
                label: ["Interview personnel."],
                simplifiedLabel: ["Interview personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "56803ea8-b234-4aa7-9b92-8eeab37e64bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e9d51b7b-97c4-48d1-8af5-e59b4b2fde09"],
                },
              },
              {
                _uid: "e9d51b7b-97c4-48d1-8af5-e59b4b2fde09",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "dd19e392-07bb-464f-b425-3d97546d3745_56803ea8-b234-4aa7-9b92-8eeab37e64bc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3b267332-9c26-4392-ba1a-4d4ff3d750ae",
                component: "col",
                label: "2.2.4 (b)",
                simplifiedLabel: "2.2.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "11ec08fb-5809-4545-857c-9d663f68c49c",
                component: "col",
                label: [
                  "Are common system security parameters settings included in the system configuration standards?",
                ],
                simplifiedLabel: [
                  "Are common system security parameters settings included in the system configuration standards?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e0358dac-208b-4d45-91e0-155096e963ea",
                component: "col",
                label: ["Review system configuration standards."],
                simplifiedLabel: ["Review system configuration standards."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ea6fbfa0-33ed-480e-960c-c5e55ada9077",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1b5bd927-a844-45c8-8d09-57d468b314a1"],
                },
              },
              {
                _uid: "1b5bd927-a844-45c8-8d09-57d468b314a1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "bee51302-130e-4d48-823b-dcaf48482a06_ea6fbfa0-33ed-480e-960c-c5e55ada9077",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1fd2a54c-9c11-4423-9a2a-3f25d9b7aa77",
                component: "col",
                label: "2.2.4 (c)",
                simplifiedLabel: "2.2.4 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "cfc8b1f5-1236-4a22-a33f-38321ae1a36f",
                component: "col",
                label: [
                  "Are security parameter settings set appropriately on system components?",
                ],
                simplifiedLabel: [
                  "Are security parameter settings set appropriately on system components?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b0b95262-02d6-41b7-b76e-e57e74b0f2e2",
                component: "col",
                label: [
                  "Examine system components.",
                  "Examine security parameter settings.",
                  "Compare settings to system configuration standards.",
                ],
                simplifiedLabel: [
                  "Examine system components.",
                  "Examine security parameter settings.",
                  "Compare settings to system configuration standards.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "12907c13-51a8-4642-9dfd-51506576ffee",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["55841199-f260-4487-9b4e-fe1dcfd63339"],
                },
              },
              {
                _uid: "55841199-f260-4487-9b4e-fe1dcfd63339",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "131bb302-2d44-41a4-b233-d21de926766a_12907c13-51a8-4642-9dfd-51506576ffee",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ee3c928c-815a-4280-b4b9-99c06ffa9f78",
                component: "col",
                label: "2.2.5 (a)",
                simplifiedLabel: "2.2.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9cf3d6fa-2c1c-4c5c-b47e-b436655a2f64",
                component: "col",
                label: [
                  "Has all unnecessary functionality—such as scripts, drivers, features, subsystems, file systems, and unnecessary web servers—been removed",
                ],
                simplifiedLabel: [
                  "Has all unnecessary functionality—such as scripts, drivers, features, subsystems, file systems, and unnecessary web servers—been removed",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2fd9ab66-2a18-4b96-a667-b26328c1d998",
                component: "col",
                label: ["Examine security parameters on system components."],
                simplifiedLabel: [
                  "Examine security parameters on system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "77e5d89e-323b-4112-bbb1-a0e77db18533",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["52e793ed-cbec-40e7-80a1-ed43b223e2f0"],
                },
              },
              {
                _uid: "52e793ed-cbec-40e7-80a1-ed43b223e2f0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f9aa998f-1195-441f-8259-422bddee96b9_77e5d89e-323b-4112-bbb1-a0e77db18533",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "51d37929-8bae-4ce9-8a83-ffe47aa11050",
                component: "col",
                label: "2.2.5 (b)",
                simplifiedLabel: "2.2.5 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9dea72ab-f384-4f59-a369-9c6c2aced441",
                component: "col",
                label: [
                  "Are enabled functions documented and do they support secure configuration?",
                ],
                simplifiedLabel: [
                  "Are enabled functions documented and do they support secure configuration?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f9dfce3b-8236-430b-97aa-8554c91512c8",
                component: "col",
                label: [
                  "Review documentation.",
                  "Examine security parameters on system components.",
                ],
                simplifiedLabel: [
                  "Review documentation.",
                  "Examine security parameters on system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "759d90af-cae8-4030-b148-38919f44f730",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["852832a2-e554-4466-ac09-1c293ab0bbbf"],
                },
              },
              {
                _uid: "852832a2-e554-4466-ac09-1c293ab0bbbf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c727adf1-ea8f-484e-a3b4-19875917bc56_759d90af-cae8-4030-b148-38919f44f730",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c3c0d4cd-ae21-4391-a52f-989c50df043e",
                component: "col",
                label: "2.2.5 (c)",
                simplifiedLabel: "2.2.5 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "eed93069-63fe-4f03-8c98-d609de9a5095",
                component: "col",
                label: [
                  "Is only documented functionality present on system components?",
                ],
                simplifiedLabel: [
                  "Is only documented functionality present on system components?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "60c1798d-35fc-4cb5-bf98-e14d415c834c",
                component: "col",
                label: [
                  "Review documentation.",
                  "Examine security parameters on system components.",
                ],
                simplifiedLabel: [
                  "Review documentation.",
                  "Examine security parameters on system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "84db292d-b201-41af-a795-377d8ed3b603",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a96f2cdb-1c3d-4ea9-bbad-5ed99d9409f1"],
                },
              },
              {
                _uid: "a96f2cdb-1c3d-4ea9-bbad-5ed99d9409f1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f4b016fd-6f9f-4045-b738-c0c52f6a5d82_84db292d-b201-41af-a795-377d8ed3b603",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "79affbdc-3cdb-43b4-836c-0c1ba66949ed",
                component: "col",
                label: "2.3",
                simplifiedLabel: "2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0289e030-39cb-4ede-816b-ace4b899a053",
                component: "col",
                label: [
                  "Is non-console administrative access encrypted as follows:",
                ],
                simplifiedLabel: [
                  "Is non-console administrative access encrypted as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "380e6f07-3b76-4b34-bc6e-7249b2c3f8fd",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d6067817-bdf8-403d-bcca-67ee8cf8fb2d",
                component: "col",
                label: "2.3 (a)",
                simplifiedLabel: "2.3 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "77da64ac-1130-4532-818d-145fac79ff6b",
                component: "col",
                label: [
                  "Is all non-console administrative access encrypted with strong cryptography, and is a strong encryption method invoked before the administrator’s password is requested?",
                ],
                simplifiedLabel: [
                  "Is all non-console administrative access encrypted with strong cryptography, and is a strong encryption method invoked before the administrator’s password is requested?",
                ],
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b7e4bda0-fd78-4cdc-a753-6f119da0fb2b",
                component: "col",
                label: [
                  "Examine system components.",
                  "Examine system configurations.",
                  "Observe an administrator log on.",
                ],
                simplifiedLabel: [
                  "Examine system components.",
                  "Examine system configurations.",
                  "Observe an administrator log on.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "efcbff2b-c5fd-4a2c-9768-223323df9510",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["fa29e37f-b8d2-4e6f-90df-8c6ebf3fe3d6"],
                },
              },
              {
                _uid: "fa29e37f-b8d2-4e6f-90df-8c6ebf3fe3d6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b6dad346-b3e9-4389-8a19-40ef5c3b3f66_efcbff2b-c5fd-4a2c-9768-223323df9510",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "34017c3a-b119-4da7-a8bb-fe8b4b332bf4",
                component: "col",
                label: "2.3 (b)",
                simplifiedLabel: "2.3 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a397676e-aa83-4d92-b51f-db36709d048f",
                component: "col",
                label: [
                  "Are system services and parameter files configured to prevent the use of Telnet and other insecure remote login commands?",
                ],
                simplifiedLabel: [
                  "Are system services and parameter files configured to prevent the use of Telnet and other insecure remote login commands?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8f69cddc-909b-47b2-a790-3d9eca8a2aa3",
                component: "col",
                label: [
                  "Examine system components.",
                  "Examine services and files.",
                ],
                simplifiedLabel: [
                  "Examine system components.",
                  "Examine services and files.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ed93ec82-53b0-48eb-a239-ec5438caf9dc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["93a7e2a0-3bd0-440f-a835-2e37c89a32ff"],
                },
              },
              {
                _uid: "93a7e2a0-3bd0-440f-a835-2e37c89a32ff",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d734c3d9-5b53-43b2-94b3-4caa00349f3e_ed93ec82-53b0-48eb-a239-ec5438caf9dc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bde9ab68-08c1-4154-b6de-5ad9afdab490",
                component: "col",
                label: "2.3 (c)",
                simplifiedLabel: "2.3 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "cb4e3438-bdab-438d-a7c8-4c8c5951fe99",
                component: "col",
                label: [
                  "Is administrator access to web-based management interfaces encrypted with strong cryptography?",
                ],
                simplifiedLabel: [
                  "Is administrator access to web-based management interfaces encrypted with strong cryptography?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "bfb35ecf-3313-49f7-9a23-0c882d71e63d",
                component: "col",
                label: [
                  "Examine system components.",
                  "Observe an administrator log on.",
                ],
                simplifiedLabel: [
                  "Examine system components.",
                  "Observe an administrator log on.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c22fd07a-62d9-49a8-8de3-fbce1afda42c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4ab03bf2-a633-4092-a53d-314df3abd84e"],
                },
              },
              {
                _uid: "4ab03bf2-a633-4092-a53d-314df3abd84e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7ba2feb7-e967-4093-bf29-3732c2f99984_c22fd07a-62d9-49a8-8de3-fbce1afda42c",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "db14b5d8-7df2-4283-87e9-e1b56431cb9e",
                component: "col",
                label: "2.3 (d)",
                simplifiedLabel: "2.3 (d)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3e80219e-8cd9-4a95-8bf1-cdff97398792",
                component: "col",
                label: [
                  "For the technology in use, is strong cryptography implemented according to industry best practice and/or vendor recommendations?",
                ],
                simplifiedLabel: [
                  "For the technology in use, is strong cryptography implemented according to industry best practice and/or vendor recommendations?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "698f3164-a328-40d1-926f-a7d3873eb29c",
                component: "col",
                label: [
                  "Examine system components.",
                  "Review vendor documentation.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Examine system components.",
                  "Review vendor documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5c76562a-6285-42bb-b899-0ef1fc102863",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d492533b-9983-4698-b00f-3fb91b9dffcf"],
                },
              },
              {
                _uid: "d492533b-9983-4698-b00f-3fb91b9dffcf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "675c4998-3d61-4da3-a472-c74469a53974_5c76562a-6285-42bb-b899-0ef1fc102863",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c1e99e38-c7bb-4663-b59d-431206a5e212",
                component: "col",
                label: "Protect Cardholder Data",
                simplifiedLabel:
                  "Requirement 3: Protect stored cardholder data",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e6d648d0-cfad-4c48-b8d1-44dbaeafcbd8",
                component: "col",
                label: "3.2 (c)",
                simplifiedLabel: "3.2 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "39658d73-f086-4e83-befa-d68a2bdd855c",
                component: "col",
                label: [
                  "Is sensitive authentication data deleted or rendered unrecoverable upon completion of the authorization process?",
                ],
                simplifiedLabel: [
                  "Is sensitive authentication data deleted or rendered unrecoverable upon completion of the authorization process?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b85dea22-0e93-41c5-8324-d52866434067",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Examine system configurations.",
                  "Examine deletion processes.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Examine system configurations.",
                  "Examine deletion processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f714907e-2387-4094-8cfc-fb7375001ef8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["6948548e-e4b3-45fc-b09a-5bfd88ad79a5"],
                },
              },
              {
                _uid: "6948548e-e4b3-45fc-b09a-5bfd88ad79a5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a954b68f-ff4b-4781-86f8-2289d4fd6774_f714907e-2387-4094-8cfc-fb7375001ef8",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "37ba9378-660a-4af5-9d9f-f3c7d00ef836",
                component: "col",
                label: "3.2 (d) ",
                simplifiedLabel: "3.2 (d)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "283bd34d-bc69-4801-89a6-130bc77d5bd5",
                component: "col",
                label:
                  "Do all systems adhere to the following requirements regarding non-storage of sensitive authentication data after authorization (even if encrypted):",
                simplifiedLabel:
                  "Do all systems adhere to the following requirements regarding non-storage of sensitive authentication data after authorization (even if encrypted):",
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "a44661de-e08b-42c7-8b32-29d782b50bd9",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b60c4e6c-ff37-4856-8571-aaf1193429dd",
                component: "col",
                label: "3.2.2",
                simplifiedLabel: "3.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8060bffe-32bb-4da7-9f29-a2c1575c3be9",
                component: "col",
                label: [
                  "The card verification code or value (three-digit or fourdigit number printed on the front or back of a payment card) is not stored after authorization?",
                ],
                simplifiedLabel: [
                  "The card verification code or value (three-digit or fourdigit number printed on the front or back of a payment card) is not stored after authorization?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ed34c4e5-1eea-488d-bb06-5858702100cb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label: "Examine data sources including:",
                  simplifiedLabel: "Examine data sources including:",
                  ul: [
                    "Incoming transaction data",
                    "All logs",
                    "History files",
                    "Trace files",
                    "Database schema",
                    "Database contents",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "21a9941b-d702-4e9b-baa0-fdb53a019354",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d7b443c7-f0e9-41d2-8297-d772d5cba4b0"],
                },
              },
              {
                _uid: "d7b443c7-f0e9-41d2-8297-d772d5cba4b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b11e27ba-87e6-4745-ab3c-f1c412f3f956_21a9941b-d702-4e9b-baa0-fdb53a019354",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "00c7cf66-7236-4281-92ef-c75027e14672",
                component: "col",
                label: "3.2.3 ",
                simplifiedLabel: "3.2.3 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },

              {
                _uid: "b1efa30c-7afd-4341-bcdf-7fd9fd2bce9b",
                component: "col",
                label: [
                  "The personal identification number (PIN) or the encrypted PIN block is not stored after authorization?",
                ],
                simplifiedLabel: [
                  "The personal identification number (PIN) or the encrypted PIN block is not stored after authorization?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b52c56f9-8d48-49a6-af05-15028706bffa",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label: "Examine data sources including:",
                  simplifiedLabel: "Examine data sources including:",
                  ul: [
                    "Incoming transaction data",
                    "All logs",
                    "History files",
                    "Trace files",
                    "Database schema",
                    "Database contents",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "46000620-9742-4e4e-90eb-314a47f820fd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ffc3aff7-6816-4f0a-81df-c2c936e1067c"],
                },
              },
              {
                _uid: "ffc3aff7-6816-4f0a-81df-c2c936e1067c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "64ae392a-b5b5-4b34-a4af-3501b33fc750_46000620-9742-4e4e-90eb-314a47f820fd",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "664414d0-c2ab-4c24-af86-f9c893d893a1",
                component: "col",
                label:
                  "Requirement 4: Encrypt transmission of cardholder data across open, public networks",
                simplifiedLabel:
                  "Requirement 4: Encrypt transmission of cardholder data across open, public networks",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a380b08-78ae-4cfc-b05f-47636f6be980",
                component: "col",
                label: "4.1 (a)",
                simplifiedLabel: "4.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "825ddafe-89ba-4d34-9a56-62d4e2facbd3",
                component: "col",
                label: [
                  "Are strong cryptography and security protocols used to safeguard sensitive cardholder data during transmission over open, public networks?",
                  "Note: Examples of open, public networks include but are not limited to the Internet; wireless technologies, including 802.11 and Bluetooth; cellular technologies, for example, Global System for Mobile communications (GSM), Code division multiple access (CDMA); and General Packet Radio Service (GPRS).",
                ],
                simplifiedLabel: [
                  "Are strong cryptography and security protocols used to safeguard sensitive cardholder data during transmission over open, public networks?",
                  "Note: Examples of open, public networks include but are not limited to the Internet; wireless technologies, including 802.11 and Bluetooth; cellular technologies, for example, Global System for Mobile communications (GSM), Code division multiple access (CDMA); and General Packet Radio Service (GPRS).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dcdbb957-f134-4ef0-b71d-3313a86240ee",
                component: "col",
                label: [
                  "Review documented standards.",
                  "Review policies and procedures.",
                  "Review all locations where CHD is transmitted or received.",
                  "Examine system configurations.",
                ],
                simplifiedLabel: [
                  "Review documented standards.",
                  "Review policies and procedures.",
                  "Review all locations where CHD is transmitted or received.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3603c44e-0f86-4bae-8281-ddf77a0be95b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["33406373-017c-4e0f-94d3-810da088290e"],
                },
              },
              {
                _uid: "33406373-017c-4e0f-94d3-810da088290e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "929f8fa6-5fc2-46a3-8199-8234df5405e9_3603c44e-0f86-4bae-8281-ddf77a0be95b",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0a3061da-2a46-4f5e-9383-d42efcf63a84",
                component: "col",
                label: "4.1 (b)",
                simplifiedLabel: "4.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "cea2c0a8-0d0c-46a1-8899-0f15973b93de",
                component: "col",
                label: ["Are only trusted keys and/or certificates accepted?"],
                simplifiedLabel: [
                  "Are only trusted keys and/or certificates accepted?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15",
              },
              {
                _uid: "ad6ef0bc-c4b3-45ed-9dbd-7f9c2f0d1373",
                component: "col",
                label: [
                  "Observe inbound and outbound transmissions.",
                  "Examine keys and certificates.",
                ],
                simplifiedLabel: [
                  "Observe inbound and outbound transmissions.",
                  "Examine keys and certificates.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "181888b1-f411-41ff-a97a-9523c14e087f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["528c7274-b491-4e65-815a-6f9edc565e0f"],
                },
              },
              {
                _uid: "528c7274-b491-4e65-815a-6f9edc565e0f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ee092886-f753-4aa3-9667-ea81e4ee884a_181888b1-f411-41ff-a97a-9523c14e087f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "544cc9ea-36c5-4377-8d37-a56407eca1c2",
                component: "col",
                label: "4.1 (c)",
                simplifiedLabel: "4.1 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1a01c477-96bf-4f13-96ab-286df81d445b",
                component: "col",
                label: [
                  "Are security protocols implemented to use only secure configurations, and to not support insecure versions or configurations?",
                ],
                simplifiedLabel: [
                  "Are security protocols implemented to use only secure configurations, and to not support insecure versions or configurations?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b8431676-2c04-4e1d-b43f-06798969cbef",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "544e8aac-7d7a-46f3-a434-5b6556c2b531",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4bf56581-271c-4a86-9d56-b971b3433c8e"],
                },
              },
              {
                _uid: "4bf56581-271c-4a86-9d56-b971b3433c8e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c7a22c8e-db16-445d-9079-85dda9f3253e_544e8aac-7d7a-46f3-a434-5b6556c2b531",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1f3fa6b-8774-464e-9f29-62ab74313140",
                component: "col",
                label: "4.1 (d)",
                simplifiedLabel: "4.1 (d)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ca1dbdfa-8813-4b4a-a072-3cd59d1f0032",
                component: "col",
                label: [
                  "Is the proper encryption strength implemented for the encryption methodology in use (check vendor recommendations/best practices)?",
                ],
                simplifiedLabel: [
                  "Is the proper encryption strength implemented for the encryption methodology in use (check vendor recommendations/best practices)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c0fae880-6ee5-4b0b-a76a-2c922104bfae",
                component: "col",
                label: [
                  "Review vendor documentation.",
                  "Examine system configurations.",
                ],
                simplifiedLabel: [
                  "Review vendor documentation.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "072cd4df-970e-49e0-ab8d-71a1e25c1ce2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["906295f9-a116-4f44-81b4-4ba73765aecd"],
                },
              },
              {
                _uid: "906295f9-a116-4f44-81b4-4ba73765aecd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f9d042b9-5db3-4d24-80f5-a41af9527b98_072cd4df-970e-49e0-ab8d-71a1e25c1ce2",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "28953b68-8a6f-4f03-870e-084c3be23016",
                component: "col",
                label: "4.1 (e)",
                simplifiedLabel: "4.1 (e)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a55df6e6-5c0b-49eb-b7fb-e55abd69840d",
                component: "col",
                label: [
                  "For TLS implementations, is TLS enabled whenever cardholder data is transmitted or received?",
                ],
                simplifiedLabel: [
                  "For TLS implementations, is TLS enabled whenever cardholder data is transmitted or received?",
                ],
                labelWithUl: {
                  label: "For example, for browser-based implementations:",
                  simplifiedLabel:
                    "For example, for browser-based implementations:",
                  ul: [
                    "“HTTPS” appears as the browser Universal Record Locator (URL) protocol, and",
                    "Cardholder data is only requested if “HTTPS” appears as part of the URL.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4640cd28-b7e5-4f94-aaa9-c0ae9d16368d",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8e2e611a-de4a-4a9c-ab99-e19e2ea61a14",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d773f76c-4afa-443b-9447-aa6d4db71541"],
                },
              },
              {
                _uid: "d773f76c-4afa-443b-9447-aa6d4db71541",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "21d04351-a1d7-4ff1-8d0f-4c74261b22c8_8e2e611a-de4a-4a9c-ab99-e19e2ea61a14",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fbcacf4f-81f8-412d-8ff6-447617896899",
                component: "col",
                label: "4.2 (b)",
                simplifiedLabel: "4.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5143d3bb-f7f5-4ddb-813d-326eba6c3c68",
                component: "col",
                label: [
                  "Are policies in place that state that unprotected PANs are not to be sent via end-user messaging technologies?",
                ],
                simplifiedLabel: [
                  "Are policies in place that state that unprotected PANs are not to be sent via end-user messaging technologies?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "64d1fda4-c9a1-4c15-baf8-b06e5c4a8c55",
                component: "col",
                label: ["Review policies and procedures."],
                simplifiedLabel: ["Review policies and procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3b0b6886-fc61-4415-959d-f08db2c60496",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ad9707ba-d954-43f4-b7a9-226bb35c8d66"],
                },
              },
              {
                _uid: "ad9707ba-d954-43f4-b7a9-226bb35c8d66",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "8c676eaa-61df-4674-8600-f6784ec68847_3b0b6886-fc61-4415-959d-f08db2c60496",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "510eedfd-c432-4bc9-87af-2b8f64d70068",
                component: "col",
                label: "4.3",
                simplifiedLabel: "4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ac7b9834-58a4-4218-b14f-fc24a1c50007",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are security policies and operational procedures for encrypting transmissions of cardholder data:",
                  simplifiedLabel:
                    "Are security policies and operational procedures for encrypting transmissions of cardholder data:",
                  ul: [
                    "Documented",
                    "In use",
                    "Known to all affected parties?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "38c2fe2b-88a0-4414-9f4a-310ea25a79bb",
                component: "col",
                label: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "64a39f89-8d6c-4549-92c1-69cf2cfd9af4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3287c04c-db29-4a46-849f-538d0b4f8edf"],
                },
              },
              {
                _uid: "3287c04c-db29-4a46-849f-538d0b4f8edf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "cc0e0858-61a1-4240-83c5-fc9e3ded3f3d_64a39f89-8d6c-4549-92c1-69cf2cfd9af4",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c23c9dec-cb6b-432e-a21a-6a16f75bf028",
                component: "col",
                label: [
                  "Maintain a Vulnerability Management Program",
                  "Requirement 5: Protect all systems against malware and regularly update anti-virus software or programs",
                ],
                simplifiedLabel: [
                  "Maintain a Vulnerability Management Program",
                  "Requirement 5: Protect all systems against malware and regularly update anti-virus software or programs",
                ],
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f305dc1c-e7cb-4470-9cc3-d8b62984d8cc",
                component: "col",
                label: "5.1",
                simplifiedLabel: "5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "bef9201c-e481-459d-85b0-431a259c6b50",
                component: "col",
                label: [
                  "Is anti-virus software deployed on all systems commonly affected by malicious software?",
                ],
                simplifiedLabel: [
                  "Is anti-virus software deployed on all systems commonly affected by malicious software?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9a220954-fdc3-495f-b0ac-e804310337aa",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "35bff2f5-3e9a-417d-9b72-a02c547e64a5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["da6030fa-ad54-447b-9f41-64a7ccf0503c"],
                },
              },
              {
                _uid: "da6030fa-ad54-447b-9f41-64a7ccf0503c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4ce130e5-2fdf-4b46-8a27-fb6fe144c7ff_35bff2f5-3e9a-417d-9b72-a02c547e64a5",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2578e78f-803e-4409-914d-57a474608548",
                component: "col",
                label: "5.1.1",
                simplifiedLabel: "5.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5974ea34-7ef5-48c0-adbb-e9c59c8343e4",
                component: "col",
                label: [
                  "Are anti-virus programs capable of detecting, removing, and protecting against all known types of malicious software (for example, viruses, Trojans, worms, spyware, adware, and rootkits)?",
                ],
                simplifiedLabel: [
                  "Are anti-virus programs capable of detecting, removing, and protecting against all known types of malicious software (for example, viruses, Trojans, worms, spyware, adware, and rootkits)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c8a19e00-3823-4c9d-a774-8e97a7a5819c",
                component: "col",
                label: [
                  "Review vendor documentation.",
                  "Examine system configurations.",
                ],
                simplifiedLabel: [
                  "Review vendor documentation.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fdb0f7c0-cefb-4c6e-a7a8-f867ec4a4a0c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d16acb87-be4d-448f-aae6-0a3fe367b599"],
                },
              },
              {
                _uid: "d16acb87-be4d-448f-aae6-0a3fe367b599",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1685748a-c6d8-4a09-a8c5-f95b9a75bdd4_fdb0f7c0-cefb-4c6e-a7a8-f867ec4a4a0c",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "86a7f126-9e3b-489c-bcce-90d80dcb7b4d",
                component: "col",
                label: "5.1.2",
                simplifiedLabel: "5.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6edf28c0-2b58-4b87-817b-a68c39aeccff",
                component: "col",
                label: [
                  "Are periodic evaluations performed to identify and evaluate evolving malware threats in order to confirm whether those systems considered to not be commonly affected by malicious software continue as such?",
                ],
                simplifiedLabel: [
                  "Are periodic evaluations performed to identify and evaluate evolving malware threats in order to confirm whether those systems considered to not be commonly affected by malicious software continue as such?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c35e4aa4-4a04-4242-b139-112336c42f29",
                component: "col",
                label: ["Interview personnel."],
                simplifiedLabel: ["Interview personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6cbd0730-50a2-4f31-b9a8-3375e202e8e2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e9b15e55-c648-49d6-a17e-55ce84b09038"],
                },
              },
              {
                _uid: "e9b15e55-c648-49d6-a17e-55ce84b09038",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b3149221-d7fb-4c96-ad17-d0c4461d156b_6cbd0730-50a2-4f31-b9a8-3375e202e8e2",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4902e00d-33a2-430f-8c52-3c30e1faa4a8",
                component: "col",
                label: "5.2",
                simplifiedLabel: "5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9d84eed1-3ef2-47f1-aba7-6f084bcf2756",
                component: "col",
                label: ["Are all anti-virus mechanisms maintained as follows:"],
                simplifiedLabel: [
                  "Are all anti-virus mechanisms maintained as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "86bec282-4a74-4b10-9dd7-6f560a55e7fc",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2c86a918-24b4-4680-afe7-c37c3c74a989",
                component: "col",
                label: "5.2 (a)",
                simplifiedLabel: "5.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "60e9841e-68ca-481a-a217-e3a9d44a373e",
                component: "col",
                label: [
                  "Are all anti-virus software and definitions kept current?",
                ],
                simplifiedLabel: [
                  "Are all anti-virus software and definitions kept current?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3cca3cfb-1572-4b8c-84f3-48ac4f5b8f9a",
                component: "col",
                label: [
                  "Examine policies and procedures.",
                  "Examine anti-virus configurations, including the master installation.",
                  "Examine system components.",
                ],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine anti-virus configurations, including the master installation.",
                  "Examine system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "968973c0-2661-4a31-b37b-ef2e3bdac828",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["960a4717-93ea-49ab-ab73-193b0589b56e"],
                },
              },
              {
                _uid: "960a4717-93ea-49ab-ab73-193b0589b56e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "df1b7bc0-e236-42af-9e1d-a3c10f6dc954_968973c0-2661-4a31-b37b-ef2e3bdac828",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "16cebf85-4725-46ba-a172-d26ff2e2ba1d",
                component: "col",
                label: "5.2 (b)",
                simplifiedLabel: "5.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "00d58661-b4ec-4857-8823-971032046454",
                component: "col",
                label: [
                  "Are automatic updates and periodic scans enabled and being performed?",
                ],
                simplifiedLabel: [
                  "Are automatic updates and periodic scans enabled and being performed?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d20a7050-5595-47c6-85b9-dfd7c64cc752",
                component: "col",
                label: [
                  "Examine anti-virus configurations, including the master installation.",
                  "Examine system components.",
                ],
                simplifiedLabel: [
                  "Examine anti-virus configurations, including the master installation.",
                  "Examine system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1b86f982-70cf-4bb5-a1ca-1cb7684abe15",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["af7dc2ef-6f53-44f2-acb3-ac2787804099"],
                },
              },
              {
                _uid: "af7dc2ef-6f53-44f2-acb3-ac2787804099",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "cc644e9e-f77d-4db4-abcf-00564624859b_1b86f982-70cf-4bb5-a1ca-1cb7684abe15",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "62949ab9-14b9-4c34-a451-5338872ffe7b",
                component: "col",
                label: "5.2 (c)",
                simplifiedLabel: "5.2 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "39285459-1a18-4f56-bb6d-a78595693995",
                component: "col",
                label: [
                  "Are all anti-virus mechanisms generating audit logs, and are logs retained in accordance with PCI DSS Requirement 10.7?",
                ],
                simplifiedLabel: [
                  "Are all anti-virus mechanisms generating audit logs, and are logs retained in accordance with PCI DSS Requirement 10.7?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2a298b8b-041b-458b-b8d8-b433942c8306",
                component: "col",
                label: [
                  "Examine anti-virus configurations.",
                  "Review log retention processes.",
                ],
                simplifiedLabel: [
                  "Examine anti-virus configurations.",
                  "Review log retention processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a66eabeb-6d91-4bbc-ab99-53768e0b84a0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9173f628-08e6-4bfd-b5ee-d8f739501eea"],
                },
              },
              {
                _uid: "9173f628-08e6-4bfd-b5ee-d8f739501eea",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6bcee3ed-b502-41a6-bc76-01666b06794a_a66eabeb-6d91-4bbc-ab99-53768e0b84a0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "66d173a9-909e-4425-af08-86982b18915e",
                component: "col",
                label: "5.3 ",
                simplifiedLabel: "5.3 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "91626a6c-2ce7-43cf-a4ef-66250714ef44",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label: "Are all anti-virus mechanisms:",
                  simplifiedLabel: "Are all anti-virus mechanisms:",
                  ul: [
                    "Actively running?",
                    "Unable to be disabled or altered by users?",
                  ],
                  pr: "Note: Anti-virus solutions may be temporarily disabled only if there is legitimate technical need, as authorized by management on a case-by-case basis. If anti-virus protection needs to be disabled for a specific purpose, it must be formally authorized. Additional security measures may also need to be implemented for the period of time during which anti-virus protection is not active.",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "aea274e0-dd88-4e7f-beb8-b495fdf2eaab",
                component: "col",
                label: [
                  "Examine anti-virus configurations.",
                  "Examine system components.",
                  "Observe processes.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Examine anti-virus configurations.",
                  "Examine system components.",
                  "Observe processes.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d0b53f54-61bd-4407-a977-43380cb0062a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["7e229631-1309-4fe8-9e6b-61bec79136e1"],
                },
              },
              {
                _uid: "7e229631-1309-4fe8-9e6b-61bec79136e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3c173b8b-e932-46fa-b2c6-fcc1c0d3b27d_d0b53f54-61bd-4407-a977-43380cb0062a",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "edd7c9ea-4292-472d-bbba-0c223d174db6",
                component: "col",
                label: "5.4 ",
                simplifiedLabel: "5.4 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "558af194-ad82-4903-8b0a-e84438d9b667",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label:
                    "Are security policies and operational procedures for protecting systems against malware:",
                  simplifiedLabel:
                    "Are security policies and operational procedures for protecting systems against malware:",
                  ul: [
                    "Documented",
                    "In use",
                    "Known to all affected parties?",
                  ],
                  pr: "",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "93a97ccc-04c7-4627-b62f-1b8cf1395901",
                component: "col",
                label: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "77e263e0-b0cc-4a7d-b0b8-161938269b95",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["dd14a988-c535-46e7-b03a-af03e9549843"],
                },
              },
              {
                _uid: "dd14a988-c535-46e7-b03a-af03e9549843",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d365ac1d-660a-45d0-a6eb-7c192b277e7b_77e263e0-b0cc-4a7d-b0b8-161938269b95",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "00e67331-3031-4245-8ee2-e011e5bfbc4a",
                component: "col",
                label:
                  "Requirement 6: Develop and maintain secure systems and applications",
                simplifiedLabel:
                  "Requirement 6: Develop and maintain secure systems and applications",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "950832bd-5f36-4c9b-a0e1-c634b7a000ce",
                component: "col",
                label: "6.1",
                simplifiedLabel: "6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b17c4d45-ebd7-4974-bbe1-5f4c354874f4",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label:
                    "Is there a process to identify security vulnerabilities, including the following:",
                  simplifiedLabel:
                    "Is there a process to identify security vulnerabilities, including the following:",
                  ul: [
                    "Using reputable outside sources for vulnerability information?",
                    "Assigning a risk ranking to vulnerabilities that includes identification of all “high” risk and “critical” vulnerabilities?",
                  ],
                },
                noteBelowLabelWithUl: {
                  label: [
                    "Note: Risk rankings should be based on industry best practices as well as consideration of potential impact. For example, criteria for ranking vulnerabilities may include consideration of the CVSS base score and/or the classification by the vendor, and/or type of systems affected.",
                    "Methods for evaluating vulnerabilities and assigning risk ratings will vary based on an organization’s environment and risk assessment trategy. Risk rankings should, at a minimum, identify all vulnerabilities considered to be a “high risk” to the environment. In addition to he risk ranking, vulnerabilities may be considered “critical” if they pose an imminent threat to the environment, impact  critical systems, and/or would result in a potential  compromise if not addressed. Examples of critical systems may include security systems, public-facing devices and systems, databases, and other systems that store, process or transmit cardholder data.",
                  ],
                  simplifiedLabel: [
                    "Note: Risk rankings should be based on industry best practices as well as consideration of potential impact. For example, criteria for ranking vulnerabilities may include consideration of the CVSS base score and/or the classification by the vendor, and/or type of systems affected.",
                    "Methods for evaluating vulnerabilities and assigning risk ratings will vary based on an organization’s environment and risk assessment trategy. Risk rankings should, at a minimum, identify all vulnerabilities considered to be a “high risk” to the environment. In addition to he risk ranking, vulnerabilities may be considered “critical” if they pose an imminent threat to the environment, impact  critical systems, and/or would result in a potential  compromise if not addressed. Examples of critical systems may include security systems, public-facing devices and systems, databases, and other systems that store, process or transmit cardholder data.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "358d409a-543f-47ec-b40a-08b9a0ef84b7",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "55179859-8745-4dc4-aba7-143e551a0ed9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["42a99986-d572-4d41-9dcf-25c47448eb96"],
                },
              },
              {
                _uid: "42a99986-d572-4d41-9dcf-25c47448eb96",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "89fbf4ea-082a-4665-9367-841ebd4c4f5f_55179859-8745-4dc4-aba7-143e551a0ed9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5ae890f1-6abe-4bc3-a57c-b9bfe0041e62",
                component: "col",
                label: "6.2 (a)",
                simplifiedLabel: "6.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e866110a-7b70-464c-ba83-0212858689be",
                component: "col",
                label: [
                  "Are all system components and software protected from known vulnerabilities by installing applicable vendor-supplied security patches?",
                ],
                simplifiedLabel: [
                  "Are all system components and software protected from known vulnerabilities by installing applicable vendor-supplied security patches?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "33143d58-fb0c-4a8f-ae2f-07719d84b02b",
                component: "col",
                label: ["Review policies and procedures."],
                simplifiedLabel: ["Review policies and procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3506e5f5-659f-4d05-86b5-595c62edb986",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["76fc1c60-13d4-4d69-9900-53376986b75e"],
                },
              },
              {
                _uid: "76fc1c60-13d4-4d69-9900-53376986b75e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3475f34f-bb52-4b2d-8add-e03a5f4191c6_3506e5f5-659f-4d05-86b5-595c62edb986",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b3dee238-326d-47b6-898d-f98696c3cd92",
                component: "col",
                label: "6.2 (b)",
                simplifiedLabel: "6.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4c3adee4-b21b-4904-bc6b-acd8d3a6bdc2",
                component: "col",
                label: [
                  "Are critical security patches installed within one month of release?",
                  "Note: Critical security patches should be identified according to the risk ranking process defined in Requirement 6.1.",
                ],
                simplifiedLabel: [
                  "Are critical security patches installed within one month of release?",
                  "Note: Critical security patches should be identified according to the risk ranking process defined in Requirement 6.1.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9543256e-c9c1-497b-80bc-abbdd800413d",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Examine system components.",
                  "Compare list of security patches installed to recent vendor patch lists.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Examine system components.",
                  "Compare list of security patches installed to recent vendor patch lists.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "522983ba-f692-4c0c-bf21-f4ebd649fe51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e38d2892-2180-402e-ae7e-227dbe2eb336"],
                },
              },
              {
                _uid: "e38d2892-2180-402e-ae7e-227dbe2eb336",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "07a4a86e-4a59-4ce4-be6f-d2078bc77927_522983ba-f692-4c0c-bf21-f4ebd649fe51",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b747f5a2-cff5-4cbc-bc8a-2ea4c44def74",
                component: "col",
                label: "6.4.5 (a)",
                simplifiedLabel: "6.4.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d3a9a01d-6302-4418-b89b-996d266ca34b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are change-control procedures documented and require the following?",
                  simplifiedLabel:
                    "Are change-control procedures documented and require the following?",
                  ul: [
                    "Documentation of impact",
                    "Documented change control approval by authorized parties",
                    "Functionality testing to verify that the change does not adversely impact the security of the system",
                    "Back-out procedures",
                  ],
                  pr: "",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2e2b40bf-595d-4602-8ec4-df7a8a8b8573",
                component: "col",
                label: ["Review change control processes and procedures."],
                simplifiedLabel: [
                  "Review change control processes and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "51b78ab4-93a1-4565-8cac-1414f056fc8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["dfa0d7e9-1dfa-4a77-b2a5-b110f5c186e9"],
                },
              },
              {
                _uid: "dfa0d7e9-1dfa-4a77-b2a5-b110f5c186e9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4fc3fa83-d2d0-44fa-a7ed-422e11389be9_51b78ab4-93a1-4565-8cac-1414f056fc8e",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "55c009a6-bc8f-4ca2-96fa-c718f4c02301",
                component: "col",
                label: "6.4.5 (b)",
                simplifiedLabel: "6.4.5 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f6aaca71-90b8-433e-b629-bcc1e90216cf",
                component: "col",
                label:
                  "Are the following performed and documented for all changes:",
                simplifiedLabel:
                  "Are the following performed and documented for all changes:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "89006716-00e4-4569-8952-47282d8bf8c1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d5a11cf6-ffc8-41d0-895c-a9961576da88",
                component: "col",
                label: "6.4.5.1",
                simplifiedLabel: "6.4.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "91a6db11-40ff-47a2-8562-03a5586a88dd",
                component: "col",
                label: "Documentation of impact?",
                simplifiedLabel: "Documentation of impact?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "aaf5eb64-f80a-44b7-b67c-a1067990f860",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a49b1ade-b47a-46f0-bb04-d2971e92fd11",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["0a4e1d4f-e33b-4126-912d-a23de5986903"],
                },
              },
              {
                _uid: "0a4e1d4f-e33b-4126-912d-a23de5986903",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "80275a19-d3d9-4461-8f5a-50b56ab8c231_a49b1ade-b47a-46f0-bb04-d2971e92fd11",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "13dfca65-0f1d-4bfb-8884-bdf077431473",
                component: "col",
                label: "6.4.5.2",
                simplifiedLabel: "6.4.5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b8449319-ae4b-40a7-9340-e2afdfa5f13d",
                component: "col",
                label: "Documented approval by authorized parties?",
                simplifiedLabel: "Documented approval by authorized parties?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3809740e-ab20-410b-a274-c97506c894b4",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0ec6548f-227f-4bf3-acd5-3d60baff466a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["31058471-8014-4e6f-a31b-334a8c954c0d"],
                },
              },
              {
                _uid: "31058471-8014-4e6f-a31b-334a8c954c0d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "0a01aae7-bb9f-4cd5-b7fa-a42c40b58ce0_0ec6548f-227f-4bf3-acd5-3d60baff466a",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "08f38348-34b0-4d41-8999-bbcf211e1965",
                component: "col",
                label: "6.4.5.3 (a)",
                simplifiedLabel: "6.4.5.3 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "cbedb63b-5882-4363-bcf8-471a0cb7b2df",
                component: "col",
                label:
                  "Functionality testing to verify that the change does not adversely impact the security of the system?",
                simplifiedLabel:
                  "Functionality testing to verify that the change does not adversely impact the security of the system?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "622366b8-e0da-407d-b937-c64d59d79601",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "77bd78b2-9c01-402e-9649-7a4af4e8f285",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["183e5210-67d6-49a0-8500-e940aefd5178"],
                },
              },
              {
                _uid: "183e5210-67d6-49a0-8500-e940aefd5178",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "75b5d8d5-a2f9-4290-b22d-2768a970fa96_77bd78b2-9c01-402e-9649-7a4af4e8f285",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f0294b1b-2d58-4adc-8ad3-1bfab0c1375f",
                component: "col",
                label: "6.4.5.3 (b)",
                simplifiedLabel: "6.4.5.3 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b2c89535-093e-4d50-9020-9ea1cba130f5",
                component: "col",
                label:
                  "For custom code changes, testing of updates for compliance with PCI DSS Requirement 6.5 before being deployed into production?",
                simplifiedLabel:
                  "For custom code changes, testing of updates for compliance with PCI DSS Requirement 6.5 before being deployed into production?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4ae891bc-41b6-4cea-b660-7061532c2842",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "730b2cf2-a4b5-4982-b583-ce569175d636",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d29d8d35-431b-49ad-b9cf-165a38447530"],
                },
              },
              {
                _uid: "d29d8d35-431b-49ad-b9cf-165a38447530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ef34b149-7254-46d2-ad15-7b1a3ede693c_730b2cf2-a4b5-4982-b583-ce569175d636",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "227aadc0-2b80-469b-aade-c41e2d38c4c2",
                component: "col",
                label: "6.4.5.4",
                simplifiedLabel: "6.4.5.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "956edc73-4ef3-43ef-99f8-b47088dcc88c",
                component: "col",
                label: "Back-out procedures?",
                simplifiedLabel: "Back-out procedures?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7afc66a3-73b0-4d8f-a18a-acf81977cf1d",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d5d47dfc-18c6-43b2-8fcf-b6c220b83934",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9ef7e0e4-f3f8-440c-a533-f3e1193482f5"],
                },
              },
              {
                _uid: "9ef7e0e4-f3f8-440c-a533-f3e1193482f5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2e11cc2c-08a8-403f-b752-fd35917352cf_d5d47dfc-18c6-43b2-8fcf-b6c220b83934",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "43ed9f5a-7496-4e7b-8675-7d4af7e2110b",
                component: "col",
                label: "6.4.6",
                simplifiedLabel: "6.4.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "383fd575-a184-427b-a708-9270635939f2",
                component: "col",
                label: [
                  "Upon completion of a significant change, are all relevant PCI DSS requirements implemented on all new or changed systems and networks, and documentation updated as applicable?",
                ],
                simplifiedLabel: [
                  "Upon completion of a significant change, are all relevant PCI DSS requirements implemented on all new or changed systems and networks, and documentation updated as applicable?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ace19575-4629-4052-b7eb-47fa2be4f4be",
                component: "col",
                label: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                  "Interview personnel.",
                  "Observe affected systems or networks.",
                ],
                simplifiedLabel: [
                  "Trace changes to change control documentation.",
                  "Examine change control documentation.",
                  "Interview personnel.",
                  "Observe affected systems or networks.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ae9e7021-dd7b-42bd-a3dc-2f11889fa4bf",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["815834a3-1cc6-4d03-afee-2aaa46004c33"],
                },
              },
              {
                _uid: "815834a3-1cc6-4d03-afee-2aaa46004c33",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b8717e5e-9df8-431c-b145-c50fa970569e_ae9e7021-dd7b-42bd-a3dc-2f11889fa4bf",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4392b908-b151-4b0c-8849-ac8dc18bfe5e",
                component: "col",
                label: "6.5 (a)",
                simplifiedLabel: "6.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "813d15d2-78a5-4efc-a03c-da7cd0bbd558",
                component: "col",
                label:
                  "Do software-development processes address common coding vulnerabilities?",
                simplifiedLabel:
                  "Do software-development processes address common coding vulnerabilities?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "116d1350-d37a-41ba-ae54-9dcc026edef4",
                component: "col",
                label: ["Review software-development policies and procedures."],
                simplifiedLabel: [
                  "Review software-development policies and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8925c38f-2de5-4001-acec-f0b72739cabb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["b9f9573f-c098-474b-ba5c-9a3e733ab65a"],
                },
              },
              {
                _uid: "b9f9573f-c098-474b-ba5c-9a3e733ab65a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a3d09894-830f-4d80-b1ff-efcc8c4943d4_8925c38f-2de5-4001-acec-f0b72739cabb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d128ff1a-9e77-4ba4-ac3a-0058ed41c822",
                component: "col",
                label: "6.5 (b)",
                simplifiedLabel: "6.5 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dc99bbfb-ad0e-447e-abd0-28540ab7e446",
                component: "col",
                label:
                  "Are developers trained at least annually in up-to-date secure coding techniques, including how to avoid common coding vulnerabilities?",
                simplifiedLabel:
                  "Are developers trained at least annually in up-to-date secure coding techniques, including how to avoid common coding vulnerabilities?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1a40df5a-62ef-425b-8c29-e175218fa4d3",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Examine training records.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Examine training records.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "97d36e0e-784c-4eb0-8a91-aac40641b923",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["382743b1-281d-4319-8cfd-8716f19adafa"],
                },
              },
              {
                _uid: "382743b1-281d-4319-8cfd-8716f19adafa",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a66e40f0-a76c-4ef1-8f07-75fafe93ef10_97d36e0e-784c-4eb0-8a91-aac40641b923",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "de7c6177-b2ae-4ea2-b6c3-79267bd682fa",
                component: "col",
                label: "6.5 (c)",
                simplifiedLabel: "6.5 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "baa03c15-f54a-4e24-aba7-67ccf2024656",
                component: "col",
                label: [
                  "Are applications developed based on secure coding guidelines to protect applications from, at a minimum, the following vulnerabilities:",
                ],
                simplifiedLabel: [
                  "Are applications developed based on secure coding guidelines to protect applications from, at a minimum, the following vulnerabilities:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "07242e6e-946e-4bb2-87c5-0e4437131690",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "830630b8-95ba-41e9-9f44-3eeec1f6ec87",
                component: "col",
                label: "6.5.1",
                simplifiedLabel: "6.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "18545277-6b8b-40e0-9e1b-9f00e4d952b2",
                component: "col",
                label: [
                  "Do coding techniques address injection flaws, particularly SQL injection?",
                  "Note: Also consider OS Command Injection, LDAP and XPath injection flaws as well as other injection flaws.",
                ],
                simplifiedLabel: [
                  "Do coding techniques address injection flaws, particularly SQL injection?",
                  "Note: Also consider OS Command Injection, LDAP and XPath injection flaws as well as other injection flaws.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f796aae7-639a-48f4-9aa0-8fe45149f2a7",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5ef1aee2-0695-42d4-9a24-86190eefddaf",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2f91cb2a-568c-4381-ae1b-87dc1eea8882"],
                },
              },
              {
                _uid: "2f91cb2a-568c-4381-ae1b-87dc1eea8882",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "db97401c-3804-4d93-8c77-cd0292b01eac_5ef1aee2-0695-42d4-9a24-86190eefddaf",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5ed2299b-61bc-4f36-8abc-c265224ff86e",
                component: "col",
                label: "6.5.2",
                simplifiedLabel: "6.5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6f1719af-54a4-4d92-b6f8-d07f09ad5fde",
                component: "col",
                label: [
                  "Do coding techniques address buffer overflow vulnerabilities?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address buffer overflow vulnerabilities?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4a798aeb-2fd5-4cee-a8fc-742af8b9ba63",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7a160322-0c59-4da1-a07b-9714645e57ce",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["51bbfad7-b343-4293-90cf-d2606d34da0f"],
                },
              },
              {
                _uid: "51bbfad7-b343-4293-90cf-d2606d34da0f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f7020a51-6a55-4f67-a144-0a3dce149f45_7a160322-0c59-4da1-a07b-9714645e57ce",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ca7d89b2-aafa-4e36-b40e-48dfc3a5b9be",
                component: "col",
                label: "6.5.4",
                simplifiedLabel: "6.5.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "39591c86-d43b-42df-8e07-d16d8f8097c9",
                component: "col",
                label: [
                  "Do coding techniques address insecure communications?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address insecure communications?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "69449b5e-8866-4a61-a794-d2a5652bbc27",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "72d4eb35-26f1-4df7-bec0-f66e989c6fdb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["bb224aac-5a8b-4ecd-a9de-086e89d8b59a"],
                },
              },
              {
                _uid: "bb224aac-5a8b-4ecd-a9de-086e89d8b59a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3170610f-973f-4401-a014-44add914abcb_72d4eb35-26f1-4df7-bec0-f66e989c6fdb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "67e10d15-ef83-410e-813e-ee690ca99ff6",
                component: "col",
                label: "6.5.5",
                simplifiedLabel: "6.5.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "16a719d1-fc8f-4985-860b-955c3cd7eb69",
                component: "col",
                label: [
                  "Do coding techniques address improper error handling?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address improper error handling?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7a9d3d49-a6be-4dbb-8e10-d0839b0c5aee",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "de89a8a1-983f-458a-8cdb-c52bde53ffd6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e90672c4-fa17-44b3-968b-1fe75b4a84a4"],
                },
              },
              {
                _uid: "e90672c4-fa17-44b3-968b-1fe75b4a84a4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "924f9a65-4ef2-4be8-b6e7-0eff7ed1b77b_de89a8a1-983f-458a-8cdb-c52bde53ffd6",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d24e1405-78f0-4a20-a818-50e119a08219",
                component: "col",
                label: "6.5.6",
                simplifiedLabel: "6.5.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d1e81b98-f1af-45f2-9ce8-c978414bb1ee",
                component: "col",
                label: [
                  "Do coding techniques address all “high risk” vulnerabilities identified in the vulnerability identification process (as defined in PCI DSS Requirement 6.1)?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address all “high risk” vulnerabilities identified in the vulnerability identification process (as defined in PCI DSS Requirement 6.1)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "069e94fa-7467-4688-8e01-d6dd9d6c065d",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6d5107c7-c29d-48d0-9f7b-ca54d6983a44",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9ddd1422-bffc-425b-aecc-212e21b2f978"],
                },
              },
              {
                _uid: "9ddd1422-bffc-425b-aecc-212e21b2f978",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "697ed40e-e0bc-4eed-983c-6518207fe313_6d5107c7-c29d-48d0-9f7b-ca54d6983a44",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a00b4e5-4c73-49f8-b55c-234e47d39810",
                component: "col",
                label: "SL from PDF",
                simplifiedLabel: "SL from PDF",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "021629bf-c867-489c-9dc7-49a6f1a0fd52",
                component: "col",
                label: [
                  "For web applications and application interfaces (internal or external), are applications developed based on secure coding guidelines to protect applications from the following additional vulnerabilities:",
                ],
                simplifiedLabel: [
                  "For web applications and application interfaces (internal or external), are applications developed based on secure coding guidelines to protect applications from the following additional vulnerabilities:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dbc93ec1-8f71-4244-afdf-ce5df9908023",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d6d05b0c-ea16-42dc-946a-9b3eb4cd9b08",
                component: "col",
                label: "6.5.7",
                simplifiedLabel: "6.5.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8e46f654-b4d6-4ad8-83ff-1270a63195c7",
                component: "col",
                label: [
                  "Do coding techniques address cross-site scripting (XSS) vulnerabilities?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address cross-site scripting (XSS) vulnerabilities?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dafba9a7-3447-41d2-903b-0f145c00503f",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0b704929-226b-4492-832c-cd850ca0262e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["857db77b-77ab-4e32-8e84-394598a9b668"],
                },
              },
              {
                _uid: "857db77b-77ab-4e32-8e84-394598a9b668",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7ffda4a7-1eb0-446f-9ca7-f7825636683f_0b704929-226b-4492-832c-cd850ca0262e",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d759c75a-f569-474f-ac3b-e46aee5deef6",
                component: "col",
                label: "6.5.8 ",
                simplifiedLabel: "6.5.8 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0953d5a7-ef48-4008-b2f5-fd813c6c0b67",
                component: "col",
                label: [
                  "Do coding techniques address improper access control such as insecure direct object references, failure to restrict URL access, directory traversal, and failure to restrict user access to functions?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address improper access control such as insecure direct object references, failure to restrict URL access, directory traversal, and failure to restrict user access to functions?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0875e024-c3dc-4cfc-8690-c5a555132982",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "168d0588-b43b-462d-89f7-375171bda560",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8a080028-06f7-4855-b0bd-8726948f080e"],
                },
              },
              {
                _uid: "8a080028-06f7-4855-b0bd-8726948f080e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "cb4a3d49-5c55-4176-848b-e8c959fb69bf_168d0588-b43b-462d-89f7-375171bda560",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "de214308-f6bf-48f9-99cc-a2587fdd488a",
                component: "col",
                label: "6.5.9",
                simplifiedLabel: "6.5.9",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d01aceef-9c24-4182-bb45-db85e9320d8b",
                component: "col",
                label: [
                  "Do coding techniques address cross-site request forgery (CSRF)?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address cross-site request forgery (CSRF)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "549dc8ee-3d9c-4e1b-8d6f-e7a774b19d79",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b5d8501a-34a7-4264-be99-2876518edc6a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c4b6b727-af69-4d76-928b-b9bb0c2f5ae6"],
                },
              },
              {
                _uid: "c4b6b727-af69-4d76-928b-b9bb0c2f5ae6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a7f661a7-a197-4228-be56-1b588a00d3d8_b5d8501a-34a7-4264-be99-2876518edc6a",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd6d492b-a63b-47ca-b7f7-1a68c9ca535e",
                component: "col",
                label: "6.5.10",
                simplifiedLabel: "6.5.10",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a4fd5a52-303a-4d2a-af8d-c04d6d40d32f",
                component: "col",
                label: [
                  "Do coding techniques address broken authentication and session management?",
                ],
                simplifiedLabel: [
                  "Do coding techniques address broken authentication and session management?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "669ff734-c0ea-45e3-adc8-5f7a315b1032",
                component: "col",
                label: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine software-development policies and procedures.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8e5d49f1-418a-4a46-8441-53b58047d4da",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["15fa1b83-1d7a-452d-b43b-abd300e0476e"],
                },
              },
              {
                _uid: "15fa1b83-1d7a-452d-b43b-abd300e0476e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1118a25b-a4aa-4d73-8b67-922af202ee20_8e5d49f1-418a-4a46-8441-53b58047d4da",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6a6e56cf-b866-49e3-bcd9-36bf57fe07fb",
                component: "col",
                label: "6.6",
                simplifiedLabel: "6.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "35246a55-1b72-421d-bc67-941270ec2ced",
                component: "col",
                label: [
                  "For public-facing web applications, are new threats and vulnerabilities addressed on an ongoing basis, and are these applications protected against known attacks by applying either of the following methods?",
                ],
                simplifiedLabel: [
                  "For public-facing web applications, are new threats and vulnerabilities addressed on an ongoing basis, and are these applications protected against known attacks by applying either of the following methods?",
                ],
                labelWithUl: {
                  label:
                    "Reviewing public-facing web applications via manual or automated application vulnerability security assessment tools or methods, as follows:",
                  simplifiedLabel:
                    "Reviewing public-facing web applications via manual or automated application vulnerability security assessment tools or methods, as follows:",
                  ul: [
                    "At least annually",
                    "After any changes",
                    "By an organization that specializes in application security",
                    "That, at a minimum, all vulnerabilities in Requirement 6.5 are included in the assessment",
                    "That all vulnerabilities are corrected",
                    "That the application is re-evaluated after the corrections",
                  ],
                  pr: [
                    "Note: This assessment is not the same as the vulnerability scans performed for Requirement 11.2.",
                    "– OR –",
                    "Installing an automated technical solution that detects and prevents web-based attacks (for example, a web-application firewall) as follows:",
                    "Is situated in front of public-facing web applications to detect and prevent web-based attacks.",
                    "Is actively running and up to date as applicable.",
                    "Is generating audit logs.",
                    "Is configured to either block web-based attacks, or generate an alert that is immediately investigated.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "144da6ef-6d2f-48fa-a3ec-f79bd48d00a3",
                component: "col",
                label: [
                  "Review documented processes.",
                  "Interview personnel.",
                  "Examine records of application security assessments.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review documented processes.",
                  "Interview personnel.",
                  "Examine records of application security assessments.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3855a235-c964-4c10-862d-ef2aa9db5279",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2d42ff3b-42bc-4418-ac05-cbb429400caf"],
                },
              },
              {
                _uid: "2d42ff3b-42bc-4418-ac05-cbb429400caf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "245a36e8-8100-4c8d-92ed-b8253c8c52ad_3855a235-c964-4c10-862d-ef2aa9db5279",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "61cd9cfa-6439-4872-ad4e-8890112df1e0",
                component: "col",
                label: "6.7 ",
                simplifiedLabel: "6.7 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "aa2dc4b3-35e3-492a-b638-65364c26089a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are security policies and operational procedures for developing and maintaining secure systems and applications:",
                  simplifiedLabel:
                    "Are security policies and operational procedures for developing and maintaining secure systems and applications:",
                  ul: [
                    "Documented",
                    "In use",
                    "Known to all affected parties?",
                  ],
                  pr: "",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7773e9c8-671f-4541-b016-52b122ce6216",
                component: "col",
                label: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review security policies and operational procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e01c8070-8535-49a7-9ed9-03e1f9963b0f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["5b3345b9-f6fe-4b91-8278-1acd11709561"],
                },
              },
              {
                _uid: "5b3345b9-f6fe-4b91-8278-1acd11709561",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "67491d6f-74e9-4ad4-9649-f529ad482bca_e01c8070-8535-49a7-9ed9-03e1f9963b0f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "576555bc-12a8-4726-a23a-8a153e2b1f82",
                component: "col",
                label: "Implement Strong Access Control Measures",
                simplifiedLabel:
                  "Requirement 7: Restrict access to cardholder data by business need to know",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7fdcf791-d81b-43e6-bb34-57e887f4bbfc",
                component: "col",
                label: "7.1",
                simplifiedLabel: "7.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a81bdefc-795c-49fe-b27e-e934c70f05bb",
                component: "col",
                label: [
                  "Is access to system components and cardholder data limited to only those individuals whose jobs require such access, as follows: ",
                ],
                simplifiedLabel: [
                  "Is access to system components and cardholder data limited to only those individuals whose jobs require such access, as follows: ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f54ee22f-e187-4e11-be2d-0ff81b67afc7",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5d109c21-539e-464e-bbfc-bc6ad9e79a29",
                component: "col",
                label: "7.1.2",
                simplifiedLabel: "7.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7f489f71-92e2-4005-bb49-262365ca31ae",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Is access to privileged user IDs restricted as follows:",
                  simplifiedLabel:
                    "Is access to privileged user IDs restricted as follows:",
                  ul: [
                    "To least privileges necessary to perform job responsibilities?",
                    "Assigned only to roles that specifically require that privileged access?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a236637e-9a85-46d6-8856-20b0fc40ba4c",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Interview management",
                  "Review privileged user IDs",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Interview management",
                  "Review privileged user IDs",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "10969aa3-4215-4796-b026-bcdacf700fa8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f86c2773-d8fd-4116-bb57-1d03f8deed4c"],
                },
              },
              {
                _uid: "f86c2773-d8fd-4116-bb57-1d03f8deed4c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9ffdb026-565d-4ed6-b9be-b9ba533fcc5a_10969aa3-4215-4796-b026-bcdacf700fa8",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9942a7fa-7b8b-475c-892e-80ecd1999e74",
                component: "col",
                label: "7.1.3",
                simplifiedLabel: "7.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e64594b5-3e61-4a82-aab8-3259343f2f63",
                component: "col",
                label:
                  "Is access assigned based on individual personnel’s job classification and function?",
                simplifiedLabel:
                  "Is access assigned based on individual personnel’s job classification and function?",
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "269b6e21-3adf-41a9-b2a3-796bb9db907f",
                component: "col",
                label: ["Interview management", "Review user IDs"],
                simplifiedLabel: ["Interview management", "Review user IDs"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dab70a0e-b875-4a71-8471-202c6367dbf1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2d8fbe7b-0b17-40be-b80a-8030759437a6"],
                },
              },
              {
                _uid: "2d8fbe7b-0b17-40be-b80a-8030759437a6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "0b48209c-c868-4c97-83e9-cb64eea4f610_dab70a0e-b875-4a71-8471-202c6367dbf1",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6123628d-e471-4eb6-86ba-f52d2b5610d0",
                component: "col",
                label: "7.1.4",
                simplifiedLabel: "7.1.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1282dfc3-3461-42a3-84b4-796e1319c621",
                component: "col",
                label:
                  "Is documented approval by authorized parties required, specifying required privileges?",
                simplifiedLabel:
                  "Is documented approval by authorized parties required, specifying required privileges?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "374cffc9-6e0e-40a0-b72b-24a7859dfe21",
                component: "col",
                label: [
                  "Review user IDs.",
                  "Compare with documented approvals.",
                  "Compare assigned privileges with documented approvals.",
                ],
                simplifiedLabel: [
                  "Review user IDs.",
                  "Compare with documented approvals.",
                  "Compare assigned privileges with documented approvals.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ffa5c75b-9038-410c-b4e8-127a47d21f62",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2e1f0531-4a82-427e-97cb-956e6f0f9138"],
                },
              },
              {
                _uid: "2e1f0531-4a82-427e-97cb-956e6f0f9138",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9e3e9f16-e0da-4015-b23a-39bf2c2c16a0_ffa5c75b-9038-410c-b4e8-127a47d21f62",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5b90e383-4432-4e8c-a1de-f01fc4116859",
                component: "col",
                label:
                  "Requirement 8: Identify and authenticate access to system components",
                simplifiedLabel:
                  "Requirement 8: Identify and authenticate access to system components",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "52f4ca3a-5b5e-45c2-a3ba-226e4deee5b9",
                component: "col",
                label: "8.1",
                simplifiedLabel: "8.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c9fc16f0-4894-48b7-a18c-8b40c0398f13",
                component: "col",
                label: [
                  "Are policies and procedures for user identification management controls defined and in place for nonconsumer users and administrators on all system components, as follows:",
                ],
                simplifiedLabel: [
                  "Are policies and procedures for user identification management controls defined and in place for nonconsumer users and administrators on all system components, as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "80d06ca9-120c-483e-ae01-9efc264b32f2",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a84c169-a18b-4920-995f-4b43e5387b08",
                component: "col",
                label: "8.1.1",
                simplifiedLabel: "8.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a81bdefc-795c-49fe-b27e-e934c70f05bb",
                component: "col",
                label: [
                  "Are all users assigned a unique ID before allowing them to access system components or cardholder data?",
                ],
                simplifiedLabel: [
                  "Are all users assigned a unique ID before allowing them to access system components or cardholder data?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2848b703-71fe-49fd-a9f6-380c71a952e7",
                component: "col",
                label: ["Review password procedures.", "Interview personnel."],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "07e49119-94d7-4cc9-b0f0-36a45ffcc1b4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["611ab5df-44ec-46ad-aedb-d36932951f1b"],
                },
              },
              {
                _uid: "611ab5df-44ec-46ad-aedb-d36932951f1b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "721eb9ce-9e5a-4c57-b85e-68e37b74f128_07e49119-94d7-4cc9-b0f0-36a45ffcc1b4",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "971bcfba-0550-436e-8173-94cee7c075d1",
                component: "col",
                label: "8.1.2",
                simplifiedLabel: "8.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "99cbafc5-b0b4-463d-8bc2-abb06b3c6ac0",
                component: "col",
                label:
                  "Are additions, deletions, and modifications of user IDs, credentials, and other identifier objects controlled such that user IDs are implemented only as authorized (including with specified privileges)?",
                simplifiedLabel:
                  "Are additions, deletions, and modifications of user IDs, credentials, and other identifier objects controlled such that user IDs are implemented only as authorized (including with specified privileges)?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fb26ebfb-1fd0-4974-a09c-d8d1ddfbf7d1",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Examine privileged and general user IDs and associated authorizations.",
                  "Observe system settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Examine privileged and general user IDs and associated authorizations.",
                  "Observe system settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d0af901d-9169-4939-8be2-321b9bb54772",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["5c8d4abb-d92d-45d6-a7c3-b7f6fa5329c9"],
                },
              },
              {
                _uid: "5c8d4abb-d92d-45d6-a7c3-b7f6fa5329c9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d9fc2c3f-9385-4485-bed5-b0e70542eeb9_d0af901d-9169-4939-8be2-321b9bb54772",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9ec1b07e-f4f5-400a-8570-66250ed793a9",
                component: "col",
                label: "8.1.3",
                simplifiedLabel: "8.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a9944349-ed25-4bc6-9b1b-cd2aed138a75",
                component: "col",
                label:
                  "Is access for any terminated users immediately deactivated or removed?",
                simplifiedLabel:
                  "Is access for any terminated users immediately deactivated or removed?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fcf79d2c-5dd8-4f81-aea1-fb8e02a9b158",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Examine terminated users accounts.",
                  "Review current access lists.",
                  "Observe returned physical authentication devices.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Examine terminated users accounts.",
                  "Review current access lists.",
                  "Observe returned physical authentication devices.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4a2965f8-7ed8-4093-82f2-957ac8eafc6f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d3002adf-942f-4ea5-a6af-7733c7c236bb"],
                },
              },
              {
                _uid: "d3002adf-942f-4ea5-a6af-7733c7c236bb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d4154981-dec4-4e20-9b5f-e4f30c97f715_4a2965f8-7ed8-4093-82f2-957ac8eafc6f",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3d5bca57-cbe3-46cf-afbd-32a99d6cd551",
                component: "col",
                label: "8.1.4",
                simplifiedLabel: "8.1.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "445d388f-95bd-4d02-a4d5-a4d33c21a0bc",
                component: "col",
                label:
                  "Are inactive user accounts either removed or disabled within 90 days?",
                simplifiedLabel:
                  "Are inactive user accounts either removed or disabled within 90 days?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f4084aec-2365-4a7e-9984-a41cb5b34f06",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Observe user accounts.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Observe user accounts.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5dc514ca-92b3-4ba8-b719-f60f5b683774",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["cb57c3a6-1195-4dbf-9f53-2cf20834670f"],
                },
              },
              {
                _uid: "cb57c3a6-1195-4dbf-9f53-2cf20834670f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "5f69871f-c268-4b01-b709-99d7b041ba66_5dc514ca-92b3-4ba8-b719-f60f5b683774",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "05cb9b5d-08cc-4beb-a1ca-d2b960bf6dce",
                component: "col",
                label: "8.1.5 (a)",
                simplifiedLabel: "8.1.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "18bd71dc-ba41-47e9-ab58-a7053ce97bb8",
                component: "col",
                label: [
                  "Are accounts used by third parties to access, support, or maintain system components via remote access enabled only during the time period needed and disabled when not in use?",
                ],
                simplifiedLabel: [
                  "Are accounts used by third parties to access, support, or maintain system components via remote access enabled only during the time period needed and disabled when not in use?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a23441e3-4ded-4a49-b928-6675c502558a",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "78c2bd1c-765a-49f8-9302-35e7a7d5be0b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["145ee2e6-078d-4334-beb8-dad129d2c893"],
                },
              },
              {
                _uid: "145ee2e6-078d-4334-beb8-dad129d2c893",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4ec8a073-2c0b-420b-8f10-7ff2d9972ff0_78c2bd1c-765a-49f8-9302-35e7a7d5be0b",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3c699020-e426-4f27-82de-784721307c94",
                component: "col",
                label: "8.1.5 (b)",
                simplifiedLabel: "8.1.5 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4fa7edd6-c80a-475b-9c72-d9e0208273bb",
                component: "col",
                label: [
                  "Are third-party remote access accounts monitored when in use?",
                ],
                simplifiedLabel: [
                  "Are third-party remote access accounts monitored when in use?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f6ebae2f-9a02-4e4c-9d60-39b57efec999",
                component: "col",
                label: ["Interview personnel.", "Observe processes."],
                simplifiedLabel: ["Interview personnel.", "Observe processes."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ca0c6920-9bda-4d10-a077-ef050f516bdb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["78595d4f-593f-4521-8663-5db6874ee7ed"],
                },
              },
              {
                _uid: "78595d4f-593f-4521-8663-5db6874ee7ed",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "13bcf784-a7b4-4d80-98b5-8f0e8e9bf34b_ca0c6920-9bda-4d10-a077-ef050f516bdb",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce58ab32-1a2a-4270-a334-2ff89109eab8",
                component: "col",
                label: "8.1.6 (a)",
                simplifiedLabel: "8.1.6 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d3f9129a-5b2e-4eea-a676-b9583cadb107",
                component: "col",
                label: [
                  "Are repeated access attempts limited by locking out the user ID after no more than six attempts?",
                ],
                simplifiedLabel: [
                  "Are repeated access attempts limited by locking out the user ID after no more than six attempts?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3a0e4d56-261e-4a87-adfa-ab6c5aff4c89",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "92f2d257-e7e8-4d18-8a88-cd7d75b2f660",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3960fb61-ce1c-4268-b4fc-46f64cb90a65"],
                },
              },
              {
                _uid: "3960fb61-ce1c-4268-b4fc-46f64cb90a65",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "eaab9b0c-d273-486d-afc7-80276e150cf2_92f2d257-e7e8-4d18-8a88-cd7d75b2f660",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "994e67be-bf8b-4b5e-b86a-5e5b9903a400",
                component: "col",
                label: "8.1.7",
                simplifiedLabel: "8.1.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "580194f1-e051-4f12-9986-6b30bb66370a",
                component: "col",
                label: [
                  "Once a user account is locked out, is the lockout duration set to a minimum of 30 minutes or until an administrator enables the user ID?",
                ],
                simplifiedLabel: [
                  "Once a user account is locked out, is the lockout duration set to a minimum of 30 minutes or until an administrator enables the user ID?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d6cae400-68dc-495f-94d7-1d781e1605b8",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9ddb68a9-0575-4361-a1ac-0b25d1b5a969",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["eac3a82d-e627-4ca7-9b0b-ea5b339d97e6"],
                },
              },
              {
                _uid: "eac3a82d-e627-4ca7-9b0b-ea5b339d97e6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fe37b643-54e1-41fc-a009-ed0f31d8a144_9ddb68a9-0575-4361-a1ac-0b25d1b5a969",
                },
                width: "40%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bef57863-ed35-419a-9d35-57bb3d71f26a",
                component: "col",
                label: "8.1.8",
                simplifiedLabel: "8.1.8",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a9ef386b-3011-4000-890b-89813c2a544b",
                component: "col",
                label: [
                  "If a session has been idle for more than 15 minutes, are users required to re-authenticate (for example, re-enter the password) to re-activate the terminal or session?",
                ],
                simplifiedLabel: [
                  "If a session has been idle for more than 15 minutes, are users required to re-authenticate (for example, re-enter the password) to re-activate the terminal or session?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "60823850-f851-4829-a522-243b736b3175",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ea25ed4b-9eb3-4e20-9d74-997bdf2c2e31",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["22aeea49-185d-4f6a-9a7b-a3b06fa4bf96"],
                },
              },
              {
                _uid: "22aeea49-185d-4f6a-9a7b-a3b06fa4bf96",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d28d4eb5-f95e-4da5-a8a7-59452d255ff8_ea25ed4b-9eb3-4e20-9d74-997bdf2c2e31",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0ed3e5ad-e5f2-4d4f-b46a-5abcb7b5dcd9",
                component: "col",
                label: "8.2",
                simplifiedLabel: "8.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "93123583-cd5d-4a5c-a7d6-71fede0a4487",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "In addition to assigning a unique ID, is one or more of the following methods employed to authenticate all                  users?",
                  simplifiedLabel:
                    "In addition to assigning a unique ID, is one or more of the following methods employed to authenticate all                  users?",
                  ul: [
                    "Something you know, such as a password or passphrase",
                    "Something you have, such as a token device or smart card",
                    "Something you are, such as a biometric",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7c7520e5-a0bc-48e3-ab97-77b10eae4b8a",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Observe authentication processes.",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Observe authentication processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "494b6de1-d438-4310-9eee-a72edeac6472",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e44fcdf8-efb7-466a-b192-d17123a6b57f"],
                },
              },
              {
                _uid: "e44fcdf8-efb7-466a-b192-d17123a6b57f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "52a2cd9f-5831-437b-b208-bfbe782faed3_494b6de1-d438-4310-9eee-a72edeac6472",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c2080960-26ac-4d01-9c0f-c0f68ac86efa",
                component: "col",
                label: "8.2.1 (a)",
                simplifiedLabel: "8.2.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c441aacf-1b14-45c7-b5a6-e90a2910efa3",
                component: "col",
                label: [
                  "Is strong cryptography used to render all authentication credentials (such as passwords/passphrases) unreadable during transmission and storage on all system components?",
                ],
                simplifiedLabel: [
                  "Is strong cryptography used to render all authentication credentials (such as passwords/passphrases) unreadable during transmission and storage on all system components?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "51e25e8c-44f4-428a-873e-a3f5ba6d40d5",
                component: "col",
                label: [
                  "Review password procedures.",
                  "Review vendor documentation.",
                  "Examine system configuration settings.",
                  "Observe password files.",
                  "Observe data transmissions",
                ],
                simplifiedLabel: [
                  "Review password procedures.",
                  "Review vendor documentation.",
                  "Examine system configuration settings.",
                  "Observe password files.",
                  "Observe data transmissions",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b04d3cee-1cd9-46ab-9aa5-c432a6efa1d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ace546e3-28e0-4a66-8884-2825829a61d3"],
                },
              },
              {
                _uid: "ace546e3-28e0-4a66-8884-2825829a61d3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3051d698-a348-4fb3-961e-4d4f5e6b5b0f_b04d3cee-1cd9-46ab-9aa5-c432a6efa1d0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b5678722-34c2-4a85-abde-1d537be2567c",
                component: "col",
                label: "8.2.2",
                simplifiedLabel: "8.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3f47a514-c67c-4403-8243-cba40ece9d55",
                component: "col",
                label:
                  "Is user identity verified before modifying any authentication credential (for example, performing password resets, provisioning new tokens, or generating new keys)? ",
                simplifiedLabel:
                  "Is user identity verified before modifying any authentication credential (for example, performing password resets, provisioning new tokens, or generating new keys)? ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9432dd75-dbe5-4b08-a819-e3595230cdaf",
                component: "col",
                label: ["Review authentication procedures."],
                simplifiedLabel: ["Review authentication procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8591834e-1b28-464e-8b60-75869d4f6256",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["89a11177-1854-4bf8-bfa3-0db871aa4bad"],
                },
              },
              {
                _uid: "89a11177-1854-4bf8-bfa3-0db871aa4bad",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "215868ff-6ead-48f8-b4f3-957b021cf9e4_8591834e-1b28-464e-8b60-75869d4f6256",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "90d7de46-6795-4e7b-9067-e92bc173d5a8",
                component: "col",
                label: "8.2.3 (a)",
                simplifiedLabel: "8.2.3 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c9eb7397-760f-4bab-80fe-c98b579bda82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are user password parameters configured to require passwords/passphrases meet the following?",
                  simplifiedLabel:
                    "Are user password parameters configured to require passwords/passphrases meet the following?",
                  ul: [
                    "A minimum password length of at least seven characters",
                    "Contain both numeric and alphabetic characters",
                  ],
                  pr: "Alternatively, the passwords/passphrases must have complexity and strength at least equivalent to the parameters specified above.",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5db7c066-e9d0-4ee6-a86d-d42ac6b5afaa",
                component: "col",
                label: [
                  "Examine system configuration settings to verify password parameters.",
                ],
                simplifiedLabel: [
                  "Examine system configuration settings to verify password parameters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7292563e-08f7-4c95-818a-95429e3a3646",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c2eb3a86-78e0-4513-91ae-f94064a8ce11"],
                },
              },
              {
                _uid: "c2eb3a86-78e0-4513-91ae-f94064a8ce11",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d824f80e-c928-44f7-9414-a17b64c666d2_7292563e-08f7-4c95-818a-95429e3a3646",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "42676559-2f52-4d82-a6ca-5db20e50fd1c",
                component: "col",
                label: "8.2.4 (a)",
                simplifiedLabel: "8.2.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2634b0f5-0e5b-4cc8-ae30-7acf8b5b7f5f",
                component: "col",
                label: [
                  "Are user passwords/passphrases changed at least once every 90 days?",
                ],
                simplifiedLabel: [
                  "Are user passwords/passphrases changed at least once every 90 days?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0b2b44a1-b8e0-4969-b7be-61e5c86bec92",
                component: "col",
                label: [
                  "Review password procedures",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "89823ed1-1e8d-4d92-aab0-d089e9371407",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["41e4f5ac-748b-4f94-b041-2f15dba4f866"],
                },
              },
              {
                _uid: "41e4f5ac-748b-4f94-b041-2f15dba4f866",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "da28b1e5-78ee-4ee4-beee-555eb2e31b7d_89823ed1-1e8d-4d92-aab0-d089e9371407",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3161064e-63c9-4298-8bc3-1954844f440f",
                component: "col",
                label: "8.2.5 (a)",
                simplifiedLabel: "8.2.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b35339e4-bba9-48be-b336-8ddeb893d887",
                component: "col",
                label: [
                  "Must an individual submit a new password/passphrase that is different from any of the last four passwords/passphrases he or she has used?",
                ],
                simplifiedLabel: [
                  "Must an individual submit a new password/passphrase that is different from any of the last four passwords/passphrases he or she has used?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "823f1d7e-8bd7-4ddf-a48a-2247903752cc",
                component: "col",
                label: [
                  "Review password procedures",
                  "Sample system components.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Review password procedures",
                  "Sample system components.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7a3a9ae5-9c77-42a6-b130-4e2833b49184",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a68652b2-c505-4834-ad66-343651b76bde"],
                },
              },
              {
                _uid: "a68652b2-c505-4834-ad66-343651b76bde",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4c2cccd3-14a4-427a-aa02-cfcc9afea695_7a3a9ae5-9c77-42a6-b130-4e2833b49184",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "181714f9-75d7-4cc7-af83-ae3d1cb041b7",
                component: "col",
                label: "8.2.6",
                simplifiedLabel: "8.2.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "53d6f324-67ea-4058-b852-15a957849426",
                component: "col",
                label: [
                  "Are passwords/passphrases set to a unique value for each user for first-time use and upon reset, and must each user change their password immediately after the first use?",
                ],
                simplifiedLabel: [
                  "Are passwords/passphrases set to a unique value for each user for first-time use and upon reset, and must each user change their password immediately after the first use?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d7ad4600-61de-4a76-b4fe-1e1a15c921d9",
                component: "col",
                label: [
                  "Review password procedures",
                  "Examine system configuration settings.",
                  "Observe security personnel.",
                ],
                simplifiedLabel: [
                  "Review password procedures",
                  "Examine system configuration settings.",
                  "Observe security personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fd639eba-f3f2-4c2f-9f86-b3f889a12ed0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["5c3852ef-1aea-466d-9810-258950984c62"],
                },
              },
              {
                _uid: "5c3852ef-1aea-466d-9810-258950984c62",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "82ac87f0-7c7d-4b6e-ad3c-6f03eba904ea_fd639eba-f3f2-4c2f-9f86-b3f889a12ed0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6e7accc9-a9dc-4540-a718-358000094ec0",
                component: "col",
                label: "8.3",
                simplifiedLabel: "8.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "60416d35-86e5-4505-b453-9feb52ffa174",
                component: "col",
                label: [
                  "Is all individual non-console administrative access and all remote access to the CDE secured using multi-factor                  authentication, as follows:",
                  "Note: Multi-factor authentication requires that a minimum of two of the three authentication methods (see PCI DSS Requirement 8.2 for descriptions of authentication methods) be used for authentication. Using one factor twice (for example, using two separate                passwords) is not considered multi-factor authentication.",
                ],
                simplifiedLabel: [
                  "Is all individual non-console administrative access and all remote access to the CDE secured using multi-factor                  authentication, as follows:",
                  "Note: Multi-factor authentication requires that a minimum of two of the three authentication methods (see PCI DSS Requirement 8.2 for descriptions of authentication methods) be used for authentication. Using one factor twice (for example, using two separate                passwords) is not considered multi-factor authentication.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "5189adff-b443-4d17-ac92-038b45655fdd",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cc4bb423-53be-4196-a7f0-65401a38f29d",
                component: "col",
                label: "8.3.1",
                simplifiedLabel: "8.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "09750fe6-f097-4232-a375-632fc39647fa",
                component: "col",
                label: [
                  "Is multi-factor authentication incorporated for all nonconsole access into the CDE for personnel with administrative access?",
                ],
                simplifiedLabel: [
                  "Is multi-factor authentication incorporated for all nonconsole access into the CDE for personnel with administrative access?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1c9d3be2-c531-42f2-ba4e-dd521e09a03a",
                component: "col",
                label: [
                  "Examine system configurations.",
                  "Observe administrator logging into CDE.",
                ],
                simplifiedLabel: [
                  "Examine system configurations.",
                  "Observe administrator logging into CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ebea7636-8f30-4c91-befd-43a8eafbc3d7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a63ba2f2-ce2f-4d5c-8d81-5dc47087629a"],
                },
              },
              {
                _uid: "a63ba2f2-ce2f-4d5c-8d81-5dc47087629a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7b9f8be2-d5ac-48c6-95b0-18dcae4f53c0_ebea7636-8f30-4c91-befd-43a8eafbc3d7",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "73ee6693-f72e-466d-b413-d463088195af",
                component: "col",
                label: "8.3.2",
                simplifiedLabel: "8.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a1bf2612-93b5-4090-86d5-e264434ce095",
                component: "col",
                label: [
                  "Is multi-factor authentication incorporated for all remote network access (both user and administrator, and including third-party access for support or maintenance) originating from outside the entity’s network?",
                ],
                simplifiedLabel: [
                  "Is multi-factor authentication incorporated for all remote network access (both user and administrator, and including third-party access for support or maintenance) originating from outside the entity’s network?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "81d98016-0d8e-494f-9ef0-1ad773a73815",
                component: "col",
                label: [
                  "Examine system configurations.",
                  "Observe personnel connecting remotely.",
                ],
                simplifiedLabel: [
                  "Examine system configurations.",
                  "Observe personnel connecting remotely.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "89563c10-bbde-41da-8157-7f5b19d90477",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1ba2216c-690b-4b92-bae9-aeab77c606cc"],
                },
              },
              {
                _uid: "1ba2216c-690b-4b92-bae9-aeab77c606cc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9ccf9296-8d8f-46b0-9dc5-a4dbc5f15470_89563c10-bbde-41da-8157-7f5b19d90477",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "58d34171-965c-4e53-94d1-1164274662c4",
                component: "col",
                label: "8.4 (a)",
                simplifiedLabel: "8.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2e02c5ca-bffb-4c9c-a750-e3a25d461713",
                component: "col",
                label: [
                  "Are authentication policies and procedures documented and communicated to all users?",
                ],
                simplifiedLabel: [
                  "Are authentication policies and procedures documented and communicated to all users?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6d93a21c-b7f2-49a1-b06d-f19e6f2d595f",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Review distribution method.",
                  "Interview personnel.",
                  "Interview users.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Review distribution method.",
                  "Interview personnel.",
                  "Interview users.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9fee3f76-00f6-4b21-9f6a-c9e2272bc6f3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f876dfce-513f-48d3-97aa-781f48edce7b"],
                },
              },
              {
                _uid: "f876dfce-513f-48d3-97aa-781f48edce7b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9d43c83a-d942-4afe-9a7c-2c128931ff5a_9fee3f76-00f6-4b21-9f6a-c9e2272bc6f3",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "04439451-bbd6-425d-80d4-b9044afb483c",
                component: "col",
                label: "8.4 (b)",
                simplifiedLabel: "8.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a9d3b957-0278-4e3c-9eca-70267090c219",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label:
                    "Do authentication policies and procedures include the following?",
                  simplifiedLabel:
                    "Do authentication policies and procedures include the following?",
                  ul: [
                    "Guidance on selecting strong authentication credentials",
                    "Guidance for how users should protect their authentication credentials",
                    "Instructions not to reuse previously used passwords",
                    "Instructions that users should change passwords if there is any suspicion the password could be compromised",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8cce851e-f677-454e-aba6-2c42b5007c23",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Review distribution method.",
                  "Interview personnel.",
                  "Interview users.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Review distribution method.",
                  "Interview personnel.",
                  "Interview users.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2be90b61-cddd-497e-9dc6-720321b8c9dd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["38c8a225-5d4c-4763-a8dd-c908f7e7271a"],
                },
              },
              {
                _uid: "38c8a225-5d4c-4763-a8dd-c908f7e7271a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "751982d6-c500-45fa-b7b5-903f0537d76c_2be90b61-cddd-497e-9dc6-720321b8c9dd",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f6f10e02-0283-492d-aad0-ff427fe3a01c",
                component: "col",
                label: "8.5",
                simplifiedLabel: "8.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d4009deb-a652-4025-a87a-3ce4d73618ca",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are group, shared, or generic accounts, passwords, or other authentication methods prohibited as follows:",
                  simplifiedLabel:
                    "Are group, shared, or generic accounts, passwords, or other authentication methods prohibited as follows:",
                  ul: [
                    "Generic user IDs and accounts are disabled or removed;",
                    "Shared user IDs for system administration activities and other critical functions do not exist; and",
                    "Shared and generic user IDs are not used to administer any system components?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c02550fb-3c40-482e-9e6c-03b07126c765",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Examine user ID lists.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Examine user ID lists.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9f372fab-3959-4f5e-a9c2-59616578c460",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["87f5d521-9dcf-416a-b51c-bb669ebb9b93"],
                },
              },
              {
                _uid: "87f5d521-9dcf-416a-b51c-bb669ebb9b93",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6d67a03b-4ab1-4906-929b-79260b284cd8_9f372fab-3959-4f5e-a9c2-59616578c460",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6aa35a44-db20-4db8-b23a-1ca2f52a1524",
                component: "col",
                label: "8.6",
                simplifiedLabel: "8.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "17f17ad8-1438-4c64-aa98-63ea8e3142f7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Where other authentication mechanisms are used (for example, physical or logical security tokens, smart cards, assigned as follows?",
                  simplifiedLabel:
                    "Where other authentication mechanisms are used (for example, physical or logical security tokens, smart cards, assigned as follows?",
                  ul: [
                    "Authentication mechanisms must be assigned to an individual account and not shared among multiple accounts",
                    "Physical and/or logical controls must be in place to ensure only the intended account can use that mechanism to gain access",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "255d87d5-dc9d-452e-bd1f-f9abe7b45ee4",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                  "Examine system configuration settings and/or physical controls.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Interview personnel.",
                  "Examine system configuration settings and/or physical controls.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ed7ca783-5ee7-4c22-90ad-bd3acebdad36",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["38bb171c-d3b0-4aee-ac5c-8acf13fd9a52"],
                },
              },
              {
                _uid: "38bb171c-d3b0-4aee-ac5c-8acf13fd9a52",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "eee4b4dd-7da2-4b88-900a-1a9cdfe30415_ed7ca783-5ee7-4c22-90ad-bd3acebdad36",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8f425c41-8353-4b58-a848-42f5ac6d7fe5",
                component: "col",
                label: "8.8",
                simplifiedLabel: "8.8",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7aadf437-db93-4d8f-af05-63eec10c3858",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label:
                    "Are security policies and operational procedures for identification and authentication:",
                  simplifiedLabel:
                    "Are security policies and operational procedures for identification and authentication:",
                  ul: [
                    "Documented",
                    "In use",
                    "Known to all affected parties?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9a2b3232-edf1-4e04-8891-c187b163d943",
                component: "col",
                label: [
                  "Examine security policies and operational procedures.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Examine security policies and operational procedures.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "172c0a1f-838d-4b3e-84f1-bb938ac4c8ff",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c08e3549-6464-45e5-b373-9c406f68d98a"],
                },
              },
              {
                _uid: "c08e3549-6464-45e5-b373-9c406f68d98a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fb07dd58-50c0-4799-b15b-0469d9943502_172c0a1f-838d-4b3e-84f1-bb938ac4c8ff",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fc69b840-1b65-4e28-9627-f6e85ba8152e",
                component: "col",
                label:
                  "Requirement 9: Restrict physical access to cardholder data",
                simplifiedLabel:
                  "Requirement 9: Restrict physical access to cardholder data",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "884df9c1-ab06-4d25-9922-27d0840651b2",
                component: "col",
                label: "9.1",
                simplifiedLabel: "9.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1711fd63-f511-4174-980c-c066c181ea30",
                component: "col",
                label: [
                  "Are appropriate facility entry controls in place to limit and monitor physical access to systems in the cardholder data environment?",
                ],
                simplifiedLabel: [
                  "Are appropriate facility entry controls in place to limit and monitor physical access to systems in the cardholder data environment?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "478c40fc-a464-4bb5-97de-dce93dc6d0aa",
                component: "col",
                label: [
                  "Observe physical access controls.",
                  "Observe personnel.",
                ],
                simplifiedLabel: [
                  "Observe physical access controls.",
                  "Observe personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "323cdd66-31a8-4a78-b910-47715b170555",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["591bb234-f185-4168-aaa7-6d63ca185d4f"],
                },
              },
              {
                _uid: "591bb234-f185-4168-aaa7-6d63ca185d4f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "76570df8-d35c-4f56-91c9-3812ecbc7b9f_323cdd66-31a8-4a78-b910-47715b170555",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "87ae1c48-4209-4667-b857-71b8dda8cd2c",
                component: "col",
                label: "9.5",
                simplifiedLabel: "9.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "95b2b5ce-b6e8-4fde-ba8f-c6e250874df4",
                component: "col",
                label: [
                  "Are all media physically secured (including but not limited to computers, removable electronic media, paper receipts, paper reports, and faxes)?",
                  "For purposes of Requirement 9, “media” refers to all paper and electronic media containing cardholder data.",
                ],
                simplifiedLabel: [
                  "Are all media physically secured (including but not limited to computers, removable electronic media, paper receipts, paper reports, and faxes)?",
                  "For purposes of Requirement 9, “media” refers to all paper and electronic media containing cardholder data.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a7194d37-c993-414e-a29c-2d199a8c48a6",
                component: "col",
                label: [
                  "Review policies and procedures for physically securing media.",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures for physically securing media.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9a605c67-cdc9-4b6f-b7f4-825753741637",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3140aac6-e035-4f1f-b799-e867a0bcad4c"],
                },
              },
              {
                _uid: "3140aac6-e035-4f1f-b799-e867a0bcad4c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a31f2cde-f0c3-4e5e-88d9-735c02d9d171_9a605c67-cdc9-4b6f-b7f4-825753741637",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa49671c-8455-4837-bbf2-b63ec70ec034",
                component: "col",
                label: "9.6 (a)",
                simplifiedLabel: "9.6 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2006ad39-ab71-4ffb-906b-104493abcc4d",
                component: "col",
                label: [
                  "Is strict control maintained over the internal or external distribution of any kind of media?",
                ],
                simplifiedLabel: [
                  "Is strict control maintained over the internal or external distribution of any kind of media?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "94ae2dc4-cd7b-40fa-9c32-237a8e2648e5",
                component: "col",
                label: [
                  "Review policies and procedures for distribution of media.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures for distribution of media.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bee78bbb-20f2-4f18-8b01-9c90defe39f7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9ae4671b-ea95-4941-8e73-8618518d1d21"],
                },
              },
              {
                _uid: "9ae4671b-ea95-4941-8e73-8618518d1d21",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "78398833-38d7-4290-8bf5-f03dcd81c877_bee78bbb-20f2-4f18-8b01-9c90defe39f7",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "68ee527b-c409-48a0-bd4c-0e1f7c477f04",
                component: "col",
                label: "9.6 (b)",
                simplifiedLabel: "9.6 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f45f0c89-f93e-4a3a-8be8-f6b860460b6a",
                component: "col",
                label: ["Do controls include the following:"],
                simplifiedLabel: ["Do controls include the following:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "5539acad-7e7b-41e3-9df9-05708110a665",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ebd5d616-194f-4361-8c81-8d12eff99c1b",
                component: "col",
                label: "9.6.1",
                simplifiedLabel: "9.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9376e756-84af-4994-bbc9-84cf8fab5c1e",
                component: "col",
                label: [
                  "Is media classified so the sensitivity of the data can be determined?",
                ],
                simplifiedLabel: [
                  "Is media classified so the sensitivity of the data can be determined?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a5e44295-28ae-4957-aec4-fed32d842e79",
                component: "col",
                label: [
                  "Review policies and procedures for media classification.",
                  "Interview security personnel.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures for media classification.",
                  "Interview security personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "71d70206-005f-40df-ab2c-f6d141a826b1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["7df24eaf-987c-469c-89d7-51c7e65d9c9e"],
                },
              },
              {
                _uid: "7df24eaf-987c-469c-89d7-51c7e65d9c9e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "36a62a20-0697-4cda-a87f-5f20c3cf0342_71d70206-005f-40df-ab2c-f6d141a826b1",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8581cfbb-cf77-45f6-863e-e4869719073b",
                component: "col",
                label: "9.6.2",
                simplifiedLabel: "9.6.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f4d5ba54-e268-4f35-9eb3-245cd7ffb0cb",
                component: "col",
                label: [
                  "Is media sent by secured courier or other delivery method that can be accurately tracked?",
                ],
                simplifiedLabel: [
                  "Is media sent by secured courier or other delivery method that can be accurately tracked?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "346d7c2c-8a29-496c-98b9-d753f8b68058",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Examine media distribution tracking logs and documentation.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Examine media distribution tracking logs and documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f51727e8-ffbe-4fe3-9715-2d560f50b826",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9a7cb94f-a472-4643-81bd-3d12c7ee37d7"],
                },
              },
              {
                _uid: "9a7cb94f-a472-4643-81bd-3d12c7ee37d7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "63b23cd5-c95e-42c8-9e46-50af9a94c843_f51727e8-ffbe-4fe3-9715-2d560f50b826",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6968fb88-25ab-45ed-a48e-e3d71b88b96a",
                component: "col",
                label: "9.6.3",
                simplifiedLabel: "9.6.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "82e87c53-2a32-41a2-9db0-fbfba72d7559",
                component: "col",
                label: [
                  "Is management approval obtained prior to moving the media (especially when media is distributed to individuals)?",
                ],
                simplifiedLabel: [
                  "Is management approval obtained prior to moving the media (especially when media is distributed to individuals)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "00b19ab5-f75c-4098-b91b-d622be38e6ea",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Examine media distribution tracking logs and documentation.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Examine media distribution tracking logs and documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "56574bf2-1de3-4b9e-92f0-83b8dc4e6bea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["49841f49-278b-4413-9fbe-41c41726a9e2"],
                },
              },
              {
                _uid: "49841f49-278b-4413-9fbe-41c41726a9e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d7621080-1431-43ca-a38c-4c708442bc11_56574bf2-1de3-4b9e-92f0-83b8dc4e6bea",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "26e58608-18fd-4ed7-b445-893912dde4d7",
                component: "col",
                label: "9.7 ",
                simplifiedLabel: "9.7 ",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "667a8ad0-53cd-48fe-ad84-c7ceee29d1d0",
                component: "col",
                label: [
                  "Is strict control maintained over the storage and accessibility of media?",
                ],
                simplifiedLabel: [
                  "Is strict control maintained over the storage and accessibility of media?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e61227b8-32d1-48be-98a0-35f8e988722d",
                component: "col",
                label: ["Review policies and procedures."],
                simplifiedLabel: ["Review policies and procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3da5fd08-d789-40e1-bd07-22d8e4cf5544",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e7584e7e-62a8-4164-b728-10b98aae929c"],
                },
              },
              {
                _uid: "e7584e7e-62a8-4164-b728-10b98aae929c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "828c7299-d713-49da-b71c-c1817c4696e7_3da5fd08-d789-40e1-bd07-22d8e4cf5544",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "673d1748-932f-4703-b255-1e0ec17927c8",
                component: "col",
                label: "9.8 (a)",
                simplifiedLabel: "9.8 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "28738f3c-adcb-4ca3-ab09-da598007f62a",
                component: "col",
                label: [
                  "Is all media destroyed when it is no longer needed for business or legal reasons?",
                ],
                simplifiedLabel: [
                  "Is all media destroyed when it is no longer needed for business or legal reasons?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d25d6917-4cd3-4357-a894-1fc402a12ade",
                component: "col",
                label: [
                  "Review periodic media destruction policies and procedures.",
                ],
                simplifiedLabel: [
                  "Review periodic media destruction policies and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bdfb4210-e1bb-4c78-afa1-8a5b960b3a2d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["35cd9da4-4e8c-4049-ab03-ada6459e88b8"],
                },
              },
              {
                _uid: "35cd9da4-4e8c-4049-ab03-ada6459e88b8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "96c68bfa-1f85-40e8-b72c-88bc98a890a1_bdfb4210-e1bb-4c78-afa1-8a5b960b3a2d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ea8b5f48-7d50-4159-a2f1-a7e645fffe62",
                component: "col",
                label: "9.8 (c)",
                simplifiedLabel: "9.8 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ce746fa2-628a-4c4f-a0d1-ec757254f8ec",
                component: "col",
                label: ["Is media destruction performed as follows:"],
                simplifiedLabel: ["Is media destruction performed as follows:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f73433cf-8866-4212-9ae7-3a40b3b5f408",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ea84b84c-bd41-49eb-9c46-bfa4299181f2",
                component: "col",
                label: "9.8.1 (a)",
                simplifiedLabel: "9.8.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "74532bb9-e875-42b7-af94-e7f2cc86ea1a",
                component: "col",
                label: [
                  "Are hardcopy materials cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed?",
                ],
                simplifiedLabel: [
                  "Are hardcopy materials cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c961cc1d-5577-4490-9797-814ee9e66400",
                component: "col",
                label: [
                  "Review periodic media destruction policies and procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                simplifiedLabel: [
                  "Review periodic media destruction policies and procedures.",
                  "Interview personnel.",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "efbdae17-732c-4eab-bb5d-acf7377c4ce7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["605505d6-68b5-4e23-b424-c2b48d5ed361"],
                },
              },
              {
                _uid: "605505d6-68b5-4e23-b424-c2b48d5ed361",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fbec58e8-57cc-4030-a6c8-a3aa9bea60b3_efbdae17-732c-4eab-bb5d-acf7377c4ce7",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84e76520-7e8b-46cb-a9a0-5ac4099e4761",
                component: "col",
                label: "9.8.1 (b)",
                simplifiedLabel: "9.8.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "865eee41-70e4-4962-b35e-45a5ab391509",
                component: "col",
                label: [
                  "Are storage containers used for materials that contain information to be destroyed secured to prevent access to the contents?",
                ],
                simplifiedLabel: [
                  "Are storage containers used for materials that contain information to be destroyed secured to prevent access to the contents?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4baa77e0-24c7-483f-9aaa-081a7d6183e3",
                component: "col",
                label: ["Examine security of storage containers."],
                simplifiedLabel: ["Examine security of storage containers."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dad37b14-7316-4e1e-be7c-c1a9cab01762",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c11a34cd-ecb3-471b-a65f-5ce7c31fcb06"],
                },
              },
              {
                _uid: "c11a34cd-ecb3-471b-a65f-5ce7c31fcb06",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "30b1ee87-5bca-4ad4-883a-9aca2e263f1a_dad37b14-7316-4e1e-be7c-c1a9cab01762",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "305f5eaa-8b17-461b-9ee2-5e0e5ec80ff5",
                component: "col",
                label: [
                  "Regularly Monitor and Test Networks",
                  "Requirement 10: Track and monitor all access to network resources and cardholder data",
                ],
                simplifiedLabel: [
                  "Regularly Monitor and Test Networks",
                  "Requirement 10: Track and monitor all access to network resources and cardholder data",
                ],
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4e103fc2-c795-4601-ab06-b3977f4eb68a",
                component: "col",
                label: "10.1 (a)",
                simplifiedLabel: "10.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "79102af3-e964-4998-b55c-797febcd6d1c",
                component: "col",
                label:
                  "Are audit trails enabled and active for system components?",
                simplifiedLabel:
                  "Are audit trails enabled and active for system components?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2d2d023a-2e4a-45fb-be3e-53100f82b811",
                component: "col",
                label: [
                  "Observe processes.",
                  "Interview system administrator.",
                ],
                simplifiedLabel: [
                  "Observe processes.",
                  "Interview system administrator.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f982483e-6002-4d2b-a651-5fe54a6d6ceb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["6be4da17-e53b-4969-9dd4-7db9d183e966"],
                },
              },
              {
                _uid: "6be4da17-e53b-4969-9dd4-7db9d183e966",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "05fa44ff-9673-4a63-aab7-f412918f11e4_f982483e-6002-4d2b-a651-5fe54a6d6ceb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5d9e1294-a114-4f63-aa87-563ae28d832c",
                component: "col",
                label: "10.1 (b)",
                simplifiedLabel: "10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f0b9f922-beaa-43d9-9be8-a5eb499be520",
                component: "col",
                label:
                  "Is access to system components linked to individual users?",
                simplifiedLabel:
                  "Is access to system components linked to individual users?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "92153e34-d6f8-4814-8f62-9caeb5998640",
                component: "col",
                label: [
                  "Observe processes.",
                  "Interview system administrator.",
                ],
                simplifiedLabel: [
                  "Observe processes.",
                  "Interview system administrator.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "cd3691b2-686a-4b43-abb0-a128e44d62b9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["62d410b6-30b9-4abe-a079-d34f84ef24a0"],
                },
              },
              {
                _uid: "62d410b6-30b9-4abe-a079-d34f84ef24a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7a9dd91a-15a3-4954-bc0f-597d0371d3c3_cd3691b2-686a-4b43-abb0-a128e44d62b9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a4538b6-cde0-4abb-8991-faae608653d6",
                component: "col",
                label: "10.2",
                simplifiedLabel: "10.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1e4f8850-586b-4fab-b48f-bfbd78f5f8fd",
                component: "col",
                label: [
                  "Are automated audit trails implemented for all system components to reconstruct the following events:",
                ],
                simplifiedLabel: [
                  "Are automated audit trails implemented for all system components to reconstruct the following events:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "13c248cc-79f1-4c3b-8411-5565506504e1",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "063445e1-5149-41d2-adaa-5ea2dea9acbe",
                component: "col",
                label: "10.2.2",
                simplifiedLabel: "10.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4f307b8e-e07e-43fa-bde6-43764b62a371",
                component: "col",
                label: [
                  "All actions taken by any individual with root or administrative privileges?",
                ],
                simplifiedLabel: [
                  "All actions taken by any individual with root or administrative privileges?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ae939af1-41ed-4d37-b88a-619ca8e9bae9",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a39f5d14-8c88-4f02-af6b-4bfc02e91301",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c4e958c4-b1b8-482b-be6f-f2986ca6d200"],
                },
              },
              {
                _uid: "c4e958c4-b1b8-482b-be6f-f2986ca6d200",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field: "ANOTHER_NEW_UID_a39f5d14-8c88-4f02-af6b-4bfc02e91301",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "034631ce-110c-4461-adfe-424a1ce431ec",
                component: "col",
                label: "10.2.3",
                simplifiedLabel: "10.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5f4e13be-106d-44b5-ae87-b6d471d9c398",
                component: "col",
                label: "Access to all audit trails?",
                simplifiedLabel: "Access to all audit trails?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c888ff0a-0ba1-42cc-b957-bd6b205f2f65",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "33365437-b761-4c13-9a5e-0a2667445632",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c3f2e8f2-e1d1-4750-893f-ebf0e644556f"],
                },
              },
              {
                _uid: "c3f2e8f2-e1d1-4750-893f-ebf0e644556f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c6ee35b4-0740-4d8b-8f88-0ac2962e2238_33365437-b761-4c13-9a5e-0a2667445632",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "919baad6-37c2-4e58-8456-d4e2575d422a",
                component: "col",
                label: "10.2.4",
                simplifiedLabel: "10.2.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fe885a8f-d0ef-4cbd-b95f-39ac79804a1b",
                component: "col",
                label: ["Invalid logical access attempts?"],
                simplifiedLabel: ["Invalid logical access attempts?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a775ca32-753b-40a1-917c-afd73c946683",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "72a2915e-d342-4c56-a6d3-51392a11c78d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["9d830d5c-8085-485d-885e-9625bd9fac74"],
                },
              },
              {
                _uid: "9d830d5c-8085-485d-885e-9625bd9fac74",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "bbefd3f7-b762-464b-b1da-67d420b7ac14_72a2915e-d342-4c56-a6d3-51392a11c78d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cecabd67-54d0-45e3-9df7-5cc9116cb4ba",
                component: "col",
                label: "10.2.5",
                simplifiedLabel: "10.2.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7b0964bd-e94e-4777-b1ed-afef26fb91c9",
                component: "col",
                label: [
                  "Use of and changes to identification and authentication mechanisms⎯including but not limited to creation of new accounts and elevation of privileges⎯and all changes, additions, or deletions to accounts with root or administrative privileges?",
                ],
                simplifiedLabel: [
                  "Use of and changes to identification and authentication mechanisms⎯including but not limited to creation of new accounts and elevation of privileges⎯and all changes, additions, or deletions to accounts with root or administrative privileges?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "93f73bd5-e9ac-450c-9759-6498cae65d1d",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f448bd02-e260-4b9c-ad96-db7d2155ca2e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d378c026-39c1-483a-afb5-b81c8e40f1c9"],
                },
              },
              {
                _uid: "d378c026-39c1-483a-afb5-b81c8e40f1c9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "86d5e71d-cee3-4617-b309-906b5a0e1e66_f448bd02-e260-4b9c-ad96-db7d2155ca2e",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1416f428-0f54-4788-ba6d-ba81f9e0bae4",
                component: "col",
                label: "10.2.6",
                simplifiedLabel: "10.2.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d4c96d1a-f607-47b6-8958-f5ece96dc3cd",
                component: "col",
                label:
                  "Initialization, stopping, or pausing of the audit logs?",
                simplifiedLabel:
                  "Initialization, stopping, or pausing of the audit logs?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9309f598-d0f0-4386-abf4-721ab0940c9c",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "abba1d8c-eead-4abd-b0d6-71c87885be8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f5e54ca6-2b00-4266-a575-94ef99af4e19"],
                },
              },
              {
                _uid: "f5e54ca6-2b00-4266-a575-94ef99af4e19",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1c8a8606-5ae4-47af-aed4-a2ff953e8ebb_abba1d8c-eead-4abd-b0d6-71c87885be8c",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba10b47c-63fc-4028-8143-96a88675ff1d",
                component: "col",
                label: "10.2.7",
                simplifiedLabel: "10.2.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "56f21845-2865-4326-9230-6330161d5916",
                component: "col",
                label: "Creation and deletion of system-level objects?",
                simplifiedLabel:
                  "Creation and deletion of system-level objects?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e4bc67bd-6cd6-49f3-af5b-4f0cd2af8372",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1f15eb3a-2809-4646-bb9b-cf61ec31d2ae",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["185d5923-e527-4452-b2c2-f21a987c6d8f"],
                },
              },
              {
                _uid: "185d5923-e527-4452-b2c2-f21a987c6d8f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "946bb64b-1567-4aae-8c39-ad450700cb79_1f15eb3a-2809-4646-bb9b-cf61ec31d2ae",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "097e9f58-9318-41c6-beff-4fa25574790b",
                component: "col",
                label: "10.3",
                simplifiedLabel: "10.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9390eae3-324f-4dcc-adc6-2a525a0d0d3b",
                component: "col",
                label: [
                  "Are the following audit trail entries recorded for all system components for each event:",
                ],
                simplifiedLabel: [
                  "Are the following audit trail entries recorded for all system components for each event:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "85c38ca6-ab7c-49b3-bb92-33c5b29b3b91",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b8fc7b2b-a042-47a3-8d87-c636fb6e1a36",
                component: "col",
                label: "10.3.1",
                simplifiedLabel: "10.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4cf0edd3-07fc-4b78-be37-33394ccc00f1",
                component: "col",
                label: ["User identification?"],
                simplifiedLabel: ["User identification?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "bf9f50be-abf6-4de4-9ba7-bcad4e49cc30",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dfe73c75-5d77-4123-8f21-713058938fa4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2caac0ac-7567-472b-9b8a-d64dc38e3a44"],
                },
              },
              {
                _uid: "2caac0ac-7567-472b-9b8a-d64dc38e3a44",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ce69a755-2f22-4d0e-9db7-b5c83383f63b_dfe73c75-5d77-4123-8f21-713058938fa4",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a552f3c-aa9f-4540-8223-b4b92d69e45f",
                component: "col",
                label: "10.3.2",
                simplifiedLabel: "10.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3aaa9dc6-c913-4b87-b2f8-6dcea20c8e23",
                component: "col",
                label: ["Type of event?"],
                simplifiedLabel: ["Type of event?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e0e085cf-4dff-455f-b7cc-c73ffdf913ac",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "820777e0-78f2-4853-99d1-f139651df9f0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["21748eb5-78e4-42fa-8026-3e6a8be27aef"],
                },
              },
              {
                _uid: "21748eb5-78e4-42fa-8026-3e6a8be27aef",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2a9343e3-32ee-4bd9-af66-71fcb06d7b03_820777e0-78f2-4853-99d1-f139651df9f0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2719982a-8dcc-4aa8-9c44-28eaf02545b4",
                component: "col",
                label: "10.3.3",
                simplifiedLabel: "10.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "01e8486e-8c48-4845-823c-d2e4db341e9e",
                component: "col",
                label: ["Date and time?"],
                simplifiedLabel: ["Date and time?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "aa054620-0a01-4ec5-9191-abe3148bd7d9",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "592bfa47-29ba-4ace-a9e9-d196d54e427f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["654c25fa-95f8-4422-bfb8-ce52037a43d3"],
                },
              },
              {
                _uid: "654c25fa-95f8-4422-bfb8-ce52037a43d3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "aeead10c-4bfc-40b2-82b1-26208d3fa264_592bfa47-29ba-4ace-a9e9-d196d54e427f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cd2b4136-1f23-40e1-9da7-11aa2d0426d3",
                component: "col",
                label: "10.3.4",
                simplifiedLabel: "10.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1c581f1e-16b4-45b9-825d-a33d37d93fd6",
                component: "col",
                label: ["Success or failure indication?"],
                simplifiedLabel: ["Success or failure indication?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1ed76a0c-c61b-403e-912b-dac6dd238d4b",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "174d296b-bf6f-4d88-96d2-ba4c3a0e73d1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["b7d5af6e-b4d1-4367-9293-4226675d3055"],
                },
              },
              {
                _uid: "b7d5af6e-b4d1-4367-9293-4226675d3055",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3cce1c81-5a5c-4fac-8e5b-cffb7441f052_174d296b-bf6f-4d88-96d2-ba4c3a0e73d1",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "becb8e32-d49d-4812-970e-d3437f4bd199",
                component: "col",
                label: "10.3.5",
                simplifiedLabel: "10.3.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "74d1ffc1-a3bf-4103-b7b2-e40e1548f3fc",
                component: "col",
                label: ["Origination of event?"],
                simplifiedLabel: ["Origination of event?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e6a885b0-cf1f-4574-a0e9-29964ec19e2b",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fa7ac303-4085-457d-8fd7-6b7e1eade4bb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["af56d350-5f67-4b83-9f4e-4a887ed7fcb8"],
                },
              },
              {
                _uid: "af56d350-5f67-4b83-9f4e-4a887ed7fcb8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "493c1f72-7667-4a52-8d34-47937b1c9276_fa7ac303-4085-457d-8fd7-6b7e1eade4bb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8d5553ff-c238-4655-be99-3e86f8f506e9",
                component: "col",
                label: "10.3.6",
                simplifiedLabel: "10.3.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8f845f31-4038-45ce-b20c-aafbf0d3fbc7",
                component: "col",
                label: [
                  "Identity or name of affected data, system component, or resource?",
                ],
                simplifiedLabel: [
                  "Identity or name of affected data, system component, or resource?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e779c47e-8be2-4b96-bbb2-8ac254d88c5f",
                component: "col",
                label: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Observe audit logs.",
                  "Examine audit log settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2683c492-e13f-4c0d-afef-5c3904fa0776",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f52a6b0e-2532-4d12-a097-9b417cb12e86"],
                },
              },
              {
                _uid: "f52a6b0e-2532-4d12-a097-9b417cb12e86",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7aed6bbd-3aa9-4e96-8f5a-3df8c6082246_2683c492-e13f-4c0d-afef-5c3904fa0776",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7fc3cc5e-99bb-4b5f-8879-b0f0538147cc",
                component: "col",
                label: "10.4",
                simplifiedLabel: "10.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8e92975a-dad3-48e2-92dc-2bad2e883052",
                component: "col",
                label: [
                  "Are all critical system clocks and times synchronized through use of time synchronization technology, and is the technology kept current?",
                  "Note: One example of time synchronization technology is Network Time Protocol (NTP).",
                ],
                simplifiedLabel: [
                  "Are all critical system clocks and times synchronized through use of time synchronization technology, and is the technology kept current?",
                  "Note: One example of time synchronization technology is Network Time Protocol (NTP).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b6ad9c28-7793-4431-bbf7-701c0ad971ec",
                component: "col",
                label: ["Review time configuration standards and processes."],
                simplifiedLabel: [
                  "Review time configuration standards and processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0ed1a527-029a-481f-be1c-98e58ca6766f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8d867123-3410-4b54-8201-7f6ea71e1204"],
                },
              },
              {
                _uid: "8d867123-3410-4b54-8201-7f6ea71e1204",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "46fadc4c-0669-48f0-9017-26c425f0e36d_0ed1a527-029a-481f-be1c-98e58ca6766f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3a108ef6-9950-47d7-8611-176048c4fdb3",
                component: "col",
                label: "10.4.1",
                simplifiedLabel: "10.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f5425602-be12-424b-8024-07eebbc3c387",
                component: "col",
                label:
                  "Are the following processes implemented for critical systems to have the correct and consistent time:",
                simplifiedLabel:
                  "Are the following processes implemented for critical systems to have the correct and consistent time:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "db499255-0ce2-45f8-98f2-1a54c61e147f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bbafbba5-08fa-4dde-a78e-b8aadc3f98a2",
                component: "col",
                label: "10.4.1 (a)",
                simplifiedLabel: "10.4.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "49a0eec4-d9a6-41b3-bd67-f8893df7bc72",
                component: "col",
                label: [
                  "Do only designated central time server(s) receive time signals from external sources, and are time signals from external sources based on International Atomic Time or UTC?",
                ],
                simplifiedLabel: [
                  "Do only designated central time server(s) receive time signals from external sources, and are time signals from external sources based on International Atomic Time or UTC?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5522db54-0bd3-4e69-a5ef-4c80a563b385",
                component: "col",
                label: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                simplifiedLabel: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e35737e1-562f-4251-8ac0-a4fed89046a0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3416cf26-4f16-4cb5-a441-813f8e298a18"],
                },
              },
              {
                _uid: "3416cf26-4f16-4cb5-a441-813f8e298a18",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c465cc83-0301-47c7-b89c-21c7e302d531_e35737e1-562f-4251-8ac0-a4fed89046a0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bef3499c-db97-4fd7-9c45-f82bd93b6709",
                component: "col",
                label: "10.4.1 (b)",
                simplifiedLabel: "10.4.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c46bb99e-e7f6-4ce0-8be2-f8f6ebb380cd",
                component: "col",
                label: [
                  "Where there is more than one designated time server, do the time servers peer with each other to keep accurate time?",
                ],
                simplifiedLabel: [
                  "Where there is more than one designated time server, do the time servers peer with each other to keep accurate time?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "93fbb05f-824d-42a3-bc49-8d3864c0562d",
                component: "col",
                label: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                simplifiedLabel: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "08d9c84d-4f42-4974-965b-2025fb3eeaff",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c5f9b85c-5a7a-4f34-87a4-00e4fa6c82f8"],
                },
              },
              {
                _uid: "c5f9b85c-5a7a-4f34-87a4-00e4fa6c82f8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2adb257f-a64f-4785-9c67-1caa7de83e25_08d9c84d-4f42-4974-965b-2025fb3eeaff",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb853aa3-b483-4fec-bbea-a72484a8aea5",
                component: "col",
                label: "10.4.1 (c)",
                simplifiedLabel: "10.4.1 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e1c72014-d8b0-4c4a-bf98-260b55d808ec",
                component: "col",
                label: [
                  "Do systems receive time only from designated central time server(s)?",
                ],
                simplifiedLabel: [
                  "Do systems receive time only from designated central time server(s)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ebc20e83-a7d5-49b3-8f0a-454025ddaa47",
                component: "col",
                label: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                simplifiedLabel: [
                  "Review time configuration standards and processes.",
                  "Examine time-related system parameters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2cc4a3e6-edba-435c-a3ff-087456a2b3d4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3c860c03-b95f-405f-ac6b-1ac0a342fced"],
                },
              },
              {
                _uid: "3c860c03-b95f-405f-ac6b-1ac0a342fced",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b700bdb7-3543-4eae-adf8-291130c319b8_2cc4a3e6-edba-435c-a3ff-087456a2b3d4",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0d633d20-ccbb-44ba-925a-8a34ad453338",
                component: "col",
                label: "10.4.2 (a)",
                simplifiedLabel: "10.4.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "95d84913-9624-4b29-b42d-6f0fe32860b1",
                component: "col",
                label: [
                  "Is time data is protected as follows:",
                  "Is access to time data restricted to only personnel with a business need to access time data?",
                ],
                simplifiedLabel: [
                  "Is time data is protected as follows:",
                  "Is access to time data restricted to only personnel with a business need to access time data?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "65321d73-0ebb-4c6f-b730-4dd88bd67054",
                component: "col",
                label: [
                  "Examine system configurations and timesynchronization settings.",
                ],
                simplifiedLabel: [
                  "Examine system configurations and timesynchronization settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "201dfa77-8ecf-41ef-8ceb-9afe077278ea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1f226b5b-4b3f-4b80-87f7-df54ec9fd763"],
                },
              },
              {
                _uid: "1f226b5b-4b3f-4b80-87f7-df54ec9fd763",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f252028d-7093-4f20-997d-eb7abac88fdd_201dfa77-8ecf-41ef-8ceb-9afe077278ea",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a573189-739c-4c98-b658-52d23a67686e",
                component: "col",
                label: "10.4.2 (b)",
                simplifiedLabel: "10.4.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dac102b9-73ee-4b14-b7cf-e6e662b43458",
                component: "col",
                label: [
                  "Are changes to time settings on critical systems logged, monitored, and reviewed?",
                ],
                simplifiedLabel: [
                  "Are changes to time settings on critical systems logged, monitored, and reviewed?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "63a06bed-196b-494f-a189-a5a39005f753",
                component: "col",
                label: [
                  "Examine system configurations and timesynchronization settings and logs.",
                ],
                simplifiedLabel: [
                  "Examine system configurations and timesynchronization settings and logs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4e2d5d7f-5ba1-4ac3-92bd-a3aba416af4b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["1ff500cf-aba2-4d9f-b4dd-793a05d5808d"],
                },
              },
              {
                _uid: "1ff500cf-aba2-4d9f-b4dd-793a05d5808d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "50639f79-e433-4657-834e-05a21743be16_4e2d5d7f-5ba1-4ac3-92bd-a3aba416af4b",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56e37d12-a741-4f11-a5b0-1974eedeacf5",
                component: "col",
                label: "10.4.3",
                simplifiedLabel: "10.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "664ee42c-09c6-41bc-ac8b-d25e5771cf6d",
                component: "col",
                label: [
                  "Are time settings received from specific, industryaccepted time sources? (This is to prevent a malicious individual from changing the clock). ",
                  "Optionally, those updates can be encrypted with a symmetric key, and access control lists can be created that specify the IP addresses of client machines that will be provided with the time updates (to prevent unauthorized use of internal time servers).",
                ],
                simplifiedLabel: [
                  "Are time settings received from specific, industryaccepted time sources? (This is to prevent a malicious individual from changing the clock). ",
                  "Optionally, those updates can be encrypted with a symmetric key, and access control lists can be created that specify the IP addresses of client machines that will be provided with the time updates (to prevent unauthorized use of internal time servers).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "13706c1e-4987-4827-96a6-986bdb263c0d",
                component: "col",
                label: ["Examine system configurations."],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4840efd8-a045-4c12-8239-8aee18339c88",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8a6d1e69-613e-45c0-9fdd-10fe61feae44"],
                },
              },
              {
                _uid: "8a6d1e69-613e-45c0-9fdd-10fe61feae44",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "05b46e71-9244-4ff6-b62e-0d42ca657114_4840efd8-a045-4c12-8239-8aee18339c88",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "af6c8a40-394b-4f85-9dcb-026ffd7218eb",
                component: "col",
                label: "10.5",
                simplifiedLabel: "10.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7699dbd7-6827-4ff8-b42b-c24648fde475",
                component: "col",
                label:
                  "Are audit trails secured so they cannot be altered, as follows:",
                simplifiedLabel:
                  "Are audit trails secured so they cannot be altered, as follows:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "546f6196-87b3-4e96-8b34-576945a1ba72",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d2c7700-e9c9-41b7-bcd5-faa9fad44524",
                component: "col",
                label: "10.5.1",
                simplifiedLabel: "10.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ffb9cf95-ee1f-4f42-8b9c-897483ef066e",
                component: "col",
                label: [
                  "Is viewing of audit trails limited to those with a job-related need?",
                ],
                simplifiedLabel: [
                  "Is viewing of audit trails limited to those with a job-related need?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f2d772a4-2319-410c-9636-e54f3b2af9f0",
                component: "col",
                label: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                simplifiedLabel: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "853e97aa-e9b5-4e87-b9b9-88ccfa976606",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["de6b618e-213f-4742-a4af-0a39bd1ce8c1"],
                },
              },
              {
                _uid: "de6b618e-213f-4742-a4af-0a39bd1ce8c1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "e2e501e6-99bd-4add-a7e4-85cbb732e925_853e97aa-e9b5-4e87-b9b9-88ccfa976606",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c55798b0-4e81-45eb-ae3d-8136b67c977c",
                component: "col",
                label: "10.5.2",
                simplifiedLabel: "10.5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8221f329-f34f-4e5c-8471-e6d4c0dbb42a",
                component: "col",
                label: [
                  "Are audit trail files protected from unauthorized modifications via access control mechanisms, physical segregation, and/or network segregation?",
                ],
                simplifiedLabel: [
                  "Are audit trail files protected from unauthorized modifications via access control mechanisms, physical segregation, and/or network segregation?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d6d2aaa9-2067-462a-aafc-ed761c247b7c",
                component: "col",
                label: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                simplifiedLabel: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "94eb0967-7f72-4da1-8b76-71b8a3f6b4b1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c382b718-3672-4938-a561-c9fb242329d3"],
                },
              },
              {
                _uid: "c382b718-3672-4938-a561-c9fb242329d3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "888e4d7f-d42f-425f-8119-6eed4779b246_94eb0967-7f72-4da1-8b76-71b8a3f6b4b1",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f2b74e21-af54-460a-abfe-93dce3b17aeb",
                component: "col",
                label: "10.5.3",
                simplifiedLabel: "10.5.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2b758599-235b-4369-ad1c-5c1d95c4e875",
                component: "col",
                label: [
                  "Are audit trail files promptly backed up to a centralized log server or media that is difficult to alter?",
                ],
                simplifiedLabel: [
                  "Are audit trail files promptly backed up to a centralized log server or media that is difficult to alter?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "64c5ac80-d5e7-44c2-b22d-5629bafe1415",
                component: "col",
                label: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                simplifiedLabel: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "77f97e8c-cdcb-40e0-849c-c88c5cace0d4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["129bb1d2-dc17-42b6-8d8e-85b127d25449"],
                },
              },
              {
                _uid: "129bb1d2-dc17-42b6-8d8e-85b127d25449",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d505ed2b-8af9-415c-807f-405d7bd9a953_77f97e8c-cdcb-40e0-849c-c88c5cace0d4",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "03b25c50-8375-46d7-a78a-ce34a2e78d26",
                component: "col",
                label: "10.5.4",
                simplifiedLabel: "10.5.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1f2e7a2d-ca6e-498a-9237-cc8b2a9aa6b5",
                component: "col",
                label: [
                  "Are logs for external-facing technologies (for example, wireless, firewalls, DNS, mail) written onto a secure, centralized, internal log server or media?",
                ],
                simplifiedLabel: [
                  "Are logs for external-facing technologies (for example, wireless, firewalls, DNS, mail) written onto a secure, centralized, internal log server or media?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3f30baf5-c4a6-46f5-8da8-377dd28c9324",
                component: "col",
                label: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                simplifiedLabel: [
                  "Interview system administrators.",
                  "Examine system configurations and permissions.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7a2a316d-9241-4303-b762-1442dac6965f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["58a24c89-c552-431a-a769-fdd80e7a9af5"],
                },
              },
              {
                _uid: "58a24c89-c552-431a-a769-fdd80e7a9af5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9b47833a-9670-4b18-a2e9-44e588a1348b_7a2a316d-9241-4303-b762-1442dac6965f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6141997e-72c8-48b7-aadc-cea181bd309d",
                component: "col",
                label: "10.5.5",
                simplifiedLabel: "10.5.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "572e4411-3993-4014-89fe-33aa13da421c",
                component: "col",
                label: [
                  "Is file-integrity monitoring or change-detection software used on logs to ensure that existing log data cannot be changed without generating alerts (although new data being added should not cause an alert)?",
                ],
                simplifiedLabel: [
                  "Is file-integrity monitoring or change-detection software used on logs to ensure that existing log data cannot be changed without generating alerts (although new data being added should not cause an alert)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4df1cf59-1866-4ffb-ab0f-08ff8f4dcda3",
                component: "col",
                label: [
                  "Examine settings, monitored files, and results from monitoring activities.",
                ],
                simplifiedLabel: [
                  "Examine settings, monitored files, and results from monitoring activities.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "65c2a591-5852-4040-928d-a2d0038b36a8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3bfac812-db78-40bc-bb55-7857200f5031"],
                },
              },
              {
                _uid: "3bfac812-db78-40bc-bb55-7857200f5031",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "62007a32-dde8-488e-bf45-b0a9b2980e85_65c2a591-5852-4040-928d-a2d0038b36a8",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bf183635-7f2e-4bd3-84d2-a13e8b7c89b0",
                component: "col",
                label: "10.6",
                simplifiedLabel: "10.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "51a5218b-82d0-47de-a5e3-e3d78b79365c",
                component: "col",
                label: [
                  "Are logs and security events for all system components reviewed to identify anomalies or suspicious activity as follows?",
                  "Note: Log harvesting, parsing, and alerting tools may be used to achieve compliance with Requirement 10.6.",
                ],
                simplifiedLabel: [
                  "Are logs and security events for all system components reviewed to identify anomalies or suspicious activity as follows?",
                  "Note: Log harvesting, parsing, and alerting tools may be used to achieve compliance with Requirement 10.6.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "89b0708f-6811-4e72-ad3b-cf2af14c49f0",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f9e0762a-d14c-4828-a251-9411c29d61c3",
                component: "col",
                label: "10.6.1 (b)",
                simplifiedLabel: "10.6.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "89c1c0f7-d54c-429e-bab4-de1b48d838d1",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                labelWithUl: {
                  label:
                    "Are the following logs and security events reviewed at least daily, either manually or via log tools?",
                  simplifiedLabel:
                    "Are the following logs and security events reviewed at least daily, either manually or via log tools?",
                  ul: [
                    "All security events",
                    "Logs of all system components that store, process, or transmit CHD and/or SAD",
                    "Logs of all critical system components",
                    "Logs of all servers and system components that perform security functions (for example, firewalls, intrusion-detection systems/intrusion-prevention systems (IDS/IPS), authentication servers, ecommerce redirection servers, etc.)",
                  ],
                  pr: "",
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fb538055-4f6b-44c8-9793-894a0553251a",
                component: "col",
                label: ["Review security policies and procedures."],
                simplifiedLabel: ["Review security policies and procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e61d5636-1a52-4915-9a7f-6dd8992e8306",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c4d09e28-ec68-4ce9-b76c-b7ddb64670b3"],
                },
              },
              {
                _uid: "c4d09e28-ec68-4ce9-b76c-b7ddb64670b3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "494b869e-c4b1-4734-85dd-18c9ffe94e1c_e61d5636-1a52-4915-9a7f-6dd8992e8306",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "96942dd8-8f42-4827-8715-e0a56c115640",
                component: "col",
                label: "10.6.2 (b)",
                simplifiedLabel: "10.6.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2a4c875c-9688-4bc0-8706-4d254c533b0a",
                component: "col",
                label: [
                  "Are logs of all other system components periodically reviewed—either manually or via log tools—based on the organization’s policies and risk management strategy?",
                ],
                simplifiedLabel: [
                  "Are logs of all other system components periodically reviewed—either manually or via log tools—based on the organization’s policies and risk management strategy?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "588792c7-98e6-473d-8b46-ae58aabd37d6",
                component: "col",
                label: ["Observe processes.", "Interview personnel."],
                simplifiedLabel: ["Observe processes.", "Interview personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a18b102e-9293-4bad-b6ef-e852dd0410a2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d95b30a3-13e4-4136-aabd-7aa26afb7089"],
                },
              },
              {
                _uid: "d95b30a3-13e4-4136-aabd-7aa26afb7089",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "97645dbd-e266-446b-97c7-ff41534bd339_a18b102e-9293-4bad-b6ef-e852dd0410a2",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fa4e6b72-5163-4837-b468-404a2331a5bb",
                component: "col",
                label: "10.6.3 (b)",
                simplifiedLabel: "10.6.3 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b22423ab-0023-4e94-b5ca-2b7fbfd13cda",
                component: "col",
                label: [
                  "Is follow up to exceptions and anomalies identified during the review process performed?",
                ],
                simplifiedLabel: [
                  "Is follow up to exceptions and anomalies identified during the review process performed?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1e1925b9-47d8-451c-84a5-f66544d2434e",
                component: "col",
                label: [
                  "Review security policies and procedures",
                  "Observe processes",
                  "Interview personnel.",
                ],
                simplifiedLabel: [
                  "Review security policies and procedures",
                  "Observe processes",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "71ce7e87-5d04-493d-9509-0af06dd0266f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e0efdbeb-8bec-4831-ad53-3de7d1101b7d"],
                },
              },
              {
                _uid: "e0efdbeb-8bec-4831-ad53-3de7d1101b7d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "e5077b9d-84dc-49ed-a29f-73a243076107_71ce7e87-5d04-493d-9509-0af06dd0266f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7d10f46e-84a1-4bac-81d4-6106d4116848",
                component: "col",
                label: "10.7 (b)",
                simplifiedLabel: "10.7 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "00c4f2be-4f91-41d6-bbf6-ce733f42f8e3",
                component: "col",
                label: ["Are audit logs retained for at least one year?"],
                simplifiedLabel: [
                  "Are audit logs retained for at least one year?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "173be55b-b543-4447-9296-f84d0d516e3a",
                component: "col",
                label: ["Interview personnel.", "Examine audit logs."],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Examine audit logs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9d689bd1-35e7-4bdd-abba-773e212634ce",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["ece8bde2-162a-4476-b119-36692db0b87c"],
                },
              },
              {
                _uid: "ece8bde2-162a-4476-b119-36692db0b87c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d07c90cf-7940-41df-bf7d-dc114786bd19_9d689bd1-35e7-4bdd-abba-773e212634ce",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3757031c-fb17-4087-95ba-36a4d488ff0c",
                component: "col",
                label: "10.7 (c)",
                simplifiedLabel: "10.7 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5e35b9ed-3204-498e-a329-98fe5462d958",
                component: "col",
                label: [
                  "Are at least the last three months’ logs immediately available for analysis?",
                ],
                simplifiedLabel: [
                  "Are at least the last three months’ logs immediately available for analysis?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ed5c724a-623d-4812-9222-55ee231a8bbb",
                component: "col",
                label: ["Interview personnel.", "Observe processes."],
                simplifiedLabel: ["Interview personnel.", "Observe processes."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0a85f28a-2a3a-42b8-bc6d-cd348417513f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["4e18859c-6f3d-4048-8d95-1ccf8ef8cce6"],
                },
              },
              {
                _uid: "4e18859c-6f3d-4048-8d95-1ccf8ef8cce6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "be2cbba3-8991-481b-ac41-b62ce2861465_0a85f28a-2a3a-42b8-bc6d-cd348417513f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "42530249-7c92-416a-8b40-d8c9195d55e0",
                component: "col",
                label:
                  "Requirement 11: Regularly test security systems and processes",
                simplifiedLabel:
                  "Requirement 11: Regularly test security systems and processes",
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e8c4d919-a142-4199-95b3-9d7c266a88f3",
                component: "col",
                label: "11.2.2 (a)",
                simplifiedLabel: "11.2.2 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f2f98dd8-d6d4-4111-8e28-34891fc014a4",
                component: "col",
                label: [
                  "Are quarterly external vulnerability scans performed?",
                  "Note: Quarterly external vulnerability scans must be performed by an Approved Scanning Vendor (ASV), approved by the Payment Card Industry Security Standards Council (PCI SSC).",
                  "Refer to the ASV Program Guide published on the PCI SSC website for scan customer responsibilities, scan preparation, etc",
                ],
                simplifiedLabel: [
                  "Are quarterly external vulnerability scans performed?",
                  "Note: Quarterly external vulnerability scans must be performed by an Approved Scanning Vendor (ASV), approved by the Payment Card Industry Security Standards Council (PCI SSC).",
                  "Refer to the ASV Program Guide published on the PCI SSC website for scan customer responsibilities, scan preparation, etc",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "79acc484-3476-4f6a-8279-f9817e81528f",
                component: "col",
                label: [
                  "Review results from the four most recent quarters of external vulnerability scans.",
                ],
                simplifiedLabel: [
                  "Review results from the four most recent quarters of external vulnerability scans.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3244882b-0d20-4aad-abb8-f84a55b95d44",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c7e85329-12b8-41ca-9ed1-c9508d06301b"],
                },
              },
              {
                _uid: "c7e85329-12b8-41ca-9ed1-c9508d06301b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "041cd937-afa2-47ce-9fda-b26d76328bea_3244882b-0d20-4aad-abb8-f84a55b95d44",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "43333107-7430-473a-8f43-2a89dd0d319d",
                component: "col",
                label: "11.2.2 (b)",
                simplifiedLabel: "11.2.2 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "96480c6b-dbce-480a-8a68-af7186e49923",
                component: "col",
                label: [
                  "Do external quarterly scan and rescan results satisfy the ASV Program Guide requirements for a passing scan (for example, no vulnerabilities rated 4.0 or higher by the CVSS, and no automatic failures)?",
                ],
                simplifiedLabel: [
                  "Do external quarterly scan and rescan results satisfy the ASV Program Guide requirements for a passing scan (for example, no vulnerabilities rated 4.0 or higher by the CVSS, and no automatic failures)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "854b0280-f953-4a21-ba2d-3a268da4b575",
                component: "col",
                label: [
                  "Review results of each external quarterly scan and rescan.",
                ],
                simplifiedLabel: [
                  "Review results of each external quarterly scan and rescan.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "37420ad4-f76f-4190-868c-49055b46ad66",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["3e54a99a-d191-44fa-a0d1-2d0421cbbd21"],
                },
              },
              {
                _uid: "3e54a99a-d191-44fa-a0d1-2d0421cbbd21",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4c3e3ec4-cade-46ef-a9c5-ee9faf9f1870_37420ad4-f76f-4190-868c-49055b46ad66",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "68ebdbaa-c63d-4c02-ad28-274b339392b6",
                component: "col",
                label: "11.2.2 (c)",
                simplifiedLabel: "11.2.2 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "55f82d5a-8158-4c49-b2c6-5bb1e03c9521",
                component: "col",
                label: [
                  "Are quarterly external vulnerability scans performed by a PCI SSC Approved Scanning Vendor (ASV?",
                ],
                simplifiedLabel: [
                  "Are quarterly external vulnerability scans performed by a PCI SSC Approved Scanning Vendor (ASV?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2f105869-b201-4261-84e7-1eb2c511726f",
                component: "col",
                label: [
                  "Review results of each external quarterly scan and rescan.",
                ],
                simplifiedLabel: [
                  "Review results of each external quarterly scan and rescan.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bc0ff855-7d84-4763-9598-86489bf093f3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8403be94-3ef0-4bad-89be-98b73a042132"],
                },
              },
              {
                _uid: "8403be94-3ef0-4bad-89be-98b73a042132",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "e924e743-2c9c-46e6-a3dd-c6a9780d2e40_bc0ff855-7d84-4763-9598-86489bf093f3",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ca4cf986-3a58-44a3-9f99-e128822b8c7b",
                component: "col",
                label: "11.2.3 (a)",
                simplifiedLabel: "11.2.3 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0500525e-4b40-473f-a766-960efbf323ae",
                component: "col",
                label: [
                  "Are internal and external scans, and rescans as needed, performed after any significant change?",
                  "Note: Scans must be performed by qualified personnel",
                ],
                simplifiedLabel: [
                  "Are internal and external scans, and rescans as needed, performed after any significant change?",
                  "Note: Scans must be performed by qualified personnel",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c6ef443a-5662-477f-99ff-6f7ccbaec673",
                component: "col",
                label: [
                  "Examine and correlate change control documentation and scan reports..",
                ],
                simplifiedLabel: [
                  "Examine and correlate change control documentation and scan reports..",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "556bfe2e-0789-47a7-b04e-feab7fbe7ddc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["97b0b9ad-8ed8-470e-9ad2-1eea77ed017d"],
                },
              },
              {
                _uid: "97b0b9ad-8ed8-470e-9ad2-1eea77ed017d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "aebebf98-2ad9-4ff4-94a8-80db4803fc37_556bfe2e-0789-47a7-b04e-feab7fbe7ddc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ac0729bb-40e0-430e-9ed4-dab49ac7cde1",
                component: "col",
                label: "11.2.3 (b)",
                simplifiedLabel: "11.2.3 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0d953596-4baa-4bc3-af52-a626288a5d2d",
                component: "col",
                labelWithUl: {
                  label:
                    "Does the quarterly internal scan process address all “high risk” vulnerabilities and include rescans to verify all “high-risk” vulnerabilities (as defined in PCI DSS Requirement 6.1) are resolved?",
                  simplifiedLabel:
                    "Does the quarterly internal scan process address all “high risk” vulnerabilities and include rescans to verify all “high-risk” vulnerabilities (as defined in PCI DSS Requirement 6.1) are resolved?",
                  ul: [
                    "For external scans, no vulnerabilities exist that are scored 4.0 or higher by the CVSS,",
                    "For internal scans, a passing result is obtained or all “high-risk” vulnerabilities as defined in PCI DSS Requirement 6.1 are resolved?",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3db4e9a8-fcbe-4b57-902d-52777a8e21f2",
                component: "col",
                label: ["Review scan reports."],
                simplifiedLabel: ["Review scan reports."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8ea1869f-fa7e-4d38-a0a7-d63a2e782c23",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e41a72e6-ce02-4256-8e81-e76ff60f3382"],
                },
              },
              {
                _uid: "e41a72e6-ce02-4256-8e81-e76ff60f3382",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "35a9d046-6bf2-44a9-a4b7-f1ae5409e790_8ea1869f-fa7e-4d38-a0a7-d63a2e782c23",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "86502cc4-0285-4adf-9502-8cc84a4eede4",
                component: "col",
                label: "11.2.3 (c)",
                simplifiedLabel: "11.2.3 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "920a3d9c-c6ac-45e1-8ff0-678ff9ba539c",
                component: "col",
                label: [
                  "Are scans performed by a qualified internal resource(s) or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                ],
                simplifiedLabel: [
                  "Are scans performed by a qualified internal resource(s) or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "db5ca2f3-e6df-46db-846b-407098b9f61d",
                component: "col",
                label: ["Interview personnel."],
                simplifiedLabel: ["Interview personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "73c12d87-e989-4eb9-a10e-55049490d97f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8c18fd35-6c89-4535-87d5-02793aeeffb6"],
                },
              },
              {
                _uid: "8c18fd35-6c89-4535-87d5-02793aeeffb6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "9383e0f8-b2cf-49ef-b514-917aaf70675c_73c12d87-e989-4eb9-a10e-55049490d97f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b61b4f5c-cf68-41fd-a1dc-0372f0027021",
                component: "col",
                label: "11.3",
                simplifiedLabel: "11.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9c54080f-3853-4e08-9685-260ac0947142",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Does the penetration-testing methodology include the following?",
                  simplifiedLabel:
                    "Does the penetration-testing methodology include the following?",
                  ul: [
                    "Is based on industry-accepted penetration testing approaches (for example, NIST SP800-115)",
                    "Includes coverage for the entire CDE perimeter and critical systems",
                    "Includes testing from both inside and outside the network",
                    "Includes testing to validate any segmentation and scope-reduction controls",
                    "Defines application-layer penetration tests to include, at a minimum, the vulnerabilities listed in Requirement 6.5",
                    "Defines network-layer penetration tests to include components that support network functions as well as operating systems",
                    "Includes review and consideration of threats and vulnerabilities experienced in the last 12 months",
                    "Specifies retention of penetration testing results and remediation activities results",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9b071191-1a2e-4fa3-a5f5-2163d6799928",
                component: "col",
                label: [
                  "Examine penetration-testing methodology.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine penetration-testing methodology.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "865f1a65-41d6-4f17-af67-0fac9d946ca8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["07e9014a-b9bc-4d62-8575-4e926e0e813f"],
                },
              },
              {
                _uid: "07e9014a-b9bc-4d62-8575-4e926e0e813f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "0afb6d50-3eeb-4e11-a64f-dfeafd039836_865f1a65-41d6-4f17-af67-0fac9d946ca8",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed4b55c5-6c85-4188-9600-1a4ba5a34d75",
                component: "col",
                label: "11.3.1 (a)",
                simplifiedLabel: "11.3.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f348e4ce-3f7f-4a95-93f5-b1884cb2839c",
                component: "col",
                label:
                  "Is external penetration testing performed per the defined methodology, at least annually, and after any significant infrastructure or application changes to the environment (such as an operating system upgrade, a sub-network added to the environment, or an added web server)?",
                simplifiedLabel:
                  "Is external penetration testing performed per the defined methodology, at least annually, and after any significant infrastructure or application changes to the environment (such as an operating system upgrade, a sub-network added to the environment, or an added web server)?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7b07a79b-6274-4099-9b0c-9a7ab91cc777",
                component: "col",
                label: [
                  "Examine scope of work.",
                  "Examine results from the most recent external penetration test.",
                ],
                simplifiedLabel: [
                  "Examine scope of work.",
                  "Examine results from the most recent external penetration test.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dc0bbd95-e591-41c0-b803-b43a9faba515",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["2595aa2d-6365-4d6f-bc8f-6d6ca265ca99"],
                },
              },
              {
                _uid: "2595aa2d-6365-4d6f-bc8f-6d6ca265ca99",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "43623675-5503-42fa-b369-c1bb2fbb123c_dc0bbd95-e591-41c0-b803-b43a9faba515",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa0495ba-b93d-48a1-9c29-c12b694161de",
                component: "col",
                label: "11.3.1 (b)",
                simplifiedLabel: "11.3.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0dc6bcf4-8f2f-4339-8c20-d4031a515422",
                component: "col",
                label:
                  "Are tests performed by a qualified internal resource or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                simplifiedLabel:
                  "Are tests performed by a qualified internal resource or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "21a30153-666a-4a50-97e8-64ce4b1847f3",
                component: "col",
                label: ["Interview responsible personnel."],
                simplifiedLabel: ["Interview responsible personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "574dfe95-4287-4aa4-838f-95ebbdb7c3f0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["60409d82-597c-4d52-93b9-22f13af90532"],
                },
              },
              {
                _uid: "60409d82-597c-4d52-93b9-22f13af90532",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "288a02c4-7879-4f37-baf0-1aac217fd2ba_574dfe95-4287-4aa4-838f-95ebbdb7c3f0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "16351c52-cca9-4349-884a-fe5f1603f8df",
                component: "col",
                label: "11.3.3",
                simplifiedLabel: "11.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fed3afdb-9f8e-41ff-a365-82fba854aec8",
                component: "col",
                label:
                  "Are exploitable vulnerabilities found during penetration testing corrected, followed by repeated testing to verify the corrections?",
                simplifiedLabel:
                  "Are exploitable vulnerabilities found during penetration testing corrected, followed by repeated testing to verify the corrections?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "994fabc4-9cfb-4e20-bbd3-6b457db3bc68",
                component: "col",
                label: ["Examine penetration testing results."],
                simplifiedLabel: ["Examine penetration testing results."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5db2c52c-8d58-4df4-9c53-1255eac9d259",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["71737895-f667-484f-928d-e42e236d0258"],
                },
              },
              {
                _uid: "71737895-f667-484f-928d-e42e236d0258",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4db92022-567e-472d-8844-2ccd03fb0cd1_5db2c52c-8d58-4df4-9c53-1255eac9d259",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "85721d49-6ccb-431e-918d-aa83a845fb73",
                component: "col",
                label: "11.3.4",
                simplifiedLabel: "11.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d0d1d454-b8bf-4757-bda9-d6d9b7c74ca0",
                component: "col",
                label: [
                  "If segmentation is used to isolate the CDE from other networks: ",
                ],
                simplifiedLabel: [
                  "If segmentation is used to isolate the CDE from other networks: ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "659ca89c-74ba-46e3-a443-dfa2460c7f29",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "45d69d22-6dde-4ebc-93cc-bf19d1311188",
                component: "col",
                label: "11.3.4 (a)",
                simplifiedLabel: "11.3.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "692250bd-4bc7-4dfd-a300-62eaf9824c0e",
                component: "col",
                label: [
                  "Are penetration-testing procedures defined to test all segmentation methods, to confirm they are operational and effective, and isolate all out-ofscope systems from systems in the CDE?",
                ],
                simplifiedLabel: [
                  "Are penetration-testing procedures defined to test all segmentation methods, to confirm they are operational and effective, and isolate all out-ofscope systems from systems in the CDE?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1bfdfd98-920f-46f9-bf46-39ad723e73ca",
                component: "col",
                label: [
                  "Examine segmentation controls.",
                  "Review penetration-testing methodology.",
                ],
                simplifiedLabel: [
                  "Examine segmentation controls.",
                  "Review penetration-testing methodology.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3ae6c1d9-645e-44c8-8a9a-c2c8e904c1b8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c23ffc1e-e634-4873-8758-fc9c915fdf78"],
                },
              },
              {
                _uid: "c23ffc1e-e634-4873-8758-fc9c915fdf78",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6f514299-5d94-459e-b401-58e57c8d8ee2_3ae6c1d9-645e-44c8-8a9a-c2c8e904c1b8",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "534cabf2-c9cb-4ede-af8a-82d3fc4ad498",
                component: "col",
                label: "11.3.4 (b)",
                simplifiedLabel: "11.3.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1a7f137b-5cd5-4834-b4ab-e607cfeacca9",
                component: "col",
                labelWithUl: {
                  label:
                    "Does penetration testing to verify segmentation controls meet the following?",
                  simplifiedLabel:
                    "Does penetration testing to verify segmentation controls meet the following?",
                  ul: [
                    "Performed at least annually and after any changes to segmentation controls/methods.",
                    "Covers all segmentation controls/methods in use.",
                    "Verifies that segmentation methods are operational and effective, and isolate all out-ofscope systems from systems in the CDE.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e03cf1b2-dfee-40e1-ba55-171e87c7fdb6",
                component: "col",
                label: [
                  "Examine results from the most recent penetration test.",
                ],
                simplifiedLabel: [
                  "Examine results from the most recent penetration test.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8d4ec176-0619-442b-b392-a2dd40146705",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["0d5da690-311a-4803-8385-3cf8b5a69513"],
                },
              },
              {
                _uid: "0d5da690-311a-4803-8385-3cf8b5a69513",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "bb9a10f5-a10f-4be9-80df-0feec39b66ff_8d4ec176-0619-442b-b392-a2dd40146705",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cd792c41-77e3-4a77-9518-5bb79491e0b1",
                component: "col",
                label: "11.3.4 (c)",
                simplifiedLabel: "11.3.4 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f6101038-a066-41b2-b65f-b61a0c7e5536",
                component: "col",
                label: [
                  "Are tests performed by a qualified internal resource or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                ],
                simplifiedLabel: [
                  "Are tests performed by a qualified internal resource or qualified external third party, and if applicable, does organizational independence of the tester exist (not required to be a QSA or ASV)?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c61a27d2-5858-4440-9e77-3de08256afd1",
                component: "col",
                label: ["Interview responsible personnel."],
                simplifiedLabel: ["Interview responsible personnel."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b96d00a1-12fe-445f-b248-924365981795",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f718c0a3-7256-4426-ab62-f113b39a2769"],
                },
              },
              {
                _uid: "f718c0a3-7256-4426-ab62-f113b39a2769",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6fd4ccba-7679-4628-9e18-41909918c95f_b96d00a1-12fe-445f-b248-924365981795",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "819a42b4-6f7a-4dc7-9b3e-c6c25877308e",
                component: "col",
                label: "11.4 (a)",
                simplifiedLabel: "11.4 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8deb2afc-a95a-4a66-902c-035c076b95b3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                labelWithUl: {
                  label:
                    "Are intrusion-detection and/or intrusion-prevention techniques that detect and/or prevent intrusions into the network in place to monitor all traffic: ",
                  simplifiedLabel:
                    "Are intrusion-detection and/or intrusion-prevention techniques that detect and/or prevent intrusions into the network in place to monitor all traffic: ",
                  ul: [
                    "At the perimeter of the cardholder data environment, and",
                    "At critical points in the cardholder data environment.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "af625a44-408f-4ff7-88b9-81df81d077cf",
                component: "col",
                label: [
                  "Examine system configurations.",
                  "Examine network diagrams.",
                ],
                simplifiedLabel: [
                  "Examine system configurations.",
                  "Examine network diagrams.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "755347ef-e77d-40a3-9161-0124060fdfb9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["099566a5-1f96-418a-bd42-960bb531bdd3"],
                },
              },
              {
                _uid: "099566a5-1f96-418a-bd42-960bb531bdd3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "01b052a8-c5ff-4579-a309-9d60b7b8fc65_755347ef-e77d-40a3-9161-0124060fdfb9",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7b703431-875b-4546-962d-fb22df7b0143",
                component: "col",
                label: "11.4 (b)",
                simplifiedLabel: "11.4 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "de484f5a-91bd-4919-b0b4-e674b7ba8fdf",
                component: "col",
                label:
                  "Are intrusion-detection and/or intrusion-prevention techniques configured to alert personnel of suspected compromises?",
                simplifiedLabel:
                  "Are intrusion-detection and/or intrusion-prevention techniques configured to alert personnel of suspected compromises?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "05ac201f-75e4-45f5-8fd3-8d6fd240ff6c",
                component: "col",
                label: [
                  "Examine system configurations.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Examine system configurations.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ccfd5e61-506f-4ac4-a655-7cce155bc735",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["284ba762-9301-4dba-b212-455d3e87880b"],
                },
              },
              {
                _uid: "284ba762-9301-4dba-b212-455d3e87880b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fccdc118-1e35-49e4-bb01-5fe9bff6151e_ccfd5e61-506f-4ac4-a655-7cce155bc735",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1f0492e8-82cb-4c1e-8599-197bb68096ae",
                component: "col",
                label: "11.4 (c)",
                simplifiedLabel: "11.4 (c)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8b306640-e915-438f-b08b-9be83090c47a",
                component: "col",
                label:
                  "Are all intrusion-detection and prevention engines, baselines, and signatures kept up-to-date?",
                simplifiedLabel:
                  "Are all intrusion-detection and prevention engines, baselines, and signatures kept up-to-date?",
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6ce829f0-7b51-46d9-bdb2-a87c582c1dce",
                component: "col",
                label: [
                  "Examine IDS/IPS configurations.",
                  "Examine vendor documentation.",
                ],
                simplifiedLabel: [
                  "Examine IDS/IPS configurations.",
                  "Examine vendor documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "79f547b0-4eb2-45f8-8d47-f3c549762adc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["07d2ce46-8486-47b8-b5f4-30042874bab4"],
                },
              },
              {
                _uid: "07d2ce46-8486-47b8-b5f4-30042874bab4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2692d720-ae52-4b72-88eb-7ed30454e8c5_79f547b0-4eb2-45f8-8d47-f3c549762adc",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1c029b1-7bf5-49c4-b680-d965fdbde9a5",
                component: "col",
                label: "11.5 (a)",
                simplifiedLabel: "11.5 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fe536382-61d0-4be9-a027-a40b692a0b30",
                component: "col",
                labelWithUl: {
                  label: [
                    "Is a change-detection mechanism (for example, file-integrity monitoring tools) deployed to detect unauthorized modification (including changes, additions, and deletions) of critical system files, configuration files, or content files?",
                    "Examples of files that should be monitored include:",
                  ],
                  simplifiedLabel: [
                    "Is a change-detection mechanism (for example, file-integrity monitoring tools) deployed to detect unauthorized modification (including changes, additions, and deletions) of critical system files, configuration files, or content files?",
                    "Examples of files that should be monitored include:",
                  ],
                  ul: [
                    "System executables",
                    "Application executables",
                    "Configuration and parameter files",
                    "Centrally stored, historical or archived, log, and audit files",
                    "Additional critical files determined by entity (for example, through risk assessment or other means)",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a99a5d9f-5f19-4801-b655-ade6b8093b1b",
                component: "col",
                label: [
                  "Observe system settings and monitored files.",
                  "Examine system configuration settings.",
                ],
                simplifiedLabel: [
                  "Observe system settings and monitored files.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a3acceb3-0e97-4cf7-bc33-ed9e55fb5a68",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["db1de04c-e12b-417c-bd79-ac748989f02f"],
                },
              },
              {
                _uid: "db1de04c-e12b-417c-bd79-ac748989f02f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ce45bf24-58e7-4884-b3da-c1c68de5251d_a3acceb3-0e97-4cf7-bc33-ed9e55fb5a68",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "426249b8-3fb5-4c1d-bc99-27cbb128f2c5",
                component: "col",
                label: "11.5(cont.)(b)",
                simplifiedLabel: "11.5(cont.)(b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "404b022f-3cc1-43e9-b13c-4f31ff7ddc82",
                component: "col",
                label: [
                  "Is the change-detection mechanism configured to alert personnel to unauthorized modification (including changes, additions, and deletions) of critical system files, configuration files or content files, and do the tools perform critical file comparisons at least weekly?",
                  "Note: For change detection purposes, critical files are usually those that do not regularly change, but the modification of which could indicate a system compromise or risk of compromise. Change detection mechanisms such as file-integrity monitoring products usually come pre-configured with critical files for the related operating system. Other critical files, such as those for custom applications, must be evaluated and defined by the entity (that is the merchant or service provider).",
                ],
                simplifiedLabel: [
                  "Is the change-detection mechanism configured to alert personnel to unauthorized modification (including changes, additions, and deletions) of critical system files, configuration files or content files, and do the tools perform critical file comparisons at least weekly?",
                  "Note: For change detection purposes, critical files are usually those that do not regularly change, but the modification of which could indicate a system compromise or risk of compromise. Change detection mechanisms such as file-integrity monitoring products usually come pre-configured with critical files for the related operating system. Other critical files, such as those for custom applications, must be evaluated and defined by the entity (that is the merchant or service provider).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "093b7fd1-6fb9-4046-8316-02855f221b98",
                component: "col",
                label: [
                  "Observe system settings and monitored files.",
                  "Review results from monitoring activities.",
                ],
                simplifiedLabel: [
                  "Observe system settings and monitored files.",
                  "Review results from monitoring activities.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "34389f45-c288-431d-a6ff-89d09ea31cd0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a6824203-5130-458f-922d-817ec82caa89"],
                },
              },
              {
                _uid: "a6824203-5130-458f-922d-817ec82caa89",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "1959b27d-f7dc-49d9-829e-9026efbf6f74_34389f45-c288-431d-a6ff-89d09ea31cd0",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b48111e0-6383-448c-9c23-5930b3a34db6",
                component: "col",
                label: "11.5.1",
                simplifiedLabel: "11.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8e5aaa04-5996-40c3-a573-050e4d9e34a0",
                component: "col",
                label: [
                  "Is a process in place to respond to any alerts generated by the change-detection solution?",
                ],
                simplifiedLabel: [
                  "Is a process in place to respond to any alerts generated by the change-detection solution?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "98580f3f-025d-49f7-ac53-afd5d8c65d68",
                component: "col",
                label: ["Examine system configuration settings."],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "783075f4-2b0d-421c-8ac5-7b7eb21499f7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["c73342fe-88b7-48f5-94eb-a580d1486e64"],
                },
              },
              {
                _uid: "c73342fe-88b7-48f5-94eb-a580d1486e64",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b7a3531c-c1fb-4ac0-9fc3-1d1994a2cfe7_783075f4-2b0d-421c-8ac5-7b7eb21499f7",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9a0e6b09-ea9c-4d69-b3ba-626b57e2f153",
                component: "col",
                label: [
                  "Maintain an Information Security Policy",
                  "Requirement 12: Maintain a policy that addresses information security for all personnel",
                  "Note: For the purposes of Requirement 12, “personnel” refers to full-time part-time employees, temporary employees and personnel, and contractors and consultants who are “resident” on the entity’s site or otherwise have access to the company’s site cardholder data environment.",
                ],
                simplifiedLabel: [
                  "Maintain an Information Security Policy",
                  "Requirement 12: Maintain a policy that addresses information security for all personnel",
                  "Note: For the purposes of Requirement 12, “personnel” refers to full-time part-time employees, temporary employees and personnel, and contractors and consultants who are “resident” on the entity’s site or otherwise have access to the company’s site cardholder data environment.",
                ],
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4685a0c0-09e3-4012-9eb5-d54d738ab2fb",
                component: "col",
                label: "12.1",
                simplifiedLabel: "12.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fc38a241-1846-45c8-bb5f-b49cab4824fc",
                component: "col",
                label: [
                  "Is a security policy established, published, maintained, and disseminated to all relevant personnel?",
                ],
                simplifiedLabel: [
                  "Is a security policy established, published, maintained, and disseminated to all relevant personnel?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4fcec56f-62aa-4e3e-ac57-812f1c69fce1",
                component: "col",
                label: ["Review the information security policy."],
                simplifiedLabel: ["Review the information security policy."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8524f1a4-0600-4e3b-9208-10b08ca8c626",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["526c8f3c-7fb3-4395-8511-366d0d43d756"],
                },
              },
              {
                _uid: "526c8f3c-7fb3-4395-8511-366d0d43d756",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "562fc8fe-f3b7-4683-8258-62dbb0979985_8524f1a4-0600-4e3b-9208-10b08ca8c626",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d30e5173-d0a7-4926-9781-c1c16b06535e",
                component: "col",
                label: "12.1.1",
                simplifiedLabel: "12.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8e7fcf0a-0d6d-48db-a488-555f9edd0368",
                component: "col",
                label: [
                  "Is the security policy reviewed at least annually and updated when the environment changes?",
                ],
                simplifiedLabel: [
                  "Is the security policy reviewed at least annually and updated when the environment changes?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3e8be408-9824-4452-900c-6938b7900826",
                component: "col",
                label: [
                  "Review the information security policy.",
                  "Interview responsible personnel.",
                ],
                simplifiedLabel: [
                  "Review the information security policy.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5f3f8ab3-ebc5-46b4-8476-bce17ca78545",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["7b312a4d-95ba-494e-9608-3b292b7229c7"],
                },
              },
              {
                _uid: "7b312a4d-95ba-494e-9608-3b292b7229c7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2bfb1c10-fa17-40d5-b8bc-6399b5129fc5_5f3f8ab3-ebc5-46b4-8476-bce17ca78545",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24ab07e3-6c21-4f8d-825e-17975fe13332",
                component: "col",
                label: "12.4",
                simplifiedLabel: "12.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "cd2536cd-05f7-4aa8-9275-86d3c9d47669",
                component: "col",
                label: [
                  "Do security policy and procedures clearly define information security responsibilities for all personnel?",
                ],
                simplifiedLabel: [
                  "Do security policy and procedures clearly define information security responsibilities for all personnel?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fc38eb0d-f6a1-4d29-869a-fc3aff55ee35",
                component: "col",
                label: [
                  "Review information security policy and procedures.",
                  "Interview a sample of responsible personnel.",
                ],
                simplifiedLabel: [
                  "Review information security policy and procedures.",
                  "Interview a sample of responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c8ab7fe5-083e-48cc-b5dc-301fa9b86933",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["94f4a95a-f1cd-45af-8f0b-28026be6c898"],
                },
              },
              {
                _uid: "94f4a95a-f1cd-45af-8f0b-28026be6c898",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "ffc57721-ccf3-4084-b7c6-8a895760c0a5_c8ab7fe5-083e-48cc-b5dc-301fa9b86933",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b861c42a-fe3b-4b61-bcdd-5fcfe02ca4e4",
                component: "col",
                label: "12.5 (b)",
                simplifiedLabel: "12.5 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f6ef1ceb-cce2-4802-b611-fa7183f83a64",
                component: "col",
                label: [
                  "Are the following information security management responsibilities formally assigned to an individual or team:",
                ],
                simplifiedLabel: [
                  "Are the following information security management responsibilities formally assigned to an individual or team:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ad9af599-f10a-44f0-8740-851172394164",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b497844a-16c1-45bb-ad8b-f7a1a018354c",
                component: "col",
                label: "12.5.3",
                simplifiedLabel: "12.5.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7ded8e84-0a87-49a5-8496-89fc1a9e6970",
                component: "col",
                label: [
                  "Establishing, documenting, and distributing security incident response and escalation procedures to ensure timely and effective handling of all situations?",
                ],
                simplifiedLabel: [
                  "Establishing, documenting, and distributing security incident response and escalation procedures to ensure timely and effective handling of all situations?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "339834c4-1da6-40be-ad57-88c71ab3a666",
                component: "col",
                label: ["Review information security policy and procedures."],
                simplifiedLabel: [
                  "Review information security policy and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ab163f88-a49f-4a71-b3d1-01ef71e2727f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["6beea6e0-4a5c-42cb-95aa-0b446f485403"],
                },
              },
              {
                _uid: "6beea6e0-4a5c-42cb-95aa-0b446f485403",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "fb62ac6e-4323-4e90-8244-26f8465b158d_ab163f88-a49f-4a71-b3d1-01ef71e2727f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "03c4b45a-d75f-4ddd-9cf6-08e11894ff6d",
                component: "col",
                label: "12.6 (a)",
                simplifiedLabel: "12.6 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "78589d57-13e5-4a94-b1f0-3418f697d336",
                component: "col",
                label: [
                  "Is a formal security awareness program in place to make all personnel aware of the cardholder data security policy and procedures?",
                ],
                simplifiedLabel: [
                  "Is a formal security awareness program in place to make all personnel aware of the cardholder data security policy and procedures?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "923f11ba-befc-49a1-a5f3-d6a9d4178b6b",
                component: "col",
                label: ["Review security awareness program"],
                simplifiedLabel: ["Review security awareness program"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7dc7dbf0-1f78-4143-b350-f326f0196355",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["6959b4ce-8b77-4564-ba37-eafdf2cde39f"],
                },
              },
              {
                _uid: "6959b4ce-8b77-4564-ba37-eafdf2cde39f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6b0cadbd-70ce-4486-b5b6-0438d742d22a_7dc7dbf0-1f78-4143-b350-f326f0196355",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "44ad4cad-033e-4e3e-ac39-bff5b1a87788",
                component: "col",
                label: "12.8",
                simplifiedLabel: "12.8",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1149afea-3b31-4632-92fd-230b5209bfa5",
                component: "col",
                label: [
                  "Are policies and procedures maintained and implemented to manage service providers with whom cardholder data is shared, or that could affect the security of cardholder data, as follows:",
                ],
                simplifiedLabel: [
                  "Are policies and procedures maintained and implemented to manage service providers with whom cardholder data is shared, or that could affect the security of cardholder data, as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ec7698e1-a54d-4112-82ed-b593b4ad0ee3",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "26c760f0-cfa9-4e8c-b0a8-32fdad8888a0",
                component: "col",
                label: "12.8.1",
                simplifiedLabel: "12.8.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6a9aad46-b7c2-4d79-8b03-d3685423b983",
                component: "col",
                label: [
                  "Is a list of service providers maintained, including a description of the service(s) provided?",
                ],
                simplifiedLabel: [
                  "Is a list of service providers maintained, including a description of the service(s) provided?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "508dbfff-8f30-4114-b261-64f397e8386d",
                component: "col",
                label: [
                  "Review policies and procedures.",
                  "Observe processes.",
                  "Review list of service providers.",
                ],
                simplifiedLabel: [
                  "Review policies and procedures.",
                  "Observe processes.",
                  "Review list of service providers.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "84e6fed4-620e-442b-9840-163677f58142",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a9b2af17-55e3-48ff-92a4-aab57d96f854"],
                },
              },
              {
                _uid: "a9b2af17-55e3-48ff-92a4-aab57d96f854",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "6708103a-9ff5-4c93-aa93-3c176774ef40_84e6fed4-620e-442b-9840-163677f58142",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e7b05396-e682-4fda-bc9d-a5590ef59a52",
                component: "col",
                label: "12.8.2",
                simplifiedLabel: "12.8.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5ac3bec8-1e65-45ee-9ae4-9cdb3a1ddfdd",
                component: "col",
                label: [
                  "Is a written agreement maintained that includes an acknowledgement that the service providers are responsible for the security of cardholder data the service providers possess or otherwise store, process, or transmit on behalf of the customer, or to the extent that they could impact the security of the customer’s cardholder data environment?",
                  "Note: The exact wording of an acknowledgement will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgement does not have to include the exact wording provided in this requirement.",
                ],
                simplifiedLabel: [
                  "Is a written agreement maintained that includes an acknowledgement that the service providers are responsible for the security of cardholder data the service providers possess or otherwise store, process, or transmit on behalf of the customer, or to the extent that they could impact the security of the customer’s cardholder data environment?",
                  "Note: The exact wording of an acknowledgement will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgement does not have to include the exact wording provided in this requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fd38b332-4f2e-4483-b864-96be1665ac8e",
                component: "col",
                label: [
                  "Observe written agreements.",
                  "Review policies and procedures.",
                ],
                simplifiedLabel: [
                  "Observe written agreements.",
                  "Review policies and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "397d4c72-06ec-4e47-868f-ba0a0173b697",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8a7f329f-eea0-477f-b208-46b9857fe90c"],
                },
              },
              {
                _uid: "8a7f329f-eea0-477f-b208-46b9857fe90c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "932bbcf1-2844-46e3-ba5d-5ed5fd7cc81a_397d4c72-06ec-4e47-868f-ba0a0173b697",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8b00befc-6a66-4348-ac85-6004e8a9bfb8",
                component: "col",
                label: "12.8.3",
                simplifiedLabel: "12.8.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a8b156ea-b0a3-47f7-a3b7-4d280c8be10c",
                component: "col",
                label: [
                  "Is there an established process for engaging service providers, including proper due diligence prior to engagement?",
                ],
                simplifiedLabel: [
                  "Is there an established process for engaging service providers, including proper due diligence prior to engagement?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "da76970b-2eec-410f-ae8c-619b9461ce94",
                component: "col",
                label: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                simplifiedLabel: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3d34f367-82fb-40d8-9bd3-ab1de6bc672f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["8d2e1866-f190-4778-ad85-f23b25c17005"],
                },
              },
              {
                _uid: "8d2e1866-f190-4778-ad85-f23b25c17005",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a2c6b946-2e8a-4b47-84ed-ba1c378ce382_3d34f367-82fb-40d8-9bd3-ab1de6bc672f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "42609508-d23f-4074-b8a7-a381759b6c8a",
                component: "col",
                label: "12.8.4",
                simplifiedLabel: "12.8.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "764a7a21-f70d-44e5-a2af-004611ce0eff",
                component: "col",
                label: [
                  "Is a program maintained to monitor service providers’ PCI DSS compliance status at least annually?",
                ],
                simplifiedLabel: [
                  "Is a program maintained to monitor service providers’ PCI DSS compliance status at least annually?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "36e18908-ae08-4f7a-b45f-8126c574ca54",
                component: "col",
                label: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                simplifiedLabel: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c524d853-088b-474d-8f97-143d63ae5f64",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f50292d6-9e38-47dc-b80d-5a9210f4c413"],
                },
              },
              {
                _uid: "f50292d6-9e38-47dc-b80d-5a9210f4c413",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c51d7b8d-addb-46fe-9c50-e0eecc8bd690_c524d853-088b-474d-8f97-143d63ae5f64",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "329884d8-4d36-4bc4-adbf-5fb311bfd261",
                component: "col",
                label: "12.8.5",
                simplifiedLabel: "12.8.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6030d690-7472-4cbc-954b-c94b8a795619",
                component: "col",
                label: [
                  "Is information maintained about which PCI DSS requirements are managed by each service provider, and which are managed by the entity?",
                ],
                simplifiedLabel: [
                  "Is information maintained about which PCI DSS requirements are managed by each service provider, and which are managed by the entity?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "99c1b31b-1974-4e00-a017-c120f4953d9d",
                component: "col",
                label: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                simplifiedLabel: [
                  "Observe processes.",
                  "Review policies and procedures and supporting documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9e9fbb1b-5732-4762-a565-fd9a081e967d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["a80cd2ab-c900-46b6-9350-02edd3b33bee"],
                },
              },
              {
                _uid: "a80cd2ab-c900-46b6-9350-02edd3b33bee",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a06ea35f-59b8-4098-9f20-ed7232db5aeb_9e9fbb1b-5732-4762-a565-fd9a081e967d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "50821c52-a38d-4f20-a071-7cc62fd22f33",
                component: "col",
                label: "12.10.1 (a)",
                simplifiedLabel: "12.10.1 (a)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ea6644e0-eba9-4ce7-afbd-73661ec9b430",
                component: "col",
                label: [
                  "Has an incident response plan been created to be implemented in the event of system breach?",
                ],
                simplifiedLabel: [
                  "Has an incident response plan been created to be implemented in the event of system breach?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1c171024-880e-41b5-94a4-0b28ebb236ad",
                component: "col",
                label: [
                  "Review the incident response plan.",
                  "Review incident response plan procedures.",
                ],
                simplifiedLabel: [
                  "Review the incident response plan.",
                  "Review incident response plan procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7d3cc68c-21ff-4e73-a0d3-16aaed797ede",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["6d734c68-9c66-44e9-9d58-9e857c1a5957"],
                },
              },
              {
                _uid: "6d734c68-9c66-44e9-9d58-9e857c1a5957",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "d03e634d-3456-4495-bbc9-6baf36092c39_7d3cc68c-21ff-4e73-a0d3-16aaed797ede",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0eb5e330-e787-4903-91b4-1eccd32faef7",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c4feb302-098c-4828-9331-3b872fddbe78",
                component: "col",
                label: ["Does the plan address the following, at a minimum:"],
                simplifiedLabel: [
                  "Does the plan address the following, at a minimum:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "9b7508ce-4470-498d-8048-bce37a54dca7",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9a1f6ebe-ad08-4d21-8b6b-2b738679203e",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "44c9da8a-9c8e-4ffa-8b7d-e1757474aef2",
                component: "col",
                label: [
                  "Roles, responsibilities, and communication and contact strategies in the event of a compromise including notification of the payment brands, at a minimum?",
                ],
                simplifiedLabel: [
                  "Roles, responsibilities, and communication and contact strategies in the event of a compromise including notification of the payment brands, at a minimum?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "22ca61d9-9872-4ace-8936-4ea3775e9a74",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0fc089ab-49ea-4aee-8727-4adc6a6df71d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["e0d6a7fb-029a-40c1-b487-7da2c4c9e1db"],
                },
              },
              {
                _uid: "e0d6a7fb-029a-40c1-b487-7da2c4c9e1db",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "0a387972-e7af-4e00-9bed-98f56348779f_0fc089ab-49ea-4aee-8727-4adc6a6df71d",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "153a6a85-2a8c-44d1-befd-99651d7c6a52",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6f4a7d8d-b6a7-4036-aea1-fdcbb897c33a",
                component: "col",
                label: ["Specific incident response procedures?"],
                simplifiedLabel: ["Specific incident response procedures?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e39eeb2e-1605-4b32-80c1-d85ae3808dfb",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0d08290f-0b50-4dea-bd9a-28a83bf48b8f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["98297d8e-3fb9-457e-a1e2-d217d7d9a957"],
                },
              },
              {
                _uid: "98297d8e-3fb9-457e-a1e2-d217d7d9a957",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "136d51cd-15a1-4926-8498-11275a00215f_0d08290f-0b50-4dea-bd9a-28a83bf48b8f",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f375529c-8c2d-4793-b4f0-6a852d750b7c",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dac7eb16-138e-4ca3-b902-2e361686b828",
                component: "col",
                label: ["Business recovery and continuity procedures?"],
                simplifiedLabel: [
                  "Business recovery and continuity procedures?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "be189a01-6a19-4dad-9950-f600d225a8c9",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3f730b76-cec9-40a2-a4cc-31f17444453b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["d0b2e1cc-51e8-4018-9a79-d30323057f95"],
                },
              },
              {
                _uid: "d0b2e1cc-51e8-4018-9a79-d30323057f95",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "c3a32c54-31ff-4a04-aefa-c95f07bf288b_3f730b76-cec9-40a2-a4cc-31f17444453b",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c93f098a-7aae-4770-a3b5-9536ce6f26f3",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "06319a03-c2d6-493b-aa1e-7abbfa1fa666",
                component: "col",
                label: ["Data backup processes?"],
                simplifiedLabel: ["Data backup processes?"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ace9211f-a16b-484e-a4db-67dbd41a7276",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b2d582ad-665f-49dd-af5e-5305f05819d7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["fa4fd4da-7920-4820-bda9-3729df37d115"],
                },
              },
              {
                _uid: "fa4fd4da-7920-4820-bda9-3729df37d115",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4b1bfe58-c91c-4c6b-af53-26e23bbe7bd6_b2d582ad-665f-49dd-af5e-5305f05819d7",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be6085f3-e8ae-47bb-826d-a1a1a7fb8a3a",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "77b05268-9135-4bd8-a735-f5f55eeae170",
                component: "col",
                label: [
                  "Analysis of legal requirements for reporting compromises?",
                ],
                simplifiedLabel: [
                  "Analysis of legal requirements for reporting compromises?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7a5983c6-7d97-4166-877f-aed4cf6af560",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2ae3ab7b-2145-458d-9751-0c95d45f6876",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["f1a9eb10-2b7f-4de8-ab28-5a06d27b5c89"],
                },
              },
              {
                _uid: "f1a9eb10-2b7f-4de8-ab28-5a06d27b5c89",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "b5c9a79c-bba4-40bd-a072-2483b17b3e1d_2ae3ab7b-2145-458d-9751-0c95d45f6876",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "672e9a37-e545-4795-97bb-670fd05d4cbb",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fe1178cd-38c8-4295-b59a-2e8d995b535e",
                component: "col",
                label: [
                  "Coverage and responses of all critical system components?",
                ],
                simplifiedLabel: [
                  "Coverage and responses of all critical system components?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c812b8b3-7735-4dba-8d5b-7fad7faa46c6",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "00a4bc32-4fe6-4cdd-9c98-1e529a333a13",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["47c6f0ba-846f-4508-b3d3-eacac3247ab9"],
                },
              },
              {
                _uid: "47c6f0ba-846f-4508-b3d3-eacac3247ab9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "56aba794-681a-4be3-8b6b-2577f1b02fc0_00a4bc32-4fe6-4cdd-9c98-1e529a333a13",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eea096cd-916a-4f03-9aa7-d4a886f92bff",
                component: "col",
                label: "12.10.1 (b)",
                simplifiedLabel: "12.10.1 (b)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "795c8dc4-35eb-48d5-a7c6-091f28c03fb2",
                component: "col",
                label: [
                  "Reference or inclusion of incident response procedures from the payment brands?",
                ],
                simplifiedLabel: [
                  "Reference or inclusion of incident response procedures from the payment brands?",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a0be6b3b-1240-4172-bb3d-dacd564aaa55",
                component: "col",
                label: ["Review incident response plan procedures."],
                simplifiedLabel: ["Review incident response plan procedures."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9ca86b1b-d042-4cda-9d16-899237d44688",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["bbb56a7d-22ce-4aad-b6b6-46dd56fa51bf"],
                },
              },
              {
                _uid: "bbb56a7d-22ce-4aad-b6b6-46dd56fa51bf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a51d1228-83f7-413c-969a-62ac46ee7434_9ca86b1b-d042-4cda-9d16-899237d44688",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c4f61df2-282f-44e3-b82c-c7ee17f67f82",
                component: "col",
                label: [
                  "Appendix A1: Additional PCI DSS Requirements for Shared Hosting Provider",
                  "This appendix is not used for merchant assessments. ",
                  "Appendix A2: Additional PCI DSS Requirements for Entities using SSL/Early TLS for Card-Present POS POI Terminal Connections",
                ],
                simplifiedLabel: [
                  "Appendix A1: Additional PCI DSS Requirements for Shared Hosting Provider",
                  "This appendix is not used for merchant assessments. ",
                  "Appendix A2: Additional PCI DSS Requirements for Entities using SSL/Early TLS for Card-Present POS POI Terminal Connections",
                ],
                type: "",
                col: "12",
                colSpan: "4",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "53b507af-798c-4a5e-9b7d-e852437314d6",
                component: "col",
                label: "A2.1",
                simplifiedLabel: "A2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1b800c99-015a-4e1d-a708-76a4ad04abdd",
                component: "col",
                label: [
                  "For POS POI terminals (at the merchant or paymentacceptance location) using SSL and/or early TLS: Are the devices confirmed to not be susceptible to any known exploits for SSL/early TLS?",
                  "Note: This requirement is intended to apply to the entity with the POS POI terminal, such as a merchant. This requirement is not intended for service providers who serve as the termination or connection point to those POS POI terminals. Requirements A2.2 and A2.3 apply to POS POI service providers.",
                ],
                simplifiedLabel: [
                  "For POS POI terminals (at the merchant or paymentacceptance location) using SSL and/or early TLS: Are the devices confirmed to not be susceptible to any known exploits for SSL/early TLS?",
                  "Note: This requirement is intended to apply to the entity with the POS POI terminal, such as a merchant. This requirement is not intended for service providers who serve as the termination or connection point to those POS POI terminals. Requirements A2.2 and A2.3 apply to POS POI service providers.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "72bbf008-557d-4b09-a42b-0a09d9331103",
                component: "col",
                label: [
                  "Review documentation (for example, vendor documentation, system/network configuration details, etc.) that verifies POS POI devices are not susceptible to any known exploits for SSL/early TLS.",
                ],
                simplifiedLabel: [
                  "Review documentation (for example, vendor documentation, system/network configuration details, etc.) that verifies POS POI devices are not susceptible to any known exploits for SSL/early TLS.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "29216476-b397-4507-b780-71473cbfadcb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "Yes with CCW",
                    simplifiedLabel: "Yes with CCW",
                    value: "yesWithCcw",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                  {
                    component: "option",
                    label: "N/A",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                ],
                width: "30%",
                resetFields: {
                  value: ["yes", "yesWithCcw", "no"],
                  _uids: ["40405861-30c5-4ebb-8630-af79a7483f4a"],
                },
              },
              {
                _uid: "40405861-30c5-4ebb-8630-af79a7483f4a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3dda65c3-957a-40c5-974c-613ac107d866_29216476-b397-4507-b780-71473cbfadcb",
                },
                width: "30%",
                maxLength: "160",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 6 (11)

  // Page - 7 (12)

  // Page - 8 (13)

  // Page - 9 (14)

  // Page - 10 (15)

  // Page - 11 (16)

  // Page - 12 (17)

  // Page - 13 (18)

  // Page - 14 (19/20)

  // Page - 15 (21/22)

  // Page - 16 (23)

  // Page - 17 (24)

  // Page - 18 (25)

  // Page - 19 (26)

  // Page - 20 (27/28)

  // Page - 21 (29)

  // Page - 22 (30)

  // Page - 23 (31)

  // Page - 24 (32)

  // Page - 25 (33/34)

  // Page - 26 (35/36)

  // Page - 27 (37)

  // Page - 28 (38)

  // Page - 29 (39)

  // Page - 30 (40)

  // Page - 31 (41)

  // Page - 32 (42)

  // Page - 33 (43)

  // Page - 34 (44)

  // Page - 35 (45/46)

  // Page - 36 (47)

  // Page - 37 (48)

  // Page - 38 (49)

  // Page - 39 (50)

  // Page - 40 (51)
  {
    _uid: "ab48fbe0-8651-416d-b87b-04c22fe9a5cd",
    layout: "form",
    component: "page",
    label: "Appendix B: Compensating Controls Worksheet",
    simplifiedLabel: "Appendix B: Compensating Controls Worksheet",
    fields: [
      {
        _uid: "a27904ab-7205-49b2-a313-4f898c145307",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [
          "Use this worksheet to define compensating controls for any requirement where “YES with CCW” was checked.",
          "Note: Only companies that have undertaken a risk analysis and have legitimate technological or documented business constraints can consider the use of compensating controls to achieve compliance.",
          "Refer to Appendices B, C, and D of PCI DSS for information about compensating controls and guidance on how to complete this worksheet.",
        ],
        headers: ["", "Information Required", "Explanation"],
        fields: [
          {
            fields: [
              {
                _uid: "d29bdd72-1d96-42f8-9e04-58a1d927dd5e",
                component: "col",
                label: ["Constraints"],
                simplifiedLabel: ["Constraints"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "26f81d47-2e38-4153-8ac0-360e5ede8cb7",
                component: "col",
                label: [
                  "List constraints precluding compliance with the original requirement.",
                ],
                simplifiedLabel: [
                  "List constraints precluding compliance with the original requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "55b706df-b401-44fa-a818-810133f46c40",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bab65c5a-6680-41b1-a5f1-600838a147ec",
                component: "col",
                label: ["Objective"],
                simplifiedLabel: ["Objective"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "373c8f5d-753f-4df1-9f39-837ca27f6193",
                component: "col",
                label: [
                  "Define the objective of the original control; identify the objective met by the compensating control.",
                ],
                simplifiedLabel: [
                  "Define the objective of the original control; identify the objective met by the compensating control.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7b9c0db7-00d0-46bd-bc55-1739cbcaf346",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "311103cd-0032-4489-a048-68c76673090a",
                component: "col",
                label: ["Identified Risk"],
                simplifiedLabel: ["Identified Risk"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "6bfe0989-ab90-472c-8175-547ae17064fe",
                component: "col",
                label: [
                  "Identify any additional risk posed by the lack of the original control.",
                ],
                simplifiedLabel: [
                  "Identify any additional risk posed by the lack of the original control.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "0823afa4-771e-4ffc-ac1c-9a6781a27e0c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "823bb015-c116-4863-b2d4-dcfeafb2dde9",
                component: "col",
                label: ["Definition of Compensating Controls"],
                simplifiedLabel: ["Definition of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "488b3441-95bc-4e15-8de4-7281af094052",
                component: "col",
                label: [
                  "Define the compensating controls and explain how they address the objectives of the original control and the increased risk, if any.",
                ],
                simplifiedLabel: [
                  "Define the compensating controls and explain how they address the objectives of the original control and the increased risk, if any.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "2a398c2c-2dae-4895-92e5-6d1da91d1036",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "135",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "302a5a57-aa21-43ab-ba20-e85a0133096d",
                component: "col",
                label: ["Validation of Compensating Controls"],
                simplifiedLabel: ["Validation of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "5b5aa382-2f74-4e3d-a1a5-b20319089b4d",
                component: "col",
                label: [
                  "Define how the compensating controls were validated and tested.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "657dc97d-d447-4e6f-a050-86cca39d5615",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "95",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8f491c23-7f2c-4932-addb-7233eb92209d",
                component: "col",
                label: ["Maintenance"],
                simplifiedLabel: ["Maintenance"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "1f78d80a-16c9-4e04-9341-ae3f646875a5",
                component: "col",
                label: [
                  "Define process and controls in place to maintain compensating controls.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "35e8b6ed-6b93-4adb-ac73-558abb1d2719",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "60",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 41 (52)
  /* {
    _uid: "b416989d-7f17-4ca8-afe2-b8573be5f272",
    layout: "form",
    component: "page",
    label: "Appendix C: Explanation of Non-Applicability",
    fields: [
      {
        _uid: "734c5660-767c-404e-bc91-1ae2f71bb5c2",
        component: "table",
        label: "",
        type: "table",
        caption:
          "If the “N/A” (Not Applicable) column was checked in the questionnaire, use this worksheet to explain why the related requirement is not applicable to your organization.",
        headers: ["Requirement", "Reason Requirement is Not Applicable"],
        fields: [
          {
            fields: [
              {
                _uid: "a79fb7da-649d-499f-9ef3-dcff91623eb5",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "b3709143-0451-48fb-b96e-ecc8fd8931c9",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1713c7c9-91e0-421b-906f-4b332656bf64",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "2c768e1c-069c-48f6-a529-ddeb643b8634",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7f3c9a60-5f90-4263-967c-769cf6867162",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "d7446a04-894f-413f-bb6b-d80364a4b311",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "36e71e5b-3237-4105-9d77-9e3c7d3df47e",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "afc420f5-dc41-4679-a468-b719fa312d14",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba1f9a7f-72de-4f86-90ac-d690528b55ff",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "3f472771-2586-40c6-a224-8c0a9ac9dd89",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "80e4cf13-4676-49f3-9956-f87554fbedde",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "f19aa5d5-b76a-40fc-8681-9ade23c2fafd",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "efc12f6d-d537-4a23-a50a-0f5133e36bc3",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "9bf9c320-4d79-461d-ab7f-65415bc7ef2b",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a63c0093-a3bf-4344-a935-e779b6178a2c",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "8837686e-16d9-46f1-a999-beb82c22dc0a",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f92f0de9-afcf-43c8-928b-9b1e17786d3f",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "bffd7005-78d9-4d83-9b97-e293162694ed",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e69119d7-94b7-4930-90d8-3b7187592c0b",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "3f537d99-4dce-4007-af79-7eeba606c63c",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "00d93e45-9aa3-4fd2-acc9-9ff784addd08",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "1500ab0c-5068-4e51-a59b-c32e0f117e71",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1581d12f-450f-44c9-b90e-631bc977c56a",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "3299407c-e33d-4c21-99c7-bd03fa15ab0b",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c9e6f0af-5de4-4b9c-a508-f6469051de0e",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "04424696-f336-41be-870b-5eb3fd8f69ee",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "def6bebf-db0b-4d11-90e6-b450c5bbeea3",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "c50db3b5-106e-45e9-b3f2-3843a78f3178",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6a958702-8d6b-4022-94b4-9ab330f9294a",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
              {
                _uid: "5161c4cf-9728-4d7f-8cab-ce1e2377cd67",
                component: "col",
                label: "",
                type: "text",
                col: "12",
                width: "80%",
                maxLength: "92",
              },
            ],
          },
        ],
      },
    ],
  }, */

  // Page - 42 (53)
  {
    _uid: "c4e8c4d7-334b-4b60-b1d0-a01c95bb641e",
    layout: "form",
    component: "page",
    label: "Validation and Attestation Details",
    simplifiedLabel: "Validation and Attestation Details",
    fields: [
      {
        _uid: "8c9254ba-438a-4608-a0c8-c3afc1e24aab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Part 3. PCI DSS Validation",
        fields: [
          {
            fields: [
              {
                _uid: "b50fda80-d07a-441a-abdf-ef34a90862c8",
                component: "col",
                label: [
                  "This AOC is based on results noted in SAQ B (Section 2), dated (SAQ completion date).",
                  "Based on the results documented in the SAQ B noted above, the signatories identified in Parts 3b-3d, as applicable, assert(s) the following compliance status for the entity identified in Part 2 of this document: (check one):",
                ],
                simplifiedLabel: [
                  "This AOC is based on results noted in SAQ B (Section 2), dated (SAQ completion date).",
                  "Based on the results documented in the SAQ B noted above, the signatories identified in Parts 3b-3d, as applicable, assert(s) the following compliance status for the entity identified in Part 2 of this document: (check one):",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ace2392f-bdd0-41ad-9f1c-ce5fad94846f",
                component: "col",
                label:
                  "Compliant: All sections of the PCI DSS SAQ are complete, all questions answered affirmatively, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated full compliance with the PCI DSS.",
                simplifiedLabel:
                  "Compliant: All sections of the PCI DSS SAQ are complete, all questions answered affirmatively, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated full compliance with the PCI DSS.",
                type: "checkbox",
                value: "yes",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "92604c63-4240-4c0c-b085-1c5b46b9798d",
                component: "col",
                label: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or not all questions are answered affirmatively, resulting in an overall NON-COMPLIANT rating, thereby (Merchant Company Name) has not demonstrated full compliance with the PCI DSS.",
                  "Target Date for Compliance:",
                  "An entity submitting this form with a status of Non-Compliant may be required to complete the Action Plan in Part 4 of this document. Check with your acquirer or the payment brand(s) before completing Part 4.",
                ],
                simplifiedLabel: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or not all questions are answered affirmatively, resulting in an overall NON-COMPLIANT rating, thereby (Merchant Company Name) has not demonstrated full compliance with the PCI DSS.",
                  "Target Date for Compliance:",
                  "An entity submitting this form with a status of Non-Compliant may be required to complete the Action Plan in Part 4 of this document. Check with your acquirer or the payment brand(s) before completing Part 4.",
                ],
                type: "checkbox",
                value: "yes",
                width: "100%",
                col: "12",
                hasLi: "yes",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                component: "col",
                label:
                  "Compliant but with Legal exception: One or more requirements are marked “No” due to a legal restriction that prevents the requirement from being met. This option requires additional review from acquirer or payment brand.",
                simplifiedLabel:
                  "Compliant but with Legal exception: One or more requirements are marked “No” due to a legal restriction that prevents the requirement from being met. This option requires additional review from acquirer or payment brand.",
                type: "checkbox",
                value: "yes",
                width: "100%",
                col: "12",
                colSpan: "2",
                resetFields: {
                  value: "",
                  _uids: [
                    "979cba44-1bbc-464c-8ba1-e4df8ffdaf59",
                    "4258272f-8558-472f-a94e-952cca1cfba5",
                    "0996151b-4b9c-4241-8c90-d0cd38dcf4ea",
                    "e2f2873c-891a-4d0e-9e49-16a5c70e03df",
                  ],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "45668b3a-aca1-41c8-babc-0d49bc27091a",
                component: "",
                label: "Please complete the following:",
                simplifiedLabel: "Please complete the following:",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "4718a2b0-4314-46a5-94f6-327e1e5af226_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1f09fb99-9e39-477a-8612-7f7a1e901daa",
                component: "text",
                label: "Affected Requirement",
                simplifiedLabel: "Affected Requirement",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "4b2807f4-fd2f-45cb-8cde-ba14c1246346_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                width: "50%",
              },
              {
                _uid: "45af25b1-3150-4a59-82b1-73d3b5779163",
                component: "text",
                label:
                  "Details of how legal constraint prevents requirement being met",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "1b927706-c596-4ab3-8126-be94bc4a0845_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "979cba44-1bbc-464c-8ba1-e4df8ffdaf59",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "a67c3f34-a55d-4a63-ba66-6263e57a8aef_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "4258272f-8558-472f-a94e-952cca1cfba5",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "ecfc9a90-2e4a-47b1-a309-4efba73913f0_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0996151b-4b9c-4241-8c90-d0cd38dcf4ea",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "5bae3488-11ff-47a5-b605-039e01cb14cd_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "e2f2873c-891a-4d0e-9e49-16a5c70e03df",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "faf0a3fc-1917-4dee-a420-297691c64f6f_c0fbd4c7-097c-4bf7-972e-81e0ee4c2679",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
        ],
      },
      {
        _uid: "1ae17b8e-7c91-427a-92cc-a0e999f87115",
        component: "table",
        label: "Merchant Attestation",
        simplifiedLabel: "Merchant Attestation",
        type: "table",
        caption:
          "Acknowledgement of Status.[ Signatory(s) confirms: (Check all that apply) ]",
        fields: [
          {
            fields: [
              {
                _uid: "8a2ec6ba-f00a-4c27-b3e2-a1a6120d85ac",
                component: "col",
                label: [
                  "PCI DSS Self-Assessment Questionnaire A, Version (version of SAQ), was completed according to the instructions therein.",
                ],
                simplifiedLabel: [
                  "PCI DSS Self-Assessment Questionnaire A, Version (version of SAQ), was completed according to the instructions therein.",
                ],
                hasLi: "no",
                type: "checkbox",
                value: "yes",
                col: "12",
                width: "80%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0568c361-f394-41df-b7a8-a6a89d06b366",
                component: "col",
                label: [
                  "All information within the above-referenced SAQ and in this attestation fairly represents the results of my assessment in all material respects.",
                ],
                simplifiedLabel: [
                  "All information within the above-referenced SAQ and in this attestation fairly represents the results of my assessment in all material respects.",
                ],
                hasLi: "no",
                type: "checkbox",
                value: "yes",
                col: "12",
                width: "80%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "52c9b983-2855-45aa-9343-1a33f1641704",
                component: "col",
                label: [
                  "I have confirmed with my payment application vendor that my payment system does not store sensitive authentication data after authorization.",
                ],
                simplifiedLabel: [
                  "I have confirmed with my payment application vendor that my payment system does not store sensitive authentication data after authorization.",
                ],
                hasLi: "no",
                type: "checkbox",
                value: "yes",
                col: "12",
                width: "80%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6fa64959-4112-4b20-a7be-a15cf123b441",
                component: "col",
                label: [
                  "I have read the PCI DSS and I recognize that I must maintain PCI DSScompliance, as applicable to my environment, at all times.",
                ],
                simplifiedLabel: [
                  "I have read the PCI DSS and I recognize that I must maintain PCI DSScompliance, as applicable to my environment, at all times.",
                ],
                hasLi: "no",
                type: "checkbox",
                value: "yes",
                col: "12",
                width: "80%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "12a95226-96c1-44bb-8262-b82ae52705c9",
                component: "col",
                label: [
                  "If my environment changes, I recognize I must reassess my environment and implement any additional PCI DSS requirements that apply.",
                ],
                simplifiedLabel: [
                  "If my environment changes, I recognize I must reassess my environment and implement any additional PCI DSS requirements that apply.",
                ],
                hasLi: "no",
                type: "checkbox",
                value: "yes",
                col: "12",
                width: "80%",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 44 (55)
  {
    _uid: "283e95e3-83f2-4984-bfea-8af68c228eda",
    layout: "form",
    component: "page",
    label: "Part 4. Action Plan for Non-Compliant Requirements",
    simplifiedLabel: "Part 4. Action Plan for Non-Compliant Requirements",
    fields: [
      {
        _uid: "7d5c6b7b-6d9d-41c2-a79d-a986e05e891d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        headers: [
          "PCI DSS Requirement*",
          "Description of Requirement",
          "Compliant to PCI DSS Requirements (Select One)",
          "Remediation Date and Actions (If “NO” selected for any Requirement)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "91bab759-54d3-4db6-906e-1eba61a94547",
                component: "col",
                label: ["1"],
                simplifiedLabel: ["1"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "796c5f92-e908-4f97-8a41-856a17f7a64d",
                component: "col",
                label: [
                  "Install and maintain a firewall configuration to protect cardholder data.",
                ],
                simplifiedLabel: [
                  "Install and maintain a firewall configuration to protect cardholder data.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "721127e4-6cac-462c-8e5f-07402544f862",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["a6b9fd19-d951-400c-a55e-c36409f42516"],
                },
              },
              {
                _uid: "a6b9fd19-d951-400c-a55e-c36409f42516",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d6728e98-a78d-4288-9d8f-11a44279c5d3",
                component: "col",
                label: ["2"],
                simplifiedLabel: ["2"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "f6d3e493-dcd3-4490-9c44-e601d02ceaad",
                component: "col",
                label: [
                  "Do not use vendor-supplied defaults for system passwords and other security parameters.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d67afde5-dd38-4c1e-8b9f-4e731f4dd923",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["b854af29-eaad-446e-9e03-39e1b983e56e"],
                },
              },
              {
                _uid: "b854af29-eaad-446e-9e03-39e1b983e56e",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "930908d8-75a7-4a82-aae8-4a5c11440a7a",
                component: "col",
                label: ["3"],
                simplifiedLabel: ["3"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "f7a11e90-337f-478c-a62e-f6a138b1893f",
                component: "col",
                label: ["Protect stored cardholder data."],
                simplifiedLabel: ["Protect stored cardholder data."],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "a7816941-6b28-464f-bf9b-54a088865d09",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["cc17833e-deb0-47ac-be2a-6e645735e9cd"],
                },
              },
              {
                _uid: "cc17833e-deb0-47ac-be2a-6e645735e9cd",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "940265b9-9c26-4067-826f-ad3335043c56",
                component: "col",
                label: ["4"],
                simplifiedLabel: ["4"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "4c97024a-4b0a-4a76-9769-b75c44280f1b",
                component: "col",
                label: [
                  "Encrypt transmission of cardholder data across open, public networks.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7f9f57d5-e264-46b2-8c7c-9a37080c40aa",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["a7ba6845-3b72-4ea2-83bd-c9305ea92cbc"],
                },
              },
              {
                _uid: "a7ba6845-3b72-4ea2-83bd-c9305ea92cbc",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e10816d9-7490-4d48-bc2e-dd27078047c1",
                component: "col",
                label: ["5"],
                simplifiedLabel: ["5"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "eb4e4e6f-b93d-4a30-9b49-26f535a2431b",
                component: "col",
                label: [
                  "Protect all systems against malware and regularly update anti-virus software or programs.",
                ],
                simplifiedLabel: [
                  "Protect all systems against malware and regularly update anti-virus software or programs.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "56d95210-677a-4337-84f2-0c1ea70ba46e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["ea79205a-69d9-4970-a761-70a6058cc2c2"],
                },
              },
              {
                _uid: "ea79205a-69d9-4970-a761-70a6058cc2c2",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1480163-8d94-45f1-8180-8d0baebfd1e3",
                component: "col",
                label: ["6"],
                simplifiedLabel: ["6"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "8cbba1fe-3ee7-41cd-9715-7892635c0b51",
                component: "col",
                label: [
                  "Develop and maintain secure systems and applications.",
                ],
                simplifiedLabel: [
                  "Develop and maintain secure systems and applications.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e38cd80d-4dee-47b6-b95f-32947058a7af",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["c627407b-5bfc-43e7-b4e0-4b51086946a4"],
                },
              },
              {
                _uid: "c627407b-5bfc-43e7-b4e0-4b51086946a4",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "67e35634-283a-47a1-9404-9268ac546b56",
                component: "col",
                label: ["7"],
                simplifiedLabel: ["7"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "7974cdcd-8920-4512-9b60-9a1d5ddb77a5",
                component: "col",
                label: [
                  "Restrict access to cardholder data by business need to know.",
                ],
                simplifiedLabel: [
                  "Restrict access to cardholder data by business need to know.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "874bdff9-cd71-4549-94ce-492ea3cf6f1e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["c51240ee-4404-412a-bdcc-0b234449c6ac"],
                },
              },
              {
                _uid: "c51240ee-4404-412a-bdcc-0b234449c6ac",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "35003185-2416-45bd-aa67-e9c8dee18284",
                component: "col",
                label: ["8"],
                simplifiedLabel: ["8"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "16830cc5-b61d-4d0a-a0fd-19f606ecfe03",
                component: "col",
                label: [
                  "Identify and authenticate access to system components.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "6e11e7f8-94fa-45f1-a761-7abe9a50d8bb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["7d27df35-0b7d-45e5-94c8-4f37c41d87c7"],
                },
              },
              {
                _uid: "7d27df35-0b7d-45e5-94c8-4f37c41d87c7",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ac8d3546-9bc0-4202-a83f-d98365e2e237",
                component: "col",
                label: ["9"],
                simplifiedLabel: ["9"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "393f5f73-23f8-4736-94c5-778bd29ecc22",
                component: "col",
                label: ["Restrict physical access to cardholder data."],
                simplifiedLabel: [
                  "Restrict physical access to cardholder data.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d8093bee-4369-4c2d-9c3d-886ec7197feb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["13b22233-fc53-4161-9282-65f58296acde"],
                },
              },
              {
                _uid: "13b22233-fc53-4161-9282-65f58296acde",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0553a44c-6bed-412f-969a-b4526f19ef44",
                component: "col",
                label: ["10"],
                simplifiedLabel: ["10"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "6f2fec5e-e5cf-472c-a079-bd0922d62d1a",
                component: "col",
                label: [
                  "Track and monitor all access to network resources and cardholder data.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "0dbb3342-77d4-4111-a99f-f006e0c76d3c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["e1ed73fa-9dd3-4c86-81ec-d8cb3328bb05"],
                },
              },
              {
                _uid: "e1ed73fa-9dd3-4c86-81ec-d8cb3328bb05",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5a060a27-46fa-46c2-a511-ce8a2ea8884a",
                component: "col",
                label: ["11"],
                simplifiedLabel: ["11"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "6e6f1a6b-16e1-4635-b6e5-2493cf85b716",
                component: "col",
                label: ["Regularly test security systems and processes."],
                simplifiedLabel: [
                  "Regularly test security systems and processes.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "2e9edee7-446b-4ce7-8cbd-146d7f287067",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["7077fcb4-054a-48a1-8182-11fb3770e7f5"],
                },
              },
              {
                _uid: "7077fcb4-054a-48a1-8182-11fb3770e7f5",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1a8b1eba-25a2-41f2-ba7d-c3d588a20ce2",
                component: "col",
                label: ["12"],
                simplifiedLabel: ["12"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "d1047b73-a01d-4faa-8e4c-e42b04664f64",
                component: "col",
                label: [
                  "Maintain a policy that addresses information security for all personnel.",
                ],
                simplifiedLabel: [
                  "Maintain a policy that addresses information security for all personnel.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "06d18aab-9697-48a0-82fa-9abf9b915d8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["5b61a867-dc82-4546-96f2-7ff6d2f3a261"],
                },
              },
              {
                _uid: "5b61a867-dc82-4546-96f2-7ff6d2f3a261",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1118f0c9-9da6-4c9c-98ee-2cdf164938de",
                component: "col",
                label: ["Appendix A2"],
                simplifiedLabel: ["Appendix A2"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "2%",
              },
              {
                _uid: "5c646048-def7-40d7-9970-84511988ddcb",
                component: "col",
                label: [
                  "Additional PCI DSS Requirements for Entities using SSL/Early TLS for CardPresent POS POI Terminal Connections.",
                ],
                simplifiedLabel: [
                  "Additional PCI DSS Requirements for Entities using SSL/Early TLS for CardPresent POS POI Terminal Connections.",
                ],
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "77220ab0-b7a7-4a49-adcf-9c61c586b9fe",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "20%",
                resetFields: {
                  value: "yes",
                  _uids: ["fe738b60-94e5-424c-a49d-8b9f4eacb626"],
                },
              },
              {
                _uid: "fe738b60-94e5-424c-a49d-8b9f4eacb626",
                component: "text",
                label: " ",
                simplifiedLabel: " ",
                type: "textarea",
                textareaRows: 4,
                col: "12",
                width: "48%",
                maxLength: "60",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page - 43 (54)
  {
    _uid: "72fdb06e-8dca-471d-8901-fe9f34292b78",
    layout: "form",
    component: "page",
    label: "PCI DSS Validation (continued)",
    simplifiedLabel: "PCI DSS Validation (continued)",
    fields: [
      {
        _uid: "d02d603d-98a4-4a8a-9301-895e9768ee94",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "Part 3b. Merchant Attestation",
        fields: [
          {
            fields: [
              {
                _uid: "5ea852f2-8694-46cc-9cfd-0b7d63a7eb8c",
                component: "checkbox",
                type: "checkbox",
                label:
                  "No evidence of full track data1 , CAV2, CVC2, CID, or CVV2 data2, or PIN data3 storage after transaction authorization was found on ANY system reviewed during this assessment.",
                simplifiedLabel:
                  "No evidence of full track data1 , CAV2, CVC2, CID, or CVV2 data2, or PIN data3 storage after transaction authorization was found on ANY system reviewed during this assessment.",
                value: "yes",
                colSpan: "2",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "faa7687e-b976-487b-97fa-b1999c395551",
                component: "checkbox",
                type: "checkbox",
                label:
                  "ASV scans are being completed by the PCI SSC Approved Scanning Vendor (ASV Name)",
                simplifiedLabel:
                  "ASV scans are being completed by the PCI SSC Approved Scanning Vendor (ASV Name)",
                value: "yes",
                colSpan: "2",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a4569e8-0c0b-42de-bc6b-92108eaf3ba6",
                component: "col",
                label: ["Signature of Merchant Executive Officer"],
                simplifiedLabel: ["Signature of Merchant Executive Officer"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "b1f07993-2ffa-42bd-84c9-1a01d82c7db2",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "45",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e1501362-0931-425c-ab7e-e7efa7158d4d",
                component: "col",
                label: ["Date"],
                simplifiedLabel: ["Date"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "4b698bea-62d0-4f17-9e60-c91d08205077",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "49cd9d25-d975-4c48-a8b6-b2fa444e7e51",
                component: "col",
                label: ["Merchant Executive Officer Name:"],
                simplifiedLabel: ["Merchant Executive Officer Name:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "6907d04c-0e29-47c8-8a95-04d37c8ca7c8",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a98c2eb3-d233-47e2-85b3-a4de0fbd9f07",
                component: "col",
                label: ["Title"],
                simplifiedLabel: ["Title"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "2080dc2a-166a-4198-9f54-6b4b7589c976",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
        ],
      },
      {
        _uid: "d5d40395-bd77-48ff-ab14-0aa0f0e24667",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption:
          "Part 3c. Qualified Security Assessor (QSA) Acknowledgement (if applicable)",
        fields: [
          {
            fields: [
              {
                _uid: "bc111a2c-d2ec-4682-b1af-fef2315f04d0",
                component: "col",
                label: [
                  "If a QSA was involved or assisted with this assessment, describe the role performed:",
                ],
                simplifiedLabel: [
                  "If a QSA was involved or assisted with this assessment, describe the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "fc2defbf-b1c0-427d-9a73-0bda34a65032",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "textarea",
                textareaRows: 6,
                col: "12",
                width: "50%",
                maxLength: "180",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5248e2cd-b91b-4a16-bd18-ad9b97369ed3",
                component: "col",
                label: ["Signature of Duly Authorized Officer of QSA Company"],
                simplifiedLabel: [
                  "Signature of Duly Authorized Officer of QSA Company",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "1281b9bf-dfc0-4ad9-b10b-ee6f686cdead",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "45",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d65264b7-3d7f-485d-b045-972bdad11124",
                component: "col",
                label: ["Date:"],
                simplifiedLabel: ["Date:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
              {
                _uid: "d08a67d2-06d4-4683-b1de-5dda28cc2a48",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ee93d3ba-42af-40cb-b31a-f76bec0585cb",
                component: "col",
                label: ["Duly Authorized Officer Name:"],
                simplifiedLabel: ["Duly Authorized Officer Name:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "e0f4962e-d52f-4fc4-bd69-43b5bbc31249",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e29a7d2-b84b-4fa3-9464-04ccbd93a840",
                component: "col",
                label: ["QSA Company:"],
                simplifiedLabel: ["QSA Company:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "3a0dc678-e869-4722-97df-50b64bb3c052",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "50%",
                maxLength: "28",
              },
            ],
          },
        ],
      },
      {
        _uid: "7218f0b6-0c25-4dc9-9413-bd39cb0ed710",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption:
          "Part 3d. Internal Security Assessor (ISA) Involvement (if applicable)",
        fields: [
          {
            fields: [
              {
                _uid: "01f5a42b-12d4-4e8f-943f-f45dfab3f7c7",
                component: "col",
                label: [
                  "If an ISA(s) was involved or assisted with this assessment, identify the ISA personnel and describe the role performed:",
                ],
                simplifiedLabel: [
                  "If an ISA(s) was involved or assisted with this assessment, identify the ISA personnel and describe the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "cf8f97b9-1d67-426e-9dfb-e444279af43c",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "textarea",
                textareaRows: 6,
                col: "12",
                width: "50%",
                maxLength: "320",
              },
            ],
          },
        ],
      },
    ],
  },
];
